<template>
  <div
    class="listagem-base"
    :class="{
      'crud-dialog-active': dialogInsert || dialogEdit,
      'listagem-base--incorporada': ocultarCabecalhoListagem,
    }"
    :aria-busy="loading && !(dialogInsert || dialogEdit)"
  >
    <div v-if="consultaPaginada" class="crud-consulta-paginada">
      <slot name="consulta"></slot>
      <div
        v-if="consultaPaginada.totalPages > 1"
        class="crud-consulta-paginada__footer"
      >
        <span>
          {{
            $t("Oportunidades_Paginacao", {
              total: consultaPaginada.totalItems,
              pagina: consultaPaginada.page,
              paginas: consultaPaginada.totalPages,
            })
          }}
        </span>
        <v-pagination
          :value="consultaPaginada.page"
          :length="consultaPaginada.totalPages"
          :total-visible="consultaPaginada.totalVisible"
          :disabled="consultaPaginada.loading"
          prev-icon="fa fa-angle-left"
          next-icon="fa fa-angle-right"
          class="pagination"
          color="#516a78ee"
          circle
          @input="$emit('paginaConsulta', $event)"
        />
      </div>
    </div>
    <ErrorAlert v-if="!consultaPaginada" :errors="errors"></ErrorAlert>
    <CrudKeyboardShortcutsDialog
      v-if="!consultaPaginada"
      v-model="keyboardShortcutsDialog"
      :shortcuts="listKeyboardShortcuts"
      footer-key="O_Tab_mantem_a_ordem_natural_e_os_atalhos_nao_interferem_na_digitacao"
    />
    <CrudSearchFieldDialog
      v-if="!consultaPaginada"
      v-model="searchFieldDialog"
      :fields="searchFieldOptions"
      @select="focusSelectedListSearchField"
    />

    <div
      v-if="!consultaPaginada && loading"
      class="loading-overlay"
      role="status"
    >
      <div class="loading-card">
        <span class="spinner"></span>
        <span class="label">{{ $t("Carregando") }}</span>
      </div>
    </div>

    <v-container
      v-if="!consultaPaginada"
      fluid
      class="px-2 px-sm-4 px-md-6 py-0 crud-listagem-container"
    >
      <!-- Totalizadores -->
      <v-row
        class="mt-4"
        v-if="
          quantidadeTitulosQuitados +
            quantidadeTitulosPendentes +
            quantidadeTitulosVencidos >
          0
        "
      >
        <div class="card-saldo ma-1" v-if="valorTitulosQuitados !== null">
          <p class="card-saldo__text" style="margin-bottom: 0">Quitados:</p>
          <p class="card-saldo__value" style="margin-bottom: 0">
            {{ valorTitulosQuitados | formatoMonetario }}
          </p>
        </div>
        <div class="card-saldo ma-1" v-if="quantidadeTitulosPendentes !== null">
          <p class="card-saldo__text" style="margin-bottom: 0">Pendentes:</p>
          <p class="card-saldo__value" style="margin-bottom: 0">
            {{ valorTitulosPendentes | formatoMonetario }}
          </p>
        </div>
        <div class="card-saldo ma-1" v-if="valorTitulosVencidos !== null">
          <p class="card-saldo__text" style="margin-bottom: 0">Atrasados:</p>
          <p class="card-saldo__value" style="margin-bottom: 0">
            {{ valorTitulosVencidos | formatoMonetario }}
          </p>
        </div>
        <div
          class="card-saldo ma-1"
          v-if="
            valorTitulosVencidos !== null &&
            valorTitulosQuitados !== null &&
            quantidadeTitulosPendentes !== null
          "
        >
          <p class="card-saldo__text" style="margin-bottom: 0">Total:</p>
          <p class="card-saldo__value" style="margin-bottom: 0">
            {{
              (valorTitulosVencidos +
                valorTitulosPendentes +
                valorTitulosQuitados)
                | formatoMonetario
            }}
          </p>
        </div>
      </v-row>
      <!-- modais -->
      <div id="dialog">
        <v-dialog v-model="deletado" persistent max-width="350">
          <v-card>
            <v-card-title class="headline">
              {{ $t("deletado_sucesso") }}
            </v-card-title>
            <v-card-text v-if="deletadoQuantidade > 1" class="pt-0">
              <span
                v-if="deletadoQuantidade - deletadoEmCascata > 1"
                class="text-caption d-block"
              >
                {{ deletadoQuantidade - deletadoEmCascata }}
                {{ $t("Itens_selecionados") }}
              </span>
              <span v-if="deletadoEmCascata > 0" class="text-caption d-block">
                {{ deletadoEmCascata }}
                {{ $tc("Registros_vinculados_excluidos", deletadoEmCascata) }}
              </span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="
                  ma-1
                  font-weight-bold
                  text-none
                  btn-primary
                  bg-gradient-primary
                  py-3
                  px-6
                  ms-3
                "
                height="39"
                text
                @click="fecharModalDeletado"
                :loading="loading"
              >
                {{ $t("Confirmar") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <!-- Modal confirmar delete -->
      <v-dialog
        v-model="confirmar"
        persistent
        :max-width="Object.keys(exclusaoOpcoes).length ? 520 : 350"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{ $t("Tem_certeza?") }}</v-card-title>

          <v-spacer></v-spacer>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12" v-if="delecaoEmLote">
                <span class="text-caption">
                  {{ selectedRows.length }} {{ $t("Itens_selecionados") }}
                </span>
              </v-col>
              <v-col
                cols="12"
                md="12"
                v-if="confirmar && $scopedSlots.exclusaoDetalhes"
              >
                <slot
                  name="exclusaoDetalhes"
                  :item="objetoAtual"
                  :itens="selectedRows"
                  :emLote="delecaoEmLote"
                  :definirOpcoes="definirExclusaoOpcoes"
                ></slot>
              </v-col>
              <v-col cols="12" md="12" v-if="exclusaoSolicitarMotivo">
                <v-textarea
                  :label="$t('Motivo')"
                  v-model.number="exclusaoMotivo"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                  rows="5"
                  auto-grow
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="cancelarConfirmacaoDelete"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              @click="deleteRecurso"
              :disabled="
                exclusaoOpcoes.bloqueada === true ||
                (exclusaoSolicitarMotivo &&
                  (exclusaoMotivo === undefined || exclusaoMotivo.length < 1))
              "
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="recebimentoDetalhado"
        transition="dialog-bottom-transition"
        max-width="900"
        persistent
      >
        <v-card>
          <v-card-title class="headline">
            {{ $t("Devolucao") }} <br />
            <!-- <v-btn class="ma-2" color="info" text-color="white">
            {{ this.objetoAtual.descricao }}
          </v-btn> -->
            <v-divider></v-divider>
          </v-card-title>
          <v-card-text>
            <v-col cols="12" md="12">
              <template v-slot:heading>
                <div class="display-2 font-weight-light">
                  {{ $t("Listagem_de_produtos") }}
                </div>
              </template>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('Procurar')"
                single-line
                hide-details
              ></v-text-field>

              <v-data-table
                :headers="headersItemPedido"
                :items="objetoAtual.items"
                :search="search"
                @click:row="handleClickPedido"
              >
              </v-data-table>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="recebimentoDetalhado = false"
            >
              {{ $t("Cancelar") }}
            </v-btn>
            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              @click="entregaParcial(objetoAtual)"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="formChangeProdutoPedido" persistent max-width="350">
        <v-card>
          <v-form @submit.prevent="changeProdutoPedido">
            <v-card-title class="headline">
              {{ $t("Adicionar_quantidade") }} <br />
              <v-btn
                :loading="loading"
                class="ma-2"
                color="green"
                text-color="white"
              >
                {{ this.produto.descricao }}
              </v-btn>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    type="number"
                    :label="$t('Quantidade')"
                    v-model.number="quantidade"
                    min="0"
                    :rules="[ruleQuantidadePendente]"
                    class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                    dense
                    flat
                    filled
                    solo
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                :loading="loading"
                height="39"
                class="
                  font-weight-bold
                  text-capitalize
                  btn-ls btn-secondary
                  bg-gradient-light
                  py-3
                  px-6
                "
                @click="limpaFormProduto"
              >
                {{ $t("Cancelar") }}
              </v-btn>

              <v-btn
                :loading="loading"
                class="
                  ma-1
                  font-weight-bold
                  text-none
                  btn-primary
                  bg-gradient-primary
                  py-3
                  px-6
                  ms-3
                "
                height="39"
                @click.prevent="changeProdutoPedido(objetoAtual)"
                :disabled="confirmarQuantidadeDesabilitarBotao"
              >
                {{ $t("Adicionar") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <!-- Modal replicate -->
      <v-dialog
        v-model="confirmarReplicar"
        persistent
        max-width="350"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_acao?")
          }}</v-card-title>

          <v-col
            cols="12"
            v-if="
              nomeSingular !== 'PedidoConsumivel' &&
              nomeSingular !== 'PedidoUniforme' &&
              nomeSingular !== 'PedidoMaterial'
            "
          >
            <v-text-field
              v-model="quantidade"
              :label="$t('Quantidade')"
              name="quantidade"
              type="number"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="10"
            md="2"
            v-if="
              nomeSingular !== 'PedidoConsumivel' &&
              nomeSingular !== 'PedidoUniforme' &&
              nomeSingular !== 'PedidoMaterial'
            "
          >
            <v-checkbox v-model="previsao">
              <template v-slot:label>
                {{ $t("previsao") }}
              </template>
            </v-checkbox>
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="confirmarReplicar = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="replicateRecurso"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="confirmarDisponibilizacaoDocumento"
        persistent
        max-width="750"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_disponibilizacao_documentos?")
          }}</v-card-title>
          <v-card-subtitle>
            <v-ln>
              <v-col cols="12" md="6">
                <v-text-field
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                  v-model="matricula"
                  :label="$t('Matricula')"
                  name="matricula"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="12">
                <v-text-field
                  v-model="nome"
                  :label="$t('Nome')"
                  name="nome"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="12">
                <v-autocomplete
                  :label="clientesLabel"
                  :disabled="loading"
                  chips
                  multiple
                  deletable-chips
                  v-model="itemsCliente"
                  return-object
                  :items="clientes"
                  :item-text="
                    (item) => item.fantasia + ' - ' + item.razaoSocial
                  "
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="12">
                <v-autocomplete
                  :label="postoTrabalhoLabel"
                  :disabled="loading"
                  chips
                  dens
                  multiple
                  deletable-chips
                  v-model="itemsPostoTrabalho"
                  return-object
                  :items="postoTrabalhos"
                  :item-text="(item) => item.descricao"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="12">
                <v-autocomplete
                  :label="$t('Cargo')"
                  :disabled="loading"
                  chips
                  dens
                  multiple
                  deletable-chips
                  v-model="itemsCargo"
                  return-object
                  :items="cargos"
                  :item-text="(item) => item.descricao"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-autocomplete>
              </v-col>
            </v-ln>
            <v-ln>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="variavelFixa01"
                  :label="$t('variavelFixa01')"
                  name="variavelFixa01"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="variavelFixa02"
                  :label="$t('variavelFixa02')"
                  name="variavelFixa02"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="variavelFixa03"
                  :label="$t('variavelFixa03')"
                  name="variavelFixa03"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="variavelFixa04"
                  :label="$t('variavelFixa04')"
                  name="variavelFixa04"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="variavelFixa05"
                  :label="$t('variavelFixa05')"
                  name="variavelFixa05"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="variavelFixa06"
                  :label="$t('variavelFixa06')"
                  name="variavelFixa06"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="variavelFixa07"
                  :label="$t('variavelFixa07')"
                  name="variavelFixa07"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="variavelFixa08"
                  :label="$t('variavelFixa08')"
                  name="variavelFixa08"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="variavelFixa09"
                  :label="$t('variavelFixa09')"
                  name="variavelFixa09"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="variavelFixa10"
                  :label="$t('variavelFixa10')"
                  name="variavelFixa10"
                  hide-details
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
            </v-ln>
          </v-card-subtitle>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="confirmarDisponibilizacaoDocumento = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="disponibilizarDocumentoFuncionarios"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal pedido Separacao -->
      <v-dialog
        v-model="confirmarSeparacao"
        persistent
        max-width="450"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_separacao_do_pedido?")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="confirmarSeparacao = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="separacao"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal pedido Disponibilizacao -->
      <v-dialog
        v-model="confirmarDisponibilizacao"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_disponibilizacao_do_pedido?")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="confirmarDisponibilizacao = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="disponibilizar"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal pedido confirmarTroca -->
      <v-dialog
        v-model="confirmarTroca"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_troca_Pedido?")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="confirmarTroca = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="trocar"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal pedido Retirado Terceiro -->
      <v-dialog
        v-model="confirmarRetiradoTerceiro"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_retirada_do_pedido?")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="confirmarRetiradoTerceiro = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="retiradaTerceiro"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal pedido Entrega -->
      <v-dialog
        v-model="confirmarEntrega"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_entrega_do_pedido?")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="confirmarEntrega = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="entregaPendente"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal pedido Recebimento -->
      <v-dialog
        v-model="confirmarRetirada"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_retirada_do_pedido?")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="confirmarRetirada = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="retirar"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal pedido Recebimento -->
      <v-dialog
        v-model="confirmarRecebimento"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_recebimento_do_pedido?")
          }}</v-card-title>
          <v-card-body v-if="this.nomeSingular === 'PedidoUniforme'">
            <v-textarea
              v-model="objetoAtual.observacaoRecebimento"
              :label="$t('Detalhes_entrega')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            >
            </v-textarea>
          </v-card-body>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="confirmarRecebimento = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="receber"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal pedido Entrega total -->
      <v-dialog
        v-model="confirmarEntregaTotal"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_entrega_total_do_pedido?")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="confirmarEntregaTotal = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="entregaTotal"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalConfirmaValidacaoFinanceira01"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_validacao?")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="modalConfirmaValidacaoFinanceira01 = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="validacaoFinanceira01"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalConfirmaValidacaoFinanceira02"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_validacao?")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="modalConfirmaValidacaoFinanceira02 = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="validacaoFinanceira02"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalConfirmaValidacaoFuncionarioAfastamento01"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            exigeValidacao02FuncionarioAfastamentoSolicitacao()
              ? $t("Confirmar_primeira_validacao")
              : $t("Confirmar_validacao_e_aprovacao")
          }}</v-card-title>
          <v-card-text>{{
            exigeValidacao02FuncionarioAfastamentoSolicitacao()
              ? $t("Afastamento_primeira_validacao_descricao")
              : $t("Afastamento_validacao_final_descricao")
          }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="modalConfirmaValidacaoFuncionarioAfastamento01 = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="validacaoFuncionarioAfastamento01"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalConfirmaValidacaoFuncionarioAfastamento02"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirmar_segunda_validacao")
          }}</v-card-title>
          <v-card-text>{{
            $t("Afastamento_validacao_final_descricao")
          }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="modalConfirmaValidacaoFuncionarioAfastamento02 = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="validacaoFuncionarioAfastamento02"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalConfirmaAprovacao"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            nomeSingular === "FuncionarioPontoSolicitacao" &&
            exigeValidacao02FuncionarioPontoSolicitacao()
              ? $t("Confirmar_validacao_ponto")
              : $t("Confirma_aprovacao?")
          }}</v-card-title>
          <v-card-text
            v-if="
              nomeSingular === 'FuncionarioPontoSolicitacao' &&
              exigeValidacao02FuncionarioPontoSolicitacao()
            "
            >{{
              objetoAtual && objetoAtual.responsavelValidacao01
                ? $t("Ponto_segunda_validacao_descricao")
                : $t("Ponto_primeira_validacao_descricao")
            }}</v-card-text
          >

          <v-card-subtitle v-if="nomeSingular === 'ContaVinculadaMovimentacao'">
            <v-spacer></v-spacer>
            <v-col cols="12" class="d-flex">
              <CampoData
                :label="$t('Data')"
                @date="dataAprovacao = $event"
                :key="idDialog"
              />
            </v-col>
          </v-card-subtitle>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="modalConfirmaAprovacao = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="aprovar"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalConfirmaGeracaoDocumento"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_geracao_documento_fiscal?")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="modalConfirmaGeracaoDocumento = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="gerarDocumento"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalConfirmaExecucaoServico"
        persistent
        max-width="470"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_registro_execucao?")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="modalConfirmaExecucaoServico = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="registroExecucaoServico"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="modalGuias" max-width="800" class="dialog-deletado">
        <v-card>
          <v-card-title class="headline">{{ $t("Guias") }}</v-card-title>
          <v-data-table
            :headers="headerGuias"
            :items="objetoAtual.guias"
            class="elevation-1"
            disable-pagination
          >
            <template v-slot:[`item.valor`]="{ item }">
              <span>{{ item.valor | formatoMonetario }}</span>
            </template>

            <template v-slot:[`item.vencimento`]="{ item }">
              <span>{{ item.vencimento | dataParaLeitura }}</span>
            </template>

            <template v-slot:[`item.statusCobranca`]="{ item }">
              {{ $t(item.statusCobranca) }}
            </template>

            <template v-slot:[`item.situacao`]="{ item }">
              {{ $t(item.situacao) }}
            </template>

            <template v-slot:[`item.valorDeclarado`]="{ item }">
              <span>{{ item.valorDeclarado | formatoMonetario }}</span>
            </template>

            <template v-slot:[`item.actionsGuias`]="{ item }">
              <v-icon
                small
                name="printBtn"
                id="print"
                :title="$t('Imprimir')"
                class="mr-2 ma-1"
                @click="printGtv(item)"
                :loading="loading"
                >mdi-printer-outline</v-icon
              >
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              height="39"
              text
              @click="modalGuias = false"
            >
              {{ $t("Fechar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalTarefaExecucaoItems"
        max-width="800"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{ $t("Items") }}</v-card-title>
          <v-data-table
            :headers="headerTarefaExecucaoItems"
            :items="objetoAtual.imobilizados"
            class="elevation-1"
            disable-pagination
          >
            <template v-slot:[`item.imagem`]="{ item }">
              <ShowImage :url="item.imagem">
                <v-avatar color="primary" size="50"
                  ><v-img
                    contain
                    max-height="151"
                    max-width="250"
                    :src="item.imagem"
                  ></v-img
                ></v-avatar>
              </ShowImage>
            </template>
            <template v-slot:[`item.ocorrencia`]="{ item }">
              <span>{{ item.ocorrencia ? $t("sim") : $t("nao") }}</span>
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              height="39"
              text
              @click="modalTarefaExecucaoItems = false"
            >
              {{ $t("Fechar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalEventosTv"
        max-width="1200"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{ $t("Eventos") }} </v-card-title>
          <v-card-subtitle>
            <v-spacer></v-spacer>
            <br />
            <v-btn
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="confirmaNovoEventoTv()"
              :loading="loading"
            >
              {{ $t("novo_registro") }}
            </v-btn>
          </v-card-subtitle>
          <v-data-table
            :headers="headerEventosTv"
            :items="eventosTv"
            class="elevation-1"
            disable-pagination
          >
            <template v-slot:[`item.dtInclusao`]="{ item }">
              <span>{{ item.dtInclusao | dataHoraParaLeitura }}</span>
            </template>
            <template v-slot:[`item.data`]="{ item }">
              <span>{{ item.data | dataHoraParaLeitura }}</span>
            </template>

            <template v-slot:[`item.exportacaoRealizada`]="{ item }">
              <span>{{
                item.exportacaoRealizada ? $t("sim") : $t("nao")
              }}</span>
            </template>

            <template v-slot:[`item.edit`]="{ item }">
              <v-icon
                @click="openEditarModalEventoTv(item)"
                icon
                elevation="0"
                :ripple="false"
                v-if="editar"
                small
                name="editBtn"
                id="edit"
                :title="$t('Editar')"
                class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                color="#67748e"
                >ni-ruler-pencil</v-icon
              >
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              height="39"
              text
              @click="modalEventosTv = false"
            >
              {{ $t("Fechar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalEventoTv"
        max-width="800"
        class="dialog-deletado"
        persistent
      >
        <v-card>
          <v-card-title class="headline">{{ $t("Evento") }} </v-card-title>
          <v-card-subtitle>
            <v-row>
              <v-col cols="12" md="12">
                <span class="opacity-5 text-dark">
                  {{ $t("Ocorrencia") }}
                </span>
                <v-autocomplete
                  id="selecionaOcorrencia"
                  outlined
                  v-model="eventoTvAtual.ocorrencia"
                  :items="ocorrenciasTvOpcoes"
                  :item-text="(item) => item.descricao"
                  :label="$t('Ocorrencia')"
                  return-object
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="12">
                <span class="opacity-5 text-dark">
                  {{ $t("Evento") }}
                </span>
                <v-autocomplete
                  id="selecionaEvento"
                  outlined
                  v-model="eventoTvAtual.evento"
                  :items="eventosTvOpcoes"
                  :item-text="(item) => item.descricao"
                  :label="$t('Evento')"
                  return-object
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <span class="opacity-5 text-dark">
                  {{ $t("Data") }}
                </span>
                <CampoDataHora
                  @date="eventoTvAtual.data = $event"
                  name="data"
                  :label="$t('Data')"
                  :payload="eventoTvAtual.data"
                  :key="idDialog"
                />
              </v-col>

              <v-col cols="12" md="12">
                <span class="opacity-5 text-dark">
                  {{ $t("Detalhes") }}
                </span>
                <v-textarea
                  v-model="eventoTvAtual.detalhes"
                  :payload="eventoTvAtual.detalhes"
                  :label="$t('Detalhes')"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-textarea>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
          </v-card-subtitle>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              v-if="
                eventoTvAtual.exportacaoRealizada === undefined ||
                eventoTvAtual.exportacaoRealizada === false
              "
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="registroNovoEventoTv()"
              :loading="loading"
            >
              {{ $t("Enviar") }}
            </v-btn>

            <v-btn
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              height="39"
              text
              @click="modalEventoTv = false"
              :loading="loading"
            >
              {{ $t("Fechar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalGerarRoteiroModelo"
        max-width="800"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("RoteiroModelos")
          }}</v-card-title>
          <v-card-subtitle>
            <v-col cols="12" md="12">
              <v-autocomplete
                id="selecionaRoteiroModelo"
                outlined
                v-model="roteiroModelo"
                :items="roteiroModelos"
                :item-text="(item) => item.descricao"
                :label="$t('Modelo')"
                return-object
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              >
              </v-autocomplete>
            </v-col>
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="gerarRoteirosModelo()"
              :loading="loading"
            >
              {{ $t("Confirmar") }}
            </v-btn>
            <v-btn
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              height="39"
              text
              @click="modalGerarRoteiroModelo = false"
              :loading="loading"
            >
              {{ $t("Fechar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal transferencia empresa -->
      <v-dialog
        v-model="modalTransferenciaEmpresa"
        persistent
        max-width="350"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Transferencia_empresa")
          }}</v-card-title>

          <v-col cols="12" class="d-flex">
            <v-text-field
              v-model="objTransferenciaEmpresa.matriculaAtual"
              :label="$t('Matricula_atual')"
              name="Matricula_atual"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex">
            <v-text-field
              v-model="objTransferenciaEmpresa.matriculaNova"
              :label="$t('Matricula_nova')"
              name="Matricula_nova"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex">
            <CampoData
              :key="idDialog"
              :payload="objTransferenciaEmpresa.dataTransferencia"
              label="Data_transferencia"
              @date="objTransferenciaEmpresa.dataTransferencia = $event"
              name="Data_transferencia"
            >
            </CampoData>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="inquilinoDestinoTransferencia"
              :items="inquilinosTransferencia"
              :item-text="formatInquilinoTransferencia"
              return-object
              :label="$t('Destino')"
              :rules="[ruleRequired]"
              :disabled="!inquilinosTransferencia.length"
              @change="onTransferenciaDestinoChange"
            ></v-autocomplete>
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="modalTransferenciaEmpresa = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="transferenciaEmpresa()"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalChangeTenant"
        persistent
        max-width="450"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Transferencia_empresa")
          }}</v-card-title>

          <v-col cols="12" class="d-flex" v-if="recursoAtual.identificacao">
            <v-text-field
              v-model="recursoAtual.identificacao"
              :label="$t('Identificacao')"
              name="identificacao"
              disabled
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" class="d-flex" v-if="recursoAtual.descricao">
            <v-text-field
              v-model="recursoAtual.descricao"
              :label="$t('Descricao')"
              name="descricao"
              disabled
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" class="d-flex" v-if="recursoAtual.matricula">
            <v-text-field
              v-model="recursoAtual.matricula"
              :label="$t('Matricula')"
              name="matricula"
              disabled
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" class="d-flex" v-if="recursoAtual.nomeSocial">
            <v-text-field
              v-model="recursoAtual.nomeSocial"
              :label="$t('NomeSocial')"
              name="nomeSocial"
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="12">
            <span class="opacity-5 text-dark">
              {{ $t("Destino") }}
            </span>
            <v-autocomplete
              :items="inquilinosDisponiveis"
              v-model="inquilinoDestino"
              item-text="fantasia"
              return-object
              :label="$t('Destino')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-autocomplete>
          </v-col>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text
              @click="modalChangeTenant = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              :disabled="!inquilinoDestino"
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="changeTenant()"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal seleciona arquivo-->
      <v-dialog v-model="modalImportArquivo" max-width="550">
        <v-card>
          <v-card-title>
            {{ $t("Selecione_arquivo") }}
          </v-card-title>

          <v-card-actions>
            <input
              type="file"
              ref="doc"
              :accept="tipoImportacaoExterna === 'Dexion' ? '.txt' : '.csv'"
            />
            <div>{{ statusReader }}</div>
          </v-card-actions>

          <v-btn
            class="
              ma-1
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              py-3
              px-6
              ms-3
            "
            height="39"
            text
            @click="importExternal()"
            :loading="loading"
          >
            {{ $t("Confirmar") }}
          </v-btn>
          <v-btn
            height="39"
            class="
              ma-1
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            text
            @click="modalImportArquivo = false"
            :loading="loading"
          >
            {{ $t("Cancelar") }}
          </v-btn>
        </v-card>
      </v-dialog>

      <v-dialog v-model="modalPedidosPendentes" class="dialog-deletado">
        <v-card>
          <v-card-title class="headline">{{ $t("Pedidos") }}</v-card-title>
          <v-data-table
            :headers="headerPedidos"
            :items="pedidosPendentes"
            class="elevation-1"
            disable-pagination
          >
            <template v-slot:[`item.data`]="{ item }">
              <span>{{ item.data | dataParaLeitura }}</span>
            </template>

            <template v-slot:[`item.situacao`]="{ item }">
              {{ $t(item.situacao) }}
            </template>
            <template v-slot:[`item.classificacao`]="{ item }">
              {{ $t(item.classificacao) }}
            </template>

            <template v-slot:[`item.valorDeclarado`]="{ item }">
              <span>{{ item.valorDeclarado | formatoMonetario }}</span>
            </template>

            <template v-slot:[`item.janelaOrigemInicio`]="{ item }">
              {{ item.janelaOrigemInicio | horaParaLeitura }}
            </template>
            <template v-slot:[`item.janelaOrigemFinal`]="{ item }">
              {{ item.janelaOrigemFinal | horaParaLeitura }}
            </template>
            <template v-slot:[`item.janelaDestinoInicio`]="{ item }">
              {{ item.janelaDestinoInicio | horaParaLeitura }}
            </template>
            <template v-slot:[`item.janelaDestinoFinal`]="{ item }">
              {{ item.janelaDestinoFinal | horaParaLeitura }}
            </template>

            <template v-slot:[`item.janelaAtendimentoInicio`]="{ item }">
              {{ item.janelaAtendimentoInicio | dataHoraParaLeitura }}
            </template>
            <template v-slot:[`item.janelaAtendimentoFinal`]="{ item }">
              {{ item.janelaAtendimentoFinal | dataHoraParaLeitura }}
            </template>

            <template v-slot:[`item.actionsPedidos`]="{ item }">
              <v-icon
                small
                name="printBtn"
                id="print"
                :title="$t('Roteirizar')"
                class="mr-2 ma-1"
                @click="showModalRoteirizarPedido(item)"
                :loading="loading"
                >ni-button-play</v-icon
              >
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              height="39"
              text
              @click="modalPedidosPendentes = false"
            >
              {{ $t("Fechar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalSolicitacoesTarefaPendente"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("SolicitacoesPendentes")
          }}</v-card-title>
          <v-data-table
            :headers="headerTarefaSolicitacao"
            :items="pedidosPendentes"
            class="elevation-1"
            disable-pagination
          >
            <template v-slot:[`item.data`]="{ item }">
              <span>{{ item.data | dataParaLeitura }}</span>
            </template>

            <template v-slot:[`item.situacao`]="{ item }">
              {{ $t(item.situacao) }}
            </template>

            <template v-slot:[`item.valorDeclarado`]="{ item }">
              <span>{{ item.valorDeclarado | formatoMonetario }}</span>
            </template>

            <template v-slot:[`item.janelaOrigemInicio`]="{ item }">
              {{ item.janelaOrigemInicio | horaParaLeitura }}
            </template>
            <template v-slot:[`item.janelaOrigemFinal`]="{ item }">
              {{ item.janelaOrigemFinal | horaParaLeitura }}
            </template>
            <template v-slot:[`item.janelaDestinoInicio`]="{ item }">
              {{ item.janelaDestinoInicio | horaParaLeitura }}
            </template>
            <template v-slot:[`item.janelaDestinoFinal`]="{ item }">
              {{ item.janelaDestinoFinal | horaParaLeitura }}
            </template>

            <template v-slot:[`item.janelaAtendimentoInicio`]="{ item }">
              {{ item.janelaAtendimentoInicio | dataHoraParaLeitura }}
            </template>
            <template v-slot:[`item.janelaAtendimentoFinal`]="{ item }">
              {{ item.janelaAtendimentoFinal | dataHoraParaLeitura }}
            </template>

            <template v-slot:[`item.actionsPedidos`]="{ item }">
              <v-icon
                small
                name="routerBtn"
                id="router"
                :title="$t('Roteirizar')"
                class="mr-2 ma-1"
                @click="showModalRoteirizarTarefaSolicitacao(item)"
                :loading="loading"
                >ni-button-play</v-icon
              >
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              height="39"
              text
              @click="modalSolicitacoesTarefaPendente = false"
            >
              {{ $t("Fechar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalRoteirizarPedido"
        class="dialog-deletado"
        max-width="600"
      >
        <v-card>
          <v-card-title class="headline">
            <v-btn class="ma-2">
              {{ $t("Pedido") + " - #" + pedidoAtual.id }}
            </v-btn>
            <br />
            {{ $t("Origem") + ": " + pedidoAtual?.origem?.descricao }}<br />
            {{
              pedidoAtual?.origem?.logradouro +
              ", " +
              pedidoAtual?.origem?.numero +
              " - " +
              pedidoAtual?.origem?.bairro
            }}
            <br />
            {{
              pedidoAtual?.origem?.cidade?.nome +
              "/" +
              pedidoAtual?.origem?.cidade?.estado?.sigla
            }}<br />
            {{ $t("Janela") + ": " }}
            {{ pedidoAtual.janelaOrigemInicio | horaParaLeitura }} a
            {{ pedidoAtual.janelaOrigemFinal | horaParaLeitura }}

            <div v-if="pedidoAtual.classificacao !== 'ASSISTENCIA'">
              <br />

              {{ $t("Destino") + ": " + pedidoAtual?.destino?.descricao }}<br />
              {{
                pedidoAtual?.destino?.logradouro +
                ", " +
                pedidoAtual?.destino?.numero +
                " - " +
                pedidoAtual?.destino?.bairro
              }}
              <br />
              {{
                pedidoAtual?.destino?.cidade?.nome +
                "/" +
                pedidoAtual?.destino?.cidade?.estado?.sigla
              }}<br />
              {{ $t("Janela") + ": " }}
              {{ pedidoAtual.janelaDestinoInicio | horaParaLeitura }} a
              {{ pedidoAtual.janelaDestinoFinal | horaParaLeitura }}
            </div>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <div class="ma-4 font-weight-light rounded">
                  <CampoHorario
                    @date="novoTrajeto.previsaoAtendimentoOrigem = $event"
                    :label="$t('PrevisaoAtendimentoOrigem')"
                    v-model="novoTrajeto.previsaoAtendimentoOrigem"
                    :key="keyModal"
                  />
                  <br />
                  <CampoHorario
                    v-if="pedidoAtual.classificacao !== 'ASSISTENCIA'"
                    @date="novoTrajeto.previsaoAtendimentoDestino = $event"
                    :label="$t('PrevisaoAtendimentoDestino')"
                    v-model="novoTrajeto.previsaoAtendimentoDestino"
                    :key="keyModal"
                  />
                  <br />

                  <v-autocomplete
                    outlined
                    v-model="novoTrajeto.roteiro"
                    :items="roteirosDisponiveis"
                    :item-text="
                      (item) => item.roteiro + ' - ' + item.operador.nome
                    "
                    :label="$t('Roteiro')"
                    return-object
                    class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                    dense
                    flat
                    filled
                    solo
                    :key="keyModal"
                  >
                  </v-autocomplete>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="modalRoteirizarPedido = false"
            >
              {{ $t("Cancelar") }}
            </v-btn>

            <v-btn
              type="submit"
              :disabled="
                novoTrajeto.roteiro.id === 0 ||
                novoTrajeto.previsaoAtendimentoOrigem === '' ||
                novoTrajeto.previsaoAtendimentoDestino === ''
              "
              @click="roteirizarPedido"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-primary
                bg-gradient-primary
                py-3
                px-6
              "
            >
              {{ $t("Adicionar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalRoteirizarTarefaSolicitacao"
        class="dialog-deletado"
        max-width="1200"
      >
        <v-card>
          <!-- Cabeçalho com dados do pedido -->
          <v-card-title class="headline">
            <div>
              {{ $t("Solicitacao") }} - #{{ pedidoAtual?.id }}<br />
              {{ $t("Cliente") }}: {{ pedidoAtual?.cliente?.fantasia }}<br />
              {{ $t("Local") }}: {{ pedidoAtual?.local?.descricao }}<br />
              {{ pedidoAtual?.local?.logradouro }},
              {{ pedidoAtual?.local?.numero }} - {{ pedidoAtual?.local?.bairro
              }}<br />
              {{ pedidoAtual?.local?.cidade?.nome }}/{{
                pedidoAtual?.local?.cidade?.estado?.sigla
              }}<br /><br />
              <strong>{{ $t("Tarefa") }}:</strong>
              {{ pedidoAtual?.tarefaClassificacao?.descricao }}<br />
              <div v-if="pedidoAtual?.tarefaClassificacao?.items?.length">
                <strong>{{ $t("Itens") }}:</strong>
                <ul>
                  <li
                    v-for="(item, index) in pedidoAtual.tarefaClassificacao
                      .items"
                    :key="index"
                  >
                    {{ item.imobilizadoClassificacao.descricao }} -
                    {{ $t("Quantidade") }}: {{ item.quantidade }}
                  </li>
                </ul>
              </div>
            </div>
          </v-card-title>

          <!-- Corpo do modal -->
          <v-card-text>
            <v-row>
              <br />
              <!-- Campo para Previsão de Atendimento -->
              <v-col cols="12" md="4">
                <CampoHorario
                  v-model="novoTrajeto.previsaoAtendimento"
                  :label="$t('PrevisaoAtendimento')"
                  @date="novoTrajeto.previsaoAtendimento = $event"
                  :key="keyModal"
                />
              </v-col>

              <!-- Seleção do Operador -->
              <v-col cols="12" md="8">
                <v-autocomplete
                  outlined
                  v-model="novoTrajeto.roteiro"
                  :items="roteirosDisponiveis"
                  :item-text="(item) => ' ' + item.operador.nome"
                  :label="$t('Operador')"
                  return-object
                  filled
                  solo
                  :key="keyModal"
                ></v-autocomplete>
              </v-col>

              <!-- Seleção de Imobilizado com Busca -->
              <!-- <v-col cols="12" md="6">
                <v-autocomplete v-model="selectedImobilizado" :items="imobilizadosDisponiveis" return-object
                  item-text="descricao" item-value="id" :label="$t('Selecione Imobilizado')" solo
                  clearable></v-autocomplete>
                <v-btn class="ma-1 font-weight-bold text-none btn-primary bg-gradient-primary py-3 px-6 ms-3"
                  height="39" @click="addImobilizado">
                  {{ $t("Adicionar Imobilizado") }}
                </v-btn>
              </v-col> -->

              <!-- Card com listagem dos Imobilizados Selecionados -->
              <!-- <v-col cols="12">
                <v-card class="mb-3">
                  <v-card-title>
                    {{ $t("Imobilizados Selecionados") }}
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-card-text>
                    <v-list>
                      <v-list-item v-for="(imob, index) in selectedImobilizados" :key="imob.id">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ imob.descricao }} - {{ imob.imobilizadoClassificacao?.descricao }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn icon @click="removeImobilizado(index)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                    <div v-if="selectedImobilizados.length === 0">
                      {{ $t("Nenhum imobilizado selecionado") }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col> -->
            </v-row>
          </v-card-text>

          <!-- Ações do modal -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              class="
                ma-1
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              height="39"
              @click="modalRoteirizarTarefaSolicitacao = false"
            >
              {{ $t("Cancelar") }}
            </v-btn>
            <v-btn
              color="primary"
              text
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
              "
              height="39"
              @click="roteirizarTarefaSolicitacao"
            >
              {{ $t("Adicionar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal cadastrado com sucesso -->
      <v-dialog v-model="dialogSuccesEdit" max-width="500">
        <div align="center">
          <v-card>
            <v-card-title>
              <div class="font-weight-bold text-h5 text-typo mb-2">
                {{ $t("editado_sucesso") }}
              </div>
            </v-card-title>
            <v-btn
              height="39"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              @click="dialogSuccesEdit = false"
              id="btn-modal-sucesso-nao"
            >
              {{ $t("Ok") }}
            </v-btn>
          </v-card>
        </div>
      </v-dialog>

      <v-dialog v-model="dialogSuccesInsert" max-width="500">
        <div align="center">
          <v-card>
            <v-card-title>
              <div class="font-weight-bold text-h5 text-typo mb-2">
                {{ $t("cadastrado_sucesso") }}
              </div>
            </v-card-title>
            <v-btn
              height="39"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              @click="dialogSuccesInsert = false"
              id="btn-modal-sucesso-nao"
            >
              {{ $t("Ok") }}
            </v-btn>
          </v-card>
        </div>
      </v-dialog>

      <v-dialog
        v-model="dialogEdit"
        persistent
        max-width="100%"
        :transition="false"
        content-class="crud-base-form-dialog"
      >
        <v-card
          v-if="crudModalLoading.edit"
          class="crud-modal-loading-card"
          role="status"
          aria-live="polite"
        >
          <div class="crud-modal-loading-panel">
            <span class="crud-modal-loading-accent"></span>
            <div class="crud-modal-loading-visual" aria-hidden="true">
              <span class="crud-modal-loading-ring"></span>
              <span class="crud-modal-loading-core"></span>
            </div>
            <div class="crud-modal-loading-content">
              <span class="crud-modal-loading-title">{{
                $t("Carregando")
              }}</span>
              <div class="crud-modal-loading-track">
                <span></span>
              </div>
              <div class="crud-modal-loading-lines" aria-hidden="true">
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </v-card>
        <component
          :is="editComponent"
          v-if="editComponent"
          v-show="!crudModalLoading.edit"
          ref="editComponentInstance"
          :itemAtual="recursoAtual"
          :recurso="recursoAtual"
          @submitSuccess="onSubmitSuccessEdit"
          @submitError="onSubmitError"
          @closeModalEdit="closeEditarModal"
          :close-with-crud-dialog="true"
        />
      </v-dialog>

      <v-dialog
        v-model="dialogInsert"
        persistent
        max-width="100%"
        :transition="false"
        content-class="crud-base-form-dialog"
      >
        <v-card
          v-if="crudModalLoading.insert"
          class="crud-modal-loading-card"
          role="status"
          aria-live="polite"
        >
          <div class="crud-modal-loading-panel">
            <span class="crud-modal-loading-accent"></span>
            <div class="crud-modal-loading-visual" aria-hidden="true">
              <span class="crud-modal-loading-ring"></span>
              <span class="crud-modal-loading-core"></span>
            </div>
            <div class="crud-modal-loading-content">
              <span class="crud-modal-loading-title">{{
                $t("Carregando")
              }}</span>
              <div class="crud-modal-loading-track">
                <span></span>
              </div>
              <div class="crud-modal-loading-lines" aria-hidden="true">
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </v-card>
        <component
          :is="insertComponent"
          v-if="insertComponent"
          v-show="!crudModalLoading.insert"
          @submitSuccessInsert="onSubmitSuccessInsert"
          @submitErrorInsert="onSubmitErrorInsert"
          @closeModalInsert="closeInsertModal"
          :close-with-crud-dialog="true"
          :dataProp="data"
        />
      </v-dialog>

      <v-row
        class="crud-listagem-layout"
        :class="ocultarCabecalhoListagem ? 'mt-0' : 'mt-8'"
      >
        <div class="crud-listagem-command-bar">
          <div v-if="!ocultarCabecalhoListagem" class="crud-listagem-heading">
            <div class="crud-listagem-heading__icon" aria-hidden="true">
              <v-icon color="#5e72e4" size="21">
                mdi-format-list-bulleted
              </v-icon>
            </div>
            <div class="crud-listagem-heading__content">
              <span class="crud-listagem-heading__kicker">
                {{ $t("Listagem") }}
              </span>
              <h1>{{ $t(recursoUpper) }}</h1>
            </div>
          </div>
          <v-row v-if="!modoSelecaoRecurso" class="crud-listagem-actions__row">
            <v-tooltip v-if="keyboardShortcutsEnabled" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  :aria-label="$t('Atalhos_de_teclado')"
                  aria-keyshortcuts="Control+/ Meta+/"
                  class="crud-listagem-shortcuts-button"
                  @click="openKeyboardShortcuts"
                >
                  <v-icon>mdi-keyboard-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Atalhos_de_teclado") }} (Ctrl/⌘ + /)</span>
            </v-tooltip>
            <BotaoTutorial />
            <v-btn
              v-if="this.nomeSingular === 'RoteiroTrajeto'"
              :loading="loading"
              @click="showPedidosPendentes()"
              v-can="'ROLE_Pedido_List'"
              id="btn--PedidoPendentes"
              :ripple="false"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              <v-icon left dark> mdi-plus-circle </v-icon>
              {{
                $t("PedidosPendentes") +
                " (" +
                this.quantidadePedidosPendentes +
                ")"
              }}
            </v-btn>

            <v-btn
              v-if="this.nomeSingular === 'TarefaExecucaoItem'"
              :loading="loading"
              @click="showTarefaSolicitacaoPendentes()"
              v-can="'ROLE_TarefaSolicitacao_List'"
              id="btn--PedidoPendentes"
              :ripple="false"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              <v-icon left dark> mdi-plus-circle </v-icon>
              {{
                $t("SolicitacoesPendentes") +
                " (" +
                this.quantidadePedidosPendentes +
                ")"
              }}
            </v-btn>

            <v-btn
              ref="botaoCadastro"
              v-if="botaoCadastro"
              :loading="loading"
              @click="openInsertModal()"
              v-can="'ROLE_' + this.nomeSingular + '_Insert'"
              id="btn--cadastro"
              aria-keyshortcuts="Control+I Meta+I"
              :ripple="false"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              <v-icon left dark> mdi-plus-circle </v-icon>
              {{ $t(this.stringCadastro) }}
            </v-btn>
            <v-btn
              v-if="
                (nomeSingular === 'Funcionario' ||
                  nomeSingular === 'FuncionarioResumed') &&
                !possuiDocumentacaoAcessoria()
              "
              :loading="loading"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              @click="openInsertModalAdmissaoResumida()"
              v-can="'ROLE_' + this.nomeSingular + '_Insert'"
            >
              <v-icon left dark> mdi-plus-circle </v-icon>
              {{ $t("Admissao_resumida") }}
            </v-btn>
            <v-btn
              v-if="botaoTransferenciaEmpresaFuncionario"
              :loading="loading"
              @click="confirmaTransferenciaEmpresa()"
              v-can="'ROLE_' + this.nomeSingular + '_Insert'"
              id="btn--transferenciaEmpresa"
              :ripple="false"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              <v-icon left dark> mdi-bank-transfer-out </v-icon>
              {{ $t("Transferencia_empresa") }}
            </v-btn>
            <v-btn
              @click="exportCSV()"
              v-if="exportacaoListagem && (isSearching || buscaSimplificada)"
              :loading="loading"
              v-can="'ROLE_' + this.nomeSingular + '_Export'"
              id="btn--exportacao"
              :ripple="false"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              <v-icon left dark> ni-cloud-download-95 </v-icon>
              {{ $t("Exportar") }}
            </v-btn>
            <v-btn
              @click="exportExcel()"
              v-if="exportacaoListagem && (isSearching || buscaSimplificada)"
              :loading="loading"
              v-can="'ROLE_' + this.nomeSingular + '_Export_Excel'"
              id="btn--exportacao-excel"
              :ripple="false"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              <v-icon left dark> ni-cloud-download-95 </v-icon>
              {{ $t("Excel") }}
            </v-btn>
            <v-btn
              v-if="exportacaoListagem && isSearching"
              @click="exportPDF()"
              :loading="loading"
              v-can="'ROLE_' + this.nomeSingular + '_Export_Pdf'"
              id="btn--exportacao"
              :ripple="false"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              <v-icon left dark> ni-cloud-download-95 </v-icon>
              {{ $t("PDF") }}
            </v-btn>
            <v-menu v-model="impressaoMenu" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  ref="botaoImpressao"
                  v-bind="attrs"
                  v-on="on"
                  :loading="loading"
                  :disabled="!camposImpressao.length"
                  id="btn--impressao"
                  aria-keyshortcuts="Control+P Meta+P"
                  :ripple="false"
                  class="
                    ma-1
                    font-weight-bold
                    text-none
                    btn-primary
                    bg-gradient-primary
                    py-3
                    px-6
                    ms-3
                  "
                  height="39"
                >
                  <v-icon left dark> mdi-printer </v-icon>
                  {{ $t("Impressao") }}
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="tipo in tiposImpressao"
                  :key="tipo.value"
                  :disabled="loading"
                  @click="gerarImpressao(tipo.value)"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small>{{ tipo.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ tipo.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            <ImportacaoExcelLote
              v-if="atualizacaoExcel && !modoSelecaoRecurso"
              :key="'atualizacao-excel-' + ($store.state.inquilino || {}).id"
              :configuracao="{ ...atualizacaoExcel, modo: 'atualizacao' }"
              :data-service="
                atualizacaoExcel.dataService || $parent.DataService
              "
              :permissao="
                atualizacaoExcel.permissao || 'ROLE_' + nomeSingular + '_Update'
              "
              :disabled="loading"
              @concluido="onAtualizacaoExcelConcluida"
            />
            <ImportacaoExcelLote
              v-if="importacaoExcel && !modoSelecaoRecurso"
              :key="'importacao-excel-' + ($store.state.inquilino || {}).id"
              :configuracao="importacaoExcel"
              :data-service="importacaoExcel.dataService || $parent.DataService"
              :permissao="
                importacaoExcel.permissao || 'ROLE_' + nomeSingular + '_Insert'
              "
              :disabled="loading"
              @concluido="onImportacaoExcelConcluida"
            />
            <v-btn
              v-if="botaoImportDexion && !modoSelecaoRecurso"
              :loading="loading"
              @click.stop="openModalImportDexion()"
              id="btn-import-dexion"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              <v-icon left> ni-cloud-upload-96 </v-icon>
              {{ $t("Importar") }} Dexion
            </v-btn>
            <v-btn
              v-if="botaoImportContaContabil"
              :loading="loading"
              @click.stop="openModalImportContaContabil()"
              id="btn-import-csv"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              <v-icon left> ni-cloud-upload-96 </v-icon>
              {{ $t("Importar_conta_contabil") }}
            </v-btn>
            <v-btn
              v-if="botaoGerarRoteiroModelo && pesquisaDataAtualTv"
              :loading="loading"
              @click="confirmaGerarRoteirosModelo()"
              v-can="'ROLE_RoteiroModelo_Route'"
              id="btn--GerarRoteiroModelo"
              :ripple="false"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              <v-icon left dark> ni-cloud-upload-96 </v-icon>
              {{ $t("RoteiroModelos") }}
            </v-btn>
            <v-btn
              v-if="
                canDeleteSelection && !enableSelection && !bulkDeleteModeActive
              "
              :loading="loading"
              @click="iniciarDelecaoEmLote"
              id="btn--excluirEmMassa"
              :ripple="false"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
            >
              <v-icon left dark> mdi-delete-sweep </v-icon>
              {{ $t("Excluir") }}
            </v-btn>
            <div
              v-if="$slots.upload || $scopedSlots.upload"
              class="crud-listagem-actions__custom"
            >
              <slot name="upload" :loading="loading"> </slot>
            </div>
          </v-row>
        </div>
        <v-col cols="12">
          <template>
            <div>
              <v-card class="card-shadow border-radius-xl crud-listagem-card">
                <div class="card-header-padding crud-listagem-filters">
                  <div class="crud-listagem-section-heading">
                    <v-icon color="#667085" size="18">
                      mdi-filter-variant
                    </v-icon>
                    <span>{{ $t("Filtros") }}</span>
                  </div>
                  <div class="d-flex align-center">
                    <v-row class="mt-1 crud-listagem-filter-grid">
                      <v-col cols="12" md="5" v-if="buscaSimplificada">
                        <v-text-field
                          ref="buscaSimplificada"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                          height="39"
                          v-model="search"
                          :label="$t('Procurar')"
                          :loading="buscaSimplificadaStatus.active"
                        >
                          <template slot="prepend-inner">
                            <v-icon color="#adb5bd" size=".875rem"
                              >fas fa-search</v-icon
                            >
                          </template>
                        </v-text-field>
                        <div
                          v-if="mostrarStatusBuscaSimplificada"
                          class="simple-search-status"
                        >
                          <span>{{ buscaSimplificadaStatusLabel }}</span>
                          <v-progress-linear
                            v-if="buscaSimplificadaStatus.active"
                            :value="buscaSimplificadaProgressValue"
                            height="3"
                            rounded
                            color="#516a78"
                          ></v-progress-linear>
                        </div>
                      </v-col>

                      <v-col cols="12" md="8" v-if="pesquisaFuncionario">
                        <v-autocomplete
                          :label="$t('Funcionario')"
                          :disabled="loading"
                          chips
                          dense
                          multiple
                          deletable-chips
                          v-model="itemsFuncionario"
                          return-object
                          :items="funcionarios"
                          :item-text="
                            (item) => item.matricula + ' - ' + item.nomeSocial
                          "
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          flat
                          filled
                          solo
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" md="10" v-if="pesquisaPessoa">
                        <v-autocomplete
                          :label="$t('Pessoas')"
                          :disabled="loading"
                          chips
                          multiple
                          deletable-chips
                          v-model="itemsPessoa"
                          return-object
                          :items="pessoas"
                          :item-text="(item) => item.cpf + ' - ' + item.nome"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" md="4" v-if="pesquisaBeneficioConvenio">
                        <v-autocomplete
                          :label="$t('Convenio')"
                          :disabled="loading"
                          chips
                          multiple
                          deletable-chips
                          v-model="itemsBeneficioConvenio"
                          return-object
                          :items="beneficioConvenios"
                          :item-text="(item) => item.descricao"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" md="2" v-if="pesquisaVencimento">
                        <CampoData
                          :disabled="loading"
                          :payload="vencimentoInicio"
                          label="Data Inicio"
                          @date="handleDataInicioVencimentoChange"
                        >
                        </CampoData>
                      </v-col>

                      <v-col cols="12" md="2" v-if="pesquisaVencimento">
                        <CampoData
                          :disabled="loading"
                          :payload="vencimentoFim"
                          label="Data Fim"
                          @date="handleDataFinalVencimentoChange"
                        >
                        </CampoData>
                      </v-col>

                      <v-col cols="12" md="2" v-if="pesquisaCompetencia">
                        <CampoCompetencia
                          label="Competencia"
                          :payload="competencia"
                          @date="handleCompetenciaChange"
                          :disabled="loading"
                        >
                        </CampoCompetencia>
                      </v-col>

                      <v-col
                        cols="12"
                        :sm="pesquisaMoedas ? 6 : undefined"
                        :md="pesquisaMoedas ? 3 : 2"
                        lg="2"
                        v-if="pesquisaPeriodo"
                      >
                        <CampoData
                          :disabled="loading"
                          :payload="inicioPeriodo"
                          label="Inicio_do_periodo"
                          @date="handleDataInicioPeriodoChange"
                        >
                        </CampoData>
                      </v-col>

                      <v-col
                        cols="12"
                        :sm="pesquisaMoedas ? 6 : undefined"
                        :md="pesquisaMoedas ? 3 : 2"
                        lg="2"
                        v-if="pesquisaPeriodo"
                      >
                        <CampoData
                          :disabled="loading"
                          :payload="encerramentoPeriodo"
                          label="Final_do_periodo"
                          @date="handleDataEncerramentoPeriodoChange"
                        >
                        </CampoData>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" v-if="pesquisaMoedas">
                        <v-autocomplete
                          :label="'Moeda operacional'"
                          chips
                          multiple
                          deletable-chips
                          v-model="itemsMoedas"
                          :items="moedas"
                          item-text="descricao"
                          item-value="id"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="6" md="3" v-if="pesquisaProvedor">
                        <v-autocomplete
                          :label="'Provedor'"
                          chips
                          multiple
                          deletable-chips
                          v-model="itemsProvedor"
                          :items="provedores"
                          item-text="text"
                          item-value="value"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" xs="4" sm="6" v-if="pesquisaDetalhe">
                        <v-text-field
                          v-model="detalhe"
                          :label="$t('Descricao')"
                          name="detalhe"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" xs="4" sm="6" v-if="pesquisaTitulo">
                        <v-text-field
                          v-model="titulo"
                          :label="$t('Titulo')"
                          name="titulo"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        xs="4"
                        sm="6"
                        v-if="pesquisaCentroDeCusto"
                      >
                        <v-text-field
                          v-model="detalhe"
                          :label="$t('Centro de Custo')"
                          name="detalhe"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col
                        cols="12"
                        xs="4"
                        sm="4"
                        v-if="pesquisaPostoTrabalhoLivroOcorre"
                      >
                        <v-text-field
                          v-model="descricao"
                          :label="$t('PostoTrabalho')"
                          name="descricao"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" xs="4" sm="4" v-if="pesquisaDescricao">
                        <v-text-field
                          v-model="descricao"
                          :label="$t('Descricao')"
                          name="descricao"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col
                        cols="12"
                        xs="4"
                        sm="4"
                        v-if="pesquisaIdentificador"
                      >
                        <v-text-field
                          v-model="identificador"
                          :label="$t('Identificador')"
                          name="identificador"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col
                        cols="12"
                        xs="4"
                        sm="4"
                        v-if="pesquisaTipoVisualizacaoEmpresa"
                      >
                        <v-select
                          v-model="tipoVisualizacaoEmpresa"
                          :items="tipoVisualizacaoEmpresaOptions"
                          item-text="text"
                          item-value="value"
                          :label="$t('Tipo_visualizacao_empresa')"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-select>
                      </v-col>

                      <v-col cols="12" md="2" v-if="pesquisaMatricula">
                        <v-text-field
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                          v-model="matricula"
                          :label="$t('Matricula')"
                          name="matricula"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="2" v-if="pesquisaID">
                        <v-text-field
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                          v-model="idPedido"
                          :label="$t('ID')"
                          name="idPedido"
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="4" v-if="pesquisaNome">
                        <v-text-field
                          v-model="nome"
                          :label="$t('Nome')"
                          name="nome"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col
                        v-for="filtro in filtrosGenericosString"
                        :key="'filtro-string-' + filtro.coluna"
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="filtrosGenericosValores[filtro.coluna]"
                          :label="$t(filtro.label)"
                          :name="filtro.coluna"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        v-for="filtro in filtrosGenericosNumericos"
                        :key="'filtro-numerico-' + filtro.coluna"
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="filtrosGenericosValores[filtro.coluna]"
                          :label="$t(filtro.label)"
                          :name="filtro.coluna"
                          type="number"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="4" v-if="pesquisaNomeCpf">
                        <v-text-field
                          v-model="nomeCpf"
                          :label="$t('Nome e CPF')"
                          name="nomeCpf"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="4" v-if="pesquisaNomeFuncionario">
                        <v-text-field
                          v-model="nomeFuncionario"
                          :label="$t('Nome do Funcionário')"
                          name="nomeFuncionario"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="3" v-if="pesquisaData">
                        <CampoData
                          :disabled="loading"
                          :payload="data"
                          label="Data"
                          @date="handleDataChange"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </CampoData>
                      </v-col>

                      <v-col
                        cols="12"
                        md="3"
                        v-if="pesquisaDataAtualTv || pesquisaDataSeguinteTv"
                      >
                        <CampoData
                          :disabled="loading"
                          :payload="data"
                          label="Data"
                          @date="handleDataChange"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </CampoData>
                      </v-col>

                      <v-col cols="12" md="3" v-if="pesquisaContaFinanceira">
                        <v-text-field
                          :label="$t('Conta_financeira')"
                          :disabled="loading"
                          v-model="itemsContaFinanceira"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="3" v-if="pesquisaFornecedor">
                        <v-text-field
                          :label="$t('Fornecedor')"
                          :disabled="loading"
                          v-model="itemsFornecedor"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="3" v-if="pesquisaCpfCnpj">
                        <v-text-field
                          v-model="numeroRegistro"
                          :label="$t('CnpjCpf')"
                          name="numeroRegistro"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="3" v-if="pesquisaCliente">
                        <v-text-field
                          :label="$t('Cliente')"
                          :disabled="loading"
                          v-model="itemsCliente"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4" v-if="pesquisaClienteLike">
                        <v-text-field
                          v-model="clienteLike"
                          :label="clienteLikeLabel"
                          name="clienteLike"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="3" v-if="pesquisaPostoTrabalhoLike">
                        <v-text-field
                          v-model="postoTrabalhoLike"
                          :label="postoTrabalhoLikeLabel"
                          name="postoTrabalhoLike"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="3" v-if="pesquisaRegistradorLike">
                        <v-text-field
                          v-model="registradorLike"
                          :label="$t('Registrador_contem')"
                          name="registradorLike"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="3" v-if="pesquisaPostoTrabalho">
                        <v-autocomplete
                          :label="postoTrabalhoLabel"
                          :disabled="loading"
                          chips
                          dens
                          multiple
                          deletable-chips
                          v-model="itemsPostoTrabalho"
                          return-object
                          :items="postoTrabalhos"
                          :item-text="(item) => item.descricao"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" md="2" v-if="pesquisaStatusFinanceiro">
                        <v-select
                          v-model="statusFinanceiro"
                          :items="[
                            { value: 'PENDENTE', text: $t('PENDENTE') },
                            { value: 'QUITADO', text: $t('QUITADO') },
                            { value: '', text: $t('Todos') },
                          ]"
                          item-text="text"
                          item-value="value"
                          :label="$t('Status')"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>

                      <v-col
                        cols="12"
                        md="2"
                        v-if="pesquisaStatusSolicitacaoConsumivel"
                      >
                        <v-select
                          v-model="statusFinanceiro"
                          :items="[
                            { value: 'Pendente', text: $t('PENDENTE') },
                            { value: 'Em separação', text: $t('SEPARACAO') },
                            {
                              value: 'Disponibilizado',
                              text: $t('DISPONIBILIZADO'),
                            },
                            { value: 'Retirado', text: $t('RETIRADO') },
                            { value: 'Cancelado', text: $t('CANCELADO') },
                            { value: '', text: $t('Todos') },
                          ]"
                          item-text="text"
                          item-value="value"
                          :label="$t('Status')"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        v-if="pesquisaStatusPedidosMateriais"
                      >
                        <v-select
                          v-model="statusFinanceiro"
                          :items="[
                            { value: 'Pendente', text: $t('PENDENTE') },
                            { value: 'Em separação', text: $t('SEPARACAO') },
                            {
                              value: 'Disponibilizado',
                              text: $t('DISPONIBILIZADO'),
                            },
                            {
                              value: 'Retirado por terceiro',
                              text: $t('RETIRADOTERCEIRO'),
                            },
                            {
                              value: 'Material recebido',
                              text: $t('RECEBIDO'),
                            },
                            {
                              value: 'Entrega pendente de conferência',
                              text: $t('ENTREGAPENDENTE'),
                            },
                            {
                              value: 'Entrega total',
                              text: $t('ENTREGATOTAL'),
                            },
                            {
                              value: 'Entrega parcial',
                              text: $t('ENTREGAPARCIAL'),
                            },
                            { value: 'Cancelado', text: $t('CANCELADO') },
                            { value: '', text: $t('Todos') },
                          ]"
                          item-text="text"
                          item-value="value"
                          :label="$t('Status')"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>

                      <v-col cols="12" md="2" v-if="pesquisaStatusComum">
                        <v-select
                          v-model="statusComumFiltro"
                          :items="[
                            { value: 'ATIVO', text: $t('ATIVO') },
                            { value: 'INATIVO', text: $t('INATIVO') },
                            { value: '', text: $t('Todos') },
                          ]"
                          item-text="text"
                          item-value="value"
                          :label="$t('Status')"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>

                      <v-col
                        cols="12"
                        md="2"
                        v-if="pesquisaStatusPedidoUniforme"
                      >
                        <v-select
                          v-model="statusFinanceiro"
                          :items="[
                            { value: 'PENDENTE', text: $t('PENDENTE') },
                            { value: 'SEPARACAO', text: $t('SEPARACAO') },
                            {
                              value: 'DISPONIBILIZADO',
                              text: $t('DISPONIBILIZADO'),
                            },
                            { value: 'RETIRADO', text: $t('RETIRADO') },
                            { value: 'RECEBIDO', text: $t('RECEBIDO') },
                            {
                              value: 'DEVOLUCAOTOTAL',
                              text: $t('DEVOLUCAOTOTAL'),
                            },
                            {
                              value: 'DEVOLUCAOPARCIAL',
                              text: $t('DEVOLUCAOPARCIAL'),
                            },
                            { value: 'CANCELADO', text: $t('CANCELADO') },
                            { value: null, text: $t('Todos') },
                          ]"
                          item-text="text"
                          item-value="value"
                          :label="$t('Status')"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>

                      <v-col cols="12" md="2" v-if="pesquisaFaturado">
                        <v-select
                          v-model="faturado"
                          :items="[
                            { value: true, text: $t('PENDENTE') },
                            { value: false, text: $t('FATURADO') },
                            { value: null, text: $t('Todos') },
                          ]"
                          item-text="text"
                          item-value="value"
                          :label="$t('Status')"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>

                      <v-col cols="12" md="2" v-if="pesquisaValor">
                        <v-text-field-money
                          v-model="valorFinanceiro"
                          :disabled="loading"
                          v-bind:label="$t('Valor')"
                          v-bind:properties="{
                            prefix: 'R$',
                            readonly: false,
                            disabled: false,
                            outlined: false,
                            clearable: true,
                            rules: required,
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: '0',
                          }"
                        />
                      </v-col>

                      <v-col
                        cols="12"
                        md="2"
                        v-if="pesquisasituacaoMovimentacaoContaVinculada"
                      >
                        <v-select
                          v-model="situacaoMovimentacaoContaVinculada"
                          :items="[
                            { value: 'PENDENTE', text: $t('PENDENTE') },
                            { value: 'RESGATADO', text: $t('RESGATADO') },
                            {
                              value: 'CANCELADO',
                              text: $t('CANCELADO'),
                            },
                            { value: null, text: $t('Todos') },
                          ]"
                          item-text="text"
                          item-value="value"
                          :label="$t('Status')"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>

                      <v-col cols="12" md="3" v-if="pesquisaContaVinculada">
                        <v-autocomplete
                          :label="$t('contaVinculada')"
                          :disabled="loading"
                          chips
                          deletable-chips
                          v-model="contaVinculada"
                          return-object
                          :items="contasVinculada"
                          :item-text="
                            (item) => {
                              return item.descricao;
                            }
                          "
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" md="4" v-if="pesquisaContaBancaria">
                        <v-text-field
                          v-model="contaBancaria"
                          :label="$t('ContaBancaria')"
                          name="contaBancaria"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        >
                        </v-text-field>
                      </v-col>

                      <v-col
                        cols="12"
                        md="2"
                        v-if="pesquisaStatusAfastamentoSolicitacao"
                      >
                        <v-select
                          v-model="statusFinanceiro"
                          :items="[
                            { value: '1', text: $t('PENDENTE') },
                            { value: '2', text: $t('APROVADO') },
                            { value: '3', text: $t('RECUSADO') },
                            { value: '', text: $t('Todos') },
                          ]"
                          item-text="text"
                          item-value="value"
                          :label="$t('Status')"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="2" v-if="pesquisaStatusFuncionario">
                        <v-select
                          v-model="statusFuncionario"
                          :items="[
                            { value: '0', text: $t('PENDENTE') },
                            { value: '1', text: $t('PREENCHIDO') },
                            { value: '2', text: $t('APROVADA') },
                            { value: '3', text: $t('RECUSADA') },
                            { value: '', text: $t('Todos') },
                          ]"
                          item-text="text"
                          item-value="value"
                          :label="$t('Status Funcionário')"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        v-if="pesquisaStatusFuncionarioFiltro"
                      >
                        <v-select
                          v-model="dsStatusFuncionario"
                          :items="[
                            { value: 'ATIVO', text: $t('ATIVO') },
                            { value: 'FERIAS', text: $t('FERIAS') },
                            { value: 'AFASTADO', text: $t('AFASTADO') },
                            { value: 'DESLIGADO', text: $t('DESLIGADO') },
                            { value: '', text: $t('Todos') },
                          ]"
                          item-text="text"
                          item-value="value"
                          :label="$t('Status Funcionário')"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                        ></v-select>
                      </v-col>

                      <slot name="customFilters" :loading="loading"></slot>

                      <v-col
                        cols="12"
                        md="2"
                        id="exportar"
                        v-if="!buscaSimplificada"
                      >
                        <v-btn
                          @click="filtrar()"
                          :loading="loading"
                          id="btn--filtrar"
                          :ripple="false"
                          class="
                            ma-1
                            font-weight-bold
                            text-none
                            ms-auto
                            btn-primary
                            bg-gradient-primary
                            py-3
                            px-6
                            ms-3
                          "
                          height="39"
                        >
                          <v-icon left dark> ni-zoom-split-in </v-icon>
                          {{ $t("Filtrar") }}
                        </v-btn>
                      </v-col>

                      <v-col
                        v-if="
                          checkBoxForcarAtualizacao ||
                          btnAtualizarInquilino ||
                          btnAtualizarTodosInquilino
                        "
                        cols="12"
                        class="crud-cotacao-atualizacao"
                      >
                        <v-checkbox
                          v-if="checkBoxForcarAtualizacao"
                          v-model="forcarAtualizacao"
                          label="Forçar atualização"
                          :disabled="loading"
                          dense
                          hide-details
                          class="mt-0 pt-0"
                        />
                        <v-btn
                          v-if="btnAtualizarInquilino"
                          class="
                            font-weight-bold
                            text-none
                            btn-ls btn-secondary
                            bg-gradient-light
                            px-6
                          "
                          height="39"
                          :loading="loading"
                          :disabled="loading"
                          @click="atualizarInquilino"
                        >
                          <v-icon left>mdi-bank-refresh</v-icon>
                          Atualizar inquilino
                        </v-btn>
                        <v-btn
                          v-if="btnAtualizarTodosInquilino"
                          v-can="'ROLE_OperacaoMoedaCotacao_UpdateAll'"
                          class="
                            font-weight-bold
                            text-none
                            btn-ls btn-secondary
                            bg-gradient-light
                            px-6
                          "
                          height="39"
                          :loading="loading"
                          :disabled="loading"
                          @click="atualizarTodosInquilino"
                        >
                          <v-icon left>mdi-bank-refresh</v-icon>
                          Atualizar todos os inquilinos
                        </v-btn>
                      </v-col>

                      <slot name="customFilterActions"></slot>
                    </v-row>
                  </div>
                </div>
                <div
                  v-if="selectionEnabled"
                  class="px-4 pb-2 crud-selection-toolbar"
                >
                  <v-row class="align-center">
                    <v-col cols="12" md="5" class="d-flex align-center">
                      <span class="text-caption">
                        {{ selectedRows.length }} {{ $t("Itens_selecionados") }}
                      </span>
                      <span
                        v-if="selectedRows.length && hasBulkStatusActions"
                        class="text-caption ms-3"
                      >
                        {{ $t("Status") }}:
                        {{ bulkSelectedStatus ? $t(bulkSelectedStatus) : "-" }}
                      </span>
                      <span
                        v-if="bulkActionSelectionMessage"
                        class="text-caption text-warning ms-3"
                      >
                        {{ bulkActionSelectionMessage }}
                      </span>
                      <v-btn
                        text
                        small
                        class="text-none ms-2"
                        :disabled="
                          !selectedRows.length || loading || bulkActionLoading
                        "
                        @click="clearSelectedRows"
                      >
                        {{ $t("Limpar") }}
                      </v-btn>
                      <v-btn
                        v-if="!enableSelection && bulkDeleteModeActive"
                        text
                        small
                        class="text-none ms-2"
                        :disabled="loading || bulkActionLoading"
                        @click="encerrarDelecaoEmLote"
                      >
                        {{ $t("Cancelar") }}
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="12"
                      md="7"
                      class="d-flex flex-wrap justify-end align-center"
                    >
                      <template v-if="hasBulkActions">
                        <v-select
                          v-model="bulkActionSelected"
                          :items="bulkActionsDisponiveis"
                          item-text="text"
                          item-value="value"
                          :label="$t('Acoes')"
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                            mr-2
                          "
                          dense
                          flat
                          filled
                          solo
                          :disabled="bulkActionSelectDisabled"
                          style="max-width: 260px"
                        ></v-select>
                        <v-btn
                          :loading="bulkActionLoading"
                          :disabled="bulkActionDisabled"
                          height="39"
                          class="
                            ma-1
                            font-weight-bold
                            text-none
                            btn-primary
                            bg-gradient-primary
                            py-3
                            px-6
                            ms-3
                          "
                          @click="executarAcaoEmMassa"
                        >
                          <v-icon left dark> mdi-playlist-check </v-icon>
                          {{ $t("Confirmar") }}
                        </v-btn>
                      </template>
                      <v-btn
                        v-if="canDeleteSelection"
                        :loading="loading && delecaoEmLote"
                        :disabled="bulkDeleteDisabled"
                        height="39"
                        class="
                          ma-1
                          font-weight-bold
                          text-none
                          btn-primary
                          bg-gradient-primary
                          py-3
                          px-6
                          ms-3
                        "
                        @click="confirmaDeleteSelecionados"
                      >
                        <v-icon left dark> mdi-delete-sweep </v-icon>
                        {{ $t("Excluir") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
                <v-card-text class="px-0 py-0 crud-listagem-table-wrap">
                  <v-data-table
                    ref="tabelaPrincipal"
                    :headers="headersFiltrados"
                    :items="recursosTabela"
                    :search="tableSearch"
                    class="table crud-listagem-table"
                    :page.sync="tablePage"
                    hide-default-footer
                    @page-count="pageCount = $event"
                    :items-per-page="itemsPerPageTabela"
                    :mobile-breakpoint="mobileBreakpoint"
                    :show-expand="expandableProp"
                    :single-expand="singleExpandProp"
                    :item-key="itemKeyProp"
                    :show-select="selectionEnabled"
                    v-model="selectedRows"
                    :item-class="tableRowClass"
                    tabindex="0"
                    aria-keyshortcuts="ArrowUp ArrowDown Enter Control+E Space Control+A Meta+A"
                    @focus.native="ensureKeyboardActiveRow"
                    @current-items="handleCurrentItems"
                    @click:row="forwardTableRowClick"
                  >
                    <template
                      v-slot:[`item.pontoPermitirSenhaEquipamento`]="slotProps"
                    >
                      <slot
                        name="item.pontoPermitirSenhaEquipamento"
                        v-bind="slotProps"
                      >
                        {{
                          slotProps.item.pontoPermitirSenhaEquipamento === true
                            ? $t("sim")
                            : $t("nao")
                        }}
                      </slot>
                    </template>
                    <template v-slot:[`item.roteiro`]="slotProps">
                      <slot name="item.roteiro" v-bind="slotProps">
                        {{ slotProps.item.roteiro }}
                      </slot>
                    </template>
                    <template v-slot:[`item.servidorCategoria`]="slotProps">
                      <slot name="item.servidorCategoria" v-bind="slotProps">
                        {{
                          slotProps.item.servidorCategoria
                            ? $t(slotProps.item.servidorCategoria)
                            : ""
                        }}
                      </slot>
                    </template>
                    <template v-slot:[`item.statusResumo`]="slotProps">
                      <slot name="item.statusResumo" v-bind="slotProps">
                        {{ slotProps.item.statusResumo }}
                      </slot>
                    </template>
                    <template v-slot:[`item.valorEmbarcado`]="slotProps">
                      <slot name="item.valorEmbarcado" v-bind="slotProps">
                        {{ slotProps.item.valorEmbarcado }}
                      </slot>
                    </template>
                    <template v-slot:expanded-item="slotProps">
                      <slot name="expanded-item" v-bind="slotProps"></slot>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <slot name="item.actions-extra" :item="item"></slot>
                      <template v-if="isRowActionsAvailable(item)">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-can="
                                acaoPrincipalPermissao ||
                                'ROLE_' + nomeSingular + '_List'
                              "
                              v-bind="attrs"
                              v-on="on"
                              @click="openEditarModal(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              v-if="editar"
                              v-show="isEditAvailable(item)"
                              small
                              name="editBtn"
                              id="edit"
                              :aria-label="$t(acaoPrincipalTitulo)"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                              >{{ acaoPrincipalIcone }}</v-icon
                            >
                          </template>
                          <span>{{ $t(acaoPrincipalTitulo) }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="nomeSingular === 'FuncionarioPreContratracao'"
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="publicLinkBtn"
                              :aria-label="$t('Copiar_link_publico')"
                              @click="copiarLinkPreContratacao(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                              >ni-single-copy-04</v-icon
                            >
                          </template>
                          <span>{{ $t("Copiar_link_publico") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                nomeSingular ===
                                  'FuncionarioDocumentacaoAcessoria' &&
                                item.assinado
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="revogarAssinaturaLinkBtn"
                              :aria-label="$t('Gerar_link_revogacao_assinatura')"
                              v-can="
                                'ROLE_FuncionarioDocumentacaoAcessoria_Update'
                              "
                              @click="
                                gerarLinkRevogacaoAssinaturaDocumentacaoAcessoria(
                                  item,
                                )
                              "
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                              >mdi-link-variant-off</v-icon
                            >
                          </template>
                          <span>{{ $t("Gerar_link_revogacao_assinatura") }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                nomeSingular === 'FuncionarioPreContratracao' &&
                                item.status === 'PREENCHIDO'
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="aprovarBtn"
                              :aria-label="$t('Aprovar')"
                              v-can="'ROLE_' + nomeSingular + '_Aprovar'"
                              @click="openEditarModal(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              mdi-content-copy
                            </v-icon>
                          </template>
                          <span>{{ $t("Aprovar") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                nomeSingular !== 'ContaFinanceira' &&
                                isReplicateAvailable(item)
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="replicarBtn"
                              id="edit"
                              :aria-label="$t('Replicar')"
                              v-can="'ROLE_' + nomeSingular + '_Replicate'"
                              @click="confirmaReplicate(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              ni-curved-next
                            </v-icon>
                          </template>
                          <span>{{ $t("Replicar") }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="podeConfirmarMovimentacaoDiaria(item)"
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="confirmarPresenca"
                              id="confirmarPresenca"
                              :aria-label="$t('Confirmar_presenca')"
                              v-can="'ROLE_' + nomeSingular + '_Update'"
                              @click="confirmarMovimentacaoDiaria(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              ni-check-bold
                            </v-icon>
                          </template>
                          <span>{{ $t("Confirmar_presenca") }}</span>
                        </v-tooltip>

                        <v-tooltip
                          v-for="(action, actionIndex) in getCustomRowActions(
                            item,
                          )"
                          :key="getCustomRowActionKey(action, actionIndex)"
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-can="
                                action.permission ||
                                'ROLE_' + nomeSingular + '_List'
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              :aria-label="
                                $t(action.title || action.label || 'Acoes')
                              "
                              @click="executarCustomRowAction(action, item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              :color="action.color || '#67748e'"
                            >
                              {{ action.icon || "ni-curved-next" }}
                            </v-icon>
                          </template>
                          <span>{{
                            $t(action.title || action.label || "Acoes")
                          }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-can="'ROLE_' + nomeSingular + '_Delete'"
                              v-if="isDeleteAvailable(item)"
                              v-bind="attrs"
                              v-on="on"
                              small
                              :aria-label="$t('Excluir')"
                              name="deleteBtn"
                              @click="confirmaDelete(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>{{ $t("Excluir") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="isPrintAvailable(item)"
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="printBtn"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              :label="$t('Imprimir')"
                              :aria-label="$t('Imprimir')"
                              v-can="
                                permissaoPrint ||
                                'ROLE_' + nomeSingular + '_Print'
                              "
                              @click="printSingle(item.id, '')"
                              color="#67748e"
                              >mdi-printer-outline</v-icon
                            >
                          </template>
                          <span>{{ $t("Imprimir") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                item.documentoArquivo !== null &&
                                item.documentoArquivo !== undefined &&
                                item.documentoArquivo.length > 10
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="printBtn"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              :label="$t('Download')"
                              :aria-label="$t('Download')"
                              v-can="'ROLE_' + nomeSingular + '_List'"
                              @click="downloadDocumento(item.documentoArquivo)"
                              color="#67748e"
                              >ni-cloud-download-95</v-icon
                            >
                          </template>
                          <span>{{ $t("Download") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="isUploadAuditoriaAvailable(item)"
                              v-can="'ROLE_' + nomeSingular + '_Update'"
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="uploadAuditoriaBtn"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              :label="$t('Upload')"
                              :aria-label="$t('Upload')"
                              @click="uploadAuditoria(item)"
                              color="#67748e"
                              >mdi-cloud-upload-outline</v-icon
                            >
                          </template>
                          <span>{{ $t("Upload") }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                nomeSingular === 'ModeloDocumentacaoAcessoria'
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="disponibilizarBtn"
                              id="edit"
                              :aria-label="$t('Disponibilizar')"
                              v-can="'ROLE_' + nomeSingular + '_MakeEveryone'"
                              @click="confirmaDisponibilizacaoDocumento(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              ni-curved-next
                            </v-icon>
                          </template>
                          <span>{{ $t("Disponibilizar") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="etapaValidacaoAfastamento(item)"
                              v-bind="attrs"
                              v-on="on"
                              small
                              :name="
                                etapaValidacaoAfastamento(item) === 1
                                  ? 'validacaoAfastamento01Btn'
                                  : 'validacaoAfastamento02Btn'
                              "
                              :id="
                                etapaValidacaoAfastamento(item) === 1
                                  ? 'validacaoAfastamento01'
                                  : 'validacaoAfastamento02'
                              "
                              :aria-label="
                                etapaValidacaoAfastamento(item) === 1 &&
                                exigeValidacao02FuncionarioAfastamentoSolicitacao()
                                  ? $t('Validar_01')
                                  : $t('Validar_e_aprovar')
                              "
                              @click="
                                confirmaValidacaoFuncionarioAfastamento(item)
                              "
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              :color="
                                etapaValidacaoAfastamento(item) === 1
                                  ? 'primary'
                                  : 'success'
                              "
                            >
                              {{
                                etapaValidacaoAfastamento(item) === 1
                                  ? "mdi-clipboard-account"
                                  : "mdi-clipboard-check"
                              }}
                            </v-icon>
                          </template>
                          <span>{{
                            etapaValidacaoAfastamento(item) === 1 &&
                            exigeValidacao02FuncionarioAfastamentoSolicitacao()
                              ? $t("Validar_01")
                              : $t("Validar_e_aprovar")
                          }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                aprovacaoFuncionarioAfastamentoSolicitacaoBloqueada(
                                  item,
                                )
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="aprovacaoBloqueadaBtn"
                              id="aprovacaoBloqueada"
                              :aria-label="$t(etapaPendenteSolicitacao(item))"
                              v-can="'ROLE_' + nomeSingular + '_Aprovar'"
                              icon
                              disabled
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#9aa3b2"
                            >
                              mdi-lock-clock
                            </v-icon>
                          </template>
                          <span>{{ $t(etapaPendenteSolicitacao(item)) }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                (nomeSingular ===
                                  'FuncionarioAfastamentoSolicitacao' &&
                                  podeAprovarFuncionarioAfastamentoSolicitacao(
                                    item,
                                  )) ||
                                (nomeSingular === 'FuncionarioPontoSolicitacao' &&
                                  item.status === 'PENDENTE')
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="aprovarBtn"
                              id="edit"
                              :aria-label="
                                nomeSingular === 'FuncionarioPontoSolicitacao' &&
                                exigeValidacao02FuncionarioPontoSolicitacao()
                                  ? item.responsavelValidacao01
                                    ? $t('Validar_e_aprovar')
                                    : $t('Validar_01')
                                  : $t('Aprovar')
                              "
                              v-can="'ROLE_' + nomeSingular + '_Aprovar'"
                              @click="confirmaAprovacao(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              :color="
                                nomeSingular === 'FuncionarioPontoSolicitacao' &&
                                exigeValidacao02FuncionarioPontoSolicitacao()
                                  ? item.responsavelValidacao01
                                    ? 'success'
                                    : 'primary'
                                  : '#67748e'
                              "
                            >
                              {{
                                nomeSingular === "FuncionarioPontoSolicitacao" &&
                                exigeValidacao02FuncionarioPontoSolicitacao()
                                  ? "mdi-check-circle-outline"
                                  : "ni-curved-next"
                              }}
                            </v-icon>
                          </template>
                          <span>{{
                            nomeSingular === "FuncionarioPontoSolicitacao" &&
                            exigeValidacao02FuncionarioPontoSolicitacao()
                              ? item.responsavelValidacao01
                                ? $t("Validar_e_aprovar")
                                : $t("Validar_01")
                              : $t("Aprovar")
                          }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                nomeSingular === 'ContaVinculadaMovimentacao' &&
                                item.situacao === 'PENDENTE'
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="aprovarBtn"
                              id="edit"
                              :aria-label="$t('Aprovar')"
                              v-can="'ROLE_' + nomeSingular + '_Aprovar'"
                              @click="confirmaAprovacao(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              ni-curved-next
                            </v-icon>
                          </template>
                          <span>{{ $t("Aprovar") }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                nomeSingular === 'RoteiroTrajeto' &&
                                nomeSingular === 'Suprimento' &&
                                item.guias.length === 0
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="gerarGtv"
                              id="gerarGtv"
                              :aria-label="$t('Gerar_documento')"
                              @click="confirmaGeracaoDocumento(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              ni-single-copy-04
                            </v-icon>
                          </template>
                          <span>{{ $t("Gerar_documento") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                (nomeSingular === 'RoteiroTrajeto' ||
                                  nomeSingular === 'Suprimento') &&
                                item.guias.length > 0
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="gerarGtv"
                              id="gerarGtv"
                              :aria-label="$t('Imprimir')"
                              @click="listGuias(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              mdi-printer-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("Imprimir") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                (nomeSingular === 'TarefaExecucaoItem' ||
                                  nomeSingular === 'TarefaExecucaoPeriodo') &&
                                item.imobilizados.length > 0
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="gerarGtv"
                              id="gerarGtv"
                              :aria-label="$t('Imprimir')"
                              @click="listTarefaExecucaoItems(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              mdi-printer-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("Imprimir") }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                nomeSingular === 'RoteiroTrajeto' &&
                                possuiLogisticaTransporte()
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="EventosTv"
                              id="eventosTv"
                              :aria-label="$t('Eventos')"
                              @click="listEventosTv(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              ni-delivery-fast
                            </v-icon>
                          </template>
                          <span>{{ $t("Eventos") }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                nomeSingular === 'FaturamentoVariaveisServico' &&
                                item.periodicidade !== null &&
                                item.periodicidade !== undefined &&
                                !item.executado
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="registrarExecucaoBtn"
                              id="edit"
                              :aria-label="$t('Executar')"
                              v-can="'ROLE_' + nomeSingular + '_Update'"
                              @click="confirmaExecucaoServico(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              ni-check-bold
                            </v-icon>
                          </template>
                          <span>{{ $t("Executar") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                nomeSingular === 'RoteiroTrajeto' &&
                                item.statusAtendimento === 'PENDENTE' &&
                                !String(item.classificacao || '').startsWith(
                                  'TRANSBORDO',
                                )
                              "
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="transbordoBtn"
                              id="edit"
                              :aria-label="$t('Transbordo')"
                              v-can="'ROLE_' + nomeSingular + '_Transbordo'"
                              @click="confirmaTransbordo(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              ni-curved-next
                            </v-icon>
                          </template>
                          <span>{{ $t("Transbordo") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="isChangeTenantAvailable(item)"
                              v-can="'ROLE_' + nomeSingular + '_ChangeTenant'"
                              v-bind="attrs"
                              v-on="on"
                              @click="openChangeTenantModal(item)"
                              icon
                              elevation="0"
                              :ripple="false"
                              small
                              name="changeTenant"
                              id="edit"
                              :aria-label="$t('AlterarTenant')"
                              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                              color="#67748e"
                            >
                              ni-bold-right</v-icon
                            >
                          </template>
                          <span>{{ $t("AlterarTenant") }}</span>
                        </v-tooltip>
                      </template>
                    </template>
                    <template v-slot:no-data>
                      <v-alert :value="true" color="error" icon="mdi-alert">
                        {{ $t("Nenhum_dado_encontrado") }}
                      </v-alert>
                    </template>
                    <template v-slot:[`item.imagem`]="{ item }">
                      <ShowImage :url="item.imagem">
                        <v-avatar color="primary" size="50"
                          ><v-img
                            contain
                            max-height="151"
                            max-width="250"
                            :src="item.imagem"
                          ></v-img
                        ></v-avatar>
                      </ShowImage>
                    </template>
                    <template v-slot:[`item.imagem02`]="{ item }">
                      <ShowImage :url="item.imagem02">
                        <v-avatar color="primary" size="50"
                          ><v-img
                            contain
                            max-height="151"
                            max-width="250"
                            :src="item.imagem02"
                          ></v-img
                        ></v-avatar>
                      </ShowImage>
                    </template>
                    <template v-slot:[`item.email`]="{ item }">
                      {{ item.email }}
                    </template>
                    <template v-slot:[`item.tipo`]="{ item }">
                      {{ $t(item.tipo) }}
                    </template>
                    <template v-slot:[`item.tipoRoteiro`]="{ item }">
                      {{ item.tipoRoteiro ? $t(item.tipoRoteiro) : "-" }}
                    </template>
                    <template v-slot:[`item.tipoAtendimentoRoteiro`]="{ item }">
                      {{ $t(item.tipoAtendimentoRoteiro || "URBANO") }}
                    </template>
                    <template v-slot:[`item.tipoCliente`]="{ item }">
                      {{ $t(item.tipoCliente) }}
                    </template>
                    <template v-slot:[`item.padronizada`]="{ item }">
                      <span>{{
                        item.padronizada ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <!-- Formatações pra valores -->

                    <template v-slot:[`item.valor`]="{ item }">
                      <span>{{ item.valor | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.valorDoDesconto`]="{ item }">
                      <span>{{ item.valorDoDesconto | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.valorComDesconto`]="{ item }">
                      <span>{{
                        item.valorComDesconto | formatoMonetario
                      }}</span>
                    </template>
                    <template v-slot:[`item.saldoLogico`]="{ item }">
                      <span>{{ item.saldoLogico | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.saldoFisico`]="{ item }">
                      <span>{{ item.saldoFisico | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.horaCorte`]="{ item }">
                      <span>{{ item.horaCorte | horaParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.ultimaConexao`]="{ item }">
                      <span>{{
                        item.ultimaConexao | dataHoraParaLeitura
                      }}</span>
                    </template>
                    <template v-slot:[`item.valorTotal`]="{ item }">
                      <span>{{ item.valorTotal | formatoMonetario }}</span>
                    </template>

                    <template v-slot:[`item.statusConectividade`]="{ item }">
                      <span>{{ $t(item.statusConectividade) }}</span>
                    </template>

                    <template v-slot:[`item.faturado`]="{ item }">
                      <span>{{
                        item.faturado ? $t("FATURADO") : $t("PENDENTE")
                      }}</span>
                    </template>

                    <template v-slot:[`item.universal`]="{ item }">
                      <span>{{ item.universal ? $t("sim") : $t("nao") }}</span>
                    </template>

                    <template v-slot:[`item.servicoExtra`]="{ item }">
                      <span>{{
                        item.servicoExtra ? $t("sim") : $t("nao")
                      }}</span>
                    </template>

                    <template v-slot:[`item.confirmacaoAcionado`]="{ item }">
                      <span>{{
                        item.confirmacaoAcionado ? $t("sim") : $t("nao")
                      }}</span>
                    </template>

                    <template v-slot:[`item.confirmacaoPresenca`]="{ item }">
                      <span>{{
                        item.confirmacaoPresenca ? $t("sim") : $t("nao")
                      }}</span>
                    </template>

                    <template v-slot:[`item.saldo`]="{ item }">
                      <span v-if="item.saldo > 0">
                        {{ item.saldo | formatoMonetario }}
                      </span>
                      <span v-else style="color: red">{{
                        item.saldo | formatoMonetario
                      }}</span>
                    </template>

                    <template v-slot:[`item.situacao`]="{ item }">
                      {{ $t(item.situacao) }}
                    </template>

                    <template v-slot:[`item.statusComum`]="{ item }">
                      {{ $t(item.statusComum) }}
                    </template>

                    <template v-slot:[`item.tipoManutencao`]="{ item }">
                      {{ $t(item.tipoManutencao) }}
                    </template>

                    <template v-slot:[`item.status`]="{ item }">
                      <template
                        v-if="
                          nomeSingular ===
                            'FuncionarioAfastamentoSolicitacao' ||
                          nomeSingular === 'FuncionarioPontoSolicitacao'
                        "
                      >
                        <v-chip
                          small
                          label
                          :color="
                            item.status === 'APROVADO'
                              ? 'success'
                              : item.status === 'PENDENTE'
                              ? 'info'
                              : 'grey'
                          "
                          dark
                        >
                          {{ $t(item.status) }}
                        </v-chip>
                        <div
                          v-if="item.status === 'PENDENTE'"
                          class="text-caption mt-1"
                        >
                          {{ $t(etapaPendenteSolicitacao(item)) }}
                        </div>
                      </template>
                      <template v-else>{{ $t(item.status) }}</template>
                    </template>

                    <template v-slot:[`item.statusCobranca`]="{ item }">
                      <span>{{
                        item.statusCobranca ? $t(item.statusCobranca) : "-"
                      }}</span>
                    </template>

                    <template v-slot:[`item.erroCobranca`]="{ item }">
                      <v-tooltip
                        v-if="item.erroCobranca"
                        bottom
                        max-width="520"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            class="billing-error-cell"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon small color="error" class="mr-1">
                              mdi-alert-circle-outline
                            </v-icon>
                            {{ item.erroCobranca }}
                          </span>
                        </template>
                        <span>{{ item.erroCobranca }}</span>
                      </v-tooltip>
                      <span v-else>-</span>
                    </template>

                    <template v-slot:[`item.salarioBase`]="{ item }">
                      <span>{{ item.salarioBase | formatoMonetario }}</span>
                    </template>

                    <template v-slot:[`item.tipoContratacao`]="{ item }">
                      {{ $t(item.tipoContratacao) }}
                    </template>
                    <template v-slot:[`item.tipoProduto`]="{ item }">
                      {{ $t(item.tipoProduto) }}
                    </template>
                    <template v-slot:[`item.disponivel`]="{ item }">
                      <span>{{ item.disponivel ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.baseINSS`]="{ item }">
                      <span>{{ item.baseINSS ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.baseIRRF`]="{ item }">
                      <span>{{ item.baseIRRF ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.baseFGTS`]="{ item }">
                      <span>{{ item.baseFGTS ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.esocialAjustada`]="{ item }">
                      <span>{{
                        item.esocialAjustada ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.tipoImobilizado`]="{ item }">
                      {{ $t(item.tipoImobilizado) }}
                    </template>
                    <template v-slot:[`item.statusEstoque`]="{ item }">
                      {{ $t(item.statusEstoque) }}
                    </template>
                    <template v-slot:[`item.tipoTributacao`]="{ item }">
                      {{ $t(item.tipoTributacao) }}
                    </template>

                    <template v-slot:[`item.cpf`]="{ item }">
                      <span>{{ item.cpf | VMask("###.###.###-##") }}</span>
                    </template>
                    <template v-slot:[`item.disponivelApp`]="{ item }">
                      <span>{{
                        item.disponivelApp ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.opcaoSupervisor`]="{ item }">
                      <span>{{
                        item.opcaoSupervisor ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.limitesAfastamento`]="slotProps">
                      <slot name="item.limitesAfastamento" v-bind="slotProps" />
                    </template>
                    <template
                      v-slot:[`item.limitarRegistrosPeriodo`]="{ item }"
                    >
                      <span>{{
                        item.limitarRegistrosPeriodo ? $t("sim") : $t("nao")
                      }}</span>
                    </template>

                    <template v-slot:[`item.pessoa.cpf`]="{ item }">
                      <span>{{
                        item.pessoa.cpf | VMask("###.###.###-##")
                      }}</span>
                    </template>

                    <template v-slot:[`item.descricao`]="{ item }">
                      <div class="inline-edit-cell">
                        <template v-if="isInlineEditing(item, 'descricao')">
                          <v-textarea
                            v-model="inlineEdit.value"
                            class="
                              inline-edit-input inline-edit-input-description
                            "
                            rows="3"
                            auto-grow
                            no-resize
                            hide-details
                            @keydown.ctrl.enter.stop.prevent="
                              saveInlineEdit(item, 'descricao')
                            "
                            @keydown.esc.stop.prevent="cancelInlineEdit"
                          ></v-textarea>
                          <v-btn
                            icon
                            x-small
                            :loading="inlineEdit.loading"
                            :disabled="inlineEdit.loading"
                            @click.stop="saveInlineEdit(item, 'descricao')"
                          >
                            <v-icon small color="success">mdi-check</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            x-small
                            :disabled="inlineEdit.loading"
                            @click.stop="cancelInlineEdit"
                          >
                            <v-icon small color="error">mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <template v-else>
                          <span class="inline-edit-text">{{
                            getInlineDisplayValue(item, "descricao")
                          }}</span>
                          <v-btn
                            v-if="canEditInlineField('descricao')"
                            icon
                            x-small
                            class="inline-edit-trigger"
                            :disabled="loading || bulkActionLoading"
                            :title="$t('Editar')"
                            @click.stop="startInlineEdit(item, 'descricao')"
                          >
                            <v-icon small color="#67748e"
                              >ni-ruler-pencil</v-icon
                            >
                          </v-btn>
                        </template>
                      </div>
                    </template>

                    <template v-slot:[`item.detalhe`]="{ item }">
                      <div class="inline-edit-cell">
                        <template v-if="isInlineEditing(item, 'detalhe')">
                          <v-textarea
                            v-model="inlineEdit.value"
                            class="
                              inline-edit-input inline-edit-input-description
                            "
                            rows="3"
                            auto-grow
                            no-resize
                            hide-details
                            @keydown.ctrl.enter.stop.prevent="
                              saveInlineEdit(item, 'detalhe')
                            "
                            @keydown.esc.stop.prevent="cancelInlineEdit"
                          ></v-textarea>
                          <v-btn
                            icon
                            x-small
                            :loading="inlineEdit.loading"
                            :disabled="inlineEdit.loading"
                            @click.stop="saveInlineEdit(item, 'detalhe')"
                          >
                            <v-icon small color="success">mdi-check</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            x-small
                            :disabled="inlineEdit.loading"
                            @click.stop="cancelInlineEdit"
                          >
                            <v-icon small color="error">mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <template v-else>
                          <span class="inline-edit-text">{{
                            getInlineDisplayValue(item, "detalhe")
                          }}</span>
                          <v-btn
                            v-if="canEditInlineField('detalhe')"
                            icon
                            x-small
                            class="inline-edit-trigger"
                            :disabled="loading || bulkActionLoading"
                            :title="$t('Editar')"
                            @click.stop="startInlineEdit(item, 'detalhe')"
                          >
                            <v-icon small color="#67748e"
                              >ni-ruler-pencil</v-icon
                            >
                          </v-btn>
                        </template>
                      </div>
                    </template>

                    <template v-slot:[`item.vencimento`]="{ item }">
                      <div class="inline-edit-cell">
                        <template v-if="isInlineEditing(item, 'vencimento')">
                          <v-text-field
                            v-model="inlineEdit.value"
                            class="inline-edit-input inline-edit-input-date"
                            type="date"
                            dense
                            hide-details
                            @keydown.enter.stop.prevent="
                              saveInlineEdit(item, 'vencimento')
                            "
                            @keydown.esc.stop.prevent="cancelInlineEdit"
                          ></v-text-field>
                          <v-btn
                            icon
                            x-small
                            :loading="inlineEdit.loading"
                            :disabled="inlineEdit.loading"
                            @click.stop="saveInlineEdit(item, 'vencimento')"
                          >
                            <v-icon small color="success">mdi-check</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            x-small
                            :disabled="inlineEdit.loading"
                            @click.stop="cancelInlineEdit"
                          >
                            <v-icon small color="error">mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <template v-else>
                          <span class="inline-edit-text">{{
                            getInlineDisplayValue(item, "vencimento")
                          }}</span>
                          <v-btn
                            v-if="canEditInlineField('vencimento')"
                            icon
                            x-small
                            class="inline-edit-trigger"
                            :disabled="loading || bulkActionLoading"
                            :title="$t('Editar')"
                            @click.stop="startInlineEdit(item, 'vencimento')"
                          >
                            <v-icon small color="#67748e"
                              >ni-ruler-pencil</v-icon
                            >
                          </v-btn>
                        </template>
                      </div>
                    </template>

                    <template v-slot:[`item.previsaoCompensacao`]="{ item }">
                      <div class="inline-edit-cell">
                        <template
                          v-if="isInlineEditing(item, 'previsaoCompensacao')"
                        >
                          <v-text-field
                            v-model="inlineEdit.value"
                            class="inline-edit-input inline-edit-input-date"
                            type="date"
                            dense
                            hide-details
                            @keydown.enter.stop.prevent="
                              saveInlineEdit(item, 'previsaoCompensacao')
                            "
                            @keydown.esc.stop.prevent="cancelInlineEdit"
                          ></v-text-field>
                          <v-btn
                            icon
                            x-small
                            :loading="inlineEdit.loading"
                            :disabled="inlineEdit.loading"
                            @click.stop="
                              saveInlineEdit(item, 'previsaoCompensacao')
                            "
                          >
                            <v-icon small color="success">mdi-check</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            x-small
                            :disabled="inlineEdit.loading"
                            @click.stop="cancelInlineEdit"
                          >
                            <v-icon small color="error">mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <template v-else>
                          <span class="inline-edit-text">{{
                            getInlineDisplayValue(item, "previsaoCompensacao")
                          }}</span>
                          <v-btn
                            v-if="canEditInlineField('previsaoCompensacao')"
                            icon
                            x-small
                            class="inline-edit-trigger"
                            :disabled="loading || bulkActionLoading"
                            :title="$t('Editar')"
                            @click.stop="
                              startInlineEdit(item, 'previsaoCompensacao')
                            "
                          >
                            <v-icon small color="#67748e"
                              >ni-ruler-pencil</v-icon
                            >
                          </v-btn>
                        </template>
                      </div>
                    </template>

                    <template v-slot:[`item.dataEfetivacao`]="{ item }">
                      <span>{{ item.dataEfetivacao | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.dataInicio`]="{ item }">
                      <span>{{ item.dataInicio | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.dataTermino`]="{ item }">
                      <span>{{ item.dataTermino | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.dtAlteracao`]="{ item }">
                      <span>{{ item.dtAlteracao | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.dtInclusao`]="{ item }">
                      <span>{{ item.dtInclusao | dataParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.dtConclusao`]="{ item }">
                      <span>{{ item.dtConclusao | dataParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.dtAprovacao`]="{ item }">
                      <span>{{ item.dtAprovacao | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.dtUltimaColeta`]="{ item }">
                      <span>{{ item.dtUltimaColeta | dataParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.inicioVigencia`]="{ item }">
                      <span>{{ item.inicioVigencia | dataParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.finalVigencia`]="{ item }">
                      <span>{{ item.finalVigencia | dataParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.encerramentoVigencia`]="{ item }">
                      <span>{{
                        item.encerramentoVigencia | dataParaLeitura
                      }}</span>
                    </template>
                    <template v-slot:[`item.dataSolicitacao`]="{ item }">
                      <span>{{ item.dataSolicitacao | dataParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.competencia`]="{ item }">
                      <div class="inline-edit-cell">
                        <template v-if="isInlineEditing(item, 'competencia')">
                          <v-text-field
                            v-model="inlineEdit.value"
                            class="
                              inline-edit-input inline-edit-input-competencia
                            "
                            dense
                            hide-details
                            placeholder="MM/AAAA"
                            v-mask="'##/####'"
                            @keydown.enter.stop.prevent="
                              saveInlineEdit(item, 'competencia')
                            "
                            @keydown.esc.stop.prevent="cancelInlineEdit"
                          ></v-text-field>
                          <v-btn
                            icon
                            x-small
                            :loading="inlineEdit.loading"
                            :disabled="inlineEdit.loading"
                            @click.stop="saveInlineEdit(item, 'competencia')"
                          >
                            <v-icon small color="success">mdi-check</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            x-small
                            :disabled="inlineEdit.loading"
                            @click.stop="cancelInlineEdit"
                          >
                            <v-icon small color="error">mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <template v-else>
                          <span class="inline-edit-text">{{
                            getInlineDisplayValue(item, "competencia")
                          }}</span>
                          <v-btn
                            v-if="canEditInlineField('competencia')"
                            icon
                            x-small
                            class="inline-edit-trigger"
                            :disabled="loading || bulkActionLoading"
                            :title="$t('Editar')"
                            @click.stop="startInlineEdit(item, 'competencia')"
                          >
                            <v-icon small color="#67748e"
                              >ni-ruler-pencil</v-icon
                            >
                          </v-btn>
                        </template>
                      </div>
                    </template>
                    <template
                      v-slot:[`item.registroPagamento.dataEfetivacao`]="{
                        item,
                      }"
                    >
                      <span>{{
                        item.registroPagamento.dataEfetivacao | dataParaLeitura
                      }}</span>
                    </template>
                    <template
                      v-slot:[`item.registroRecebimento.dataEfetivacao`]="{
                        item,
                      }"
                    >
                      <span>{{
                        item.registroRecebimento.dataEfetivacao
                          | dataParaLeitura
                      }}</span>
                    </template>
                    <template v-slot:[`item.principal`]="{ item }">
                      <span>{{ item.principal ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.areaPrincipal`]="{ item }">
                      <span>{{
                        item.areaPrincipal ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.expedicao`]="{ item }">
                      <span>{{ item.expedicao ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.retencao`]="{ item }">
                      <span>{{ item.retencao ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.analitico`]="{ item }">
                      <span>{{ item.analitico ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.previsao`]="{ item }">
                      <span>{{ item.previsao ? $t("sim") : $t("nao") }}</span>
                    </template>

                    <template v-slot:[`item.notificarNovo`]="{ item }">
                      <span>{{
                        item.notificarNovo ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.ativo`]="{ item }">
                      <span>{{ item.ativo ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.enviarEmail`]="{ item }">
                      <span>{{
                        item.enviarEmail ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.telegramVinculado`]="{ item }">
                      <span>{{
                        item.telegramVinculado ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.emailVerificado`]="{ item }">
                      <span>{{
                        item.emailVerificado ? $t("sim") : $t("nao")
                      }}</span>
                    </template>

                    <template v-slot:[`item.emailValidado`]="{ item }">
                      <span>{{
                        item.emailValidado ? $t("sim") : $t("nao")
                      }}</span>
                    </template>

                    <template v-slot:[`item.emailRecusado`]="{ item }">
                      <span>{{
                        item.emailRecusado ? $t("sim") : $t("nao")
                      }}</span>
                    </template>

                    <template v-slot:[`item.escalaIntermitente`]="{ item }">
                      <span>{{
                        item.escalaIntermitente ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.presente`]="{ item }">
                      <span>{{ item.presente ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.manutencao`]="{ item }">
                      <span>{{ item.manutencao ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.feriadoBancario`]="{ item }">
                      <span>{{
                        item.feriadoBancario ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.folga`]="{ item }">
                      <span>{{ item.folga ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.feriado`]="{ item }">
                      <span>{{ item.feriado ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.utilizaCentroDeposito`]="{ item }">
                      <span>{{
                        item.utilizaCentroDeposito ? $t("sim") : $t("nao")
                      }}</span>
                    </template>

                    <template v-slot:[`item.jornadaTipoApuracao`]="{ item }">
                      <span>{{ item.jornadaTipoApuracao | capitalize }}</span>
                    </template>
                    <template v-slot:[`item.inicio`]="{ item }">
                      <span>{{ item.inicio | dataHoraParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.inicioPeriodo`]="{ item }">
                      <span>{{ item.inicioPeriodo | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.finalPeriodo`]="{ item }">
                      <span>{{ item.finalPeriodo | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.encerramento`]="{ item }">
                      <span>{{ item.encerramento | dataHoraParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.encerrado`]="{ item }">
                      <span>{{ $t(item.encerrado ? "sim" : "nao") }}</span>
                    </template>
                    <template v-slot:[`item.publicar`]="{ item }">
                      <span>{{ $t(item.publicar ? "sim" : "nao") }}</span>
                    </template>
                    <template v-slot:[`item.bloquearMovimentacao`]="{ item }">
                      <span>{{
                        $t(item.bloquearMovimentacao ? "sim" : "nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.inconsistencia`]="{ item }">
                      <span>{{ $t(item.inconsistencia ? "sim" : "nao") }}</span>
                    </template>

                    <template v-slot:[`item.nRegistro`]="{ item }">
                      <span v-if="item.nRegistro">{{
                        item.nRegistro
                          | VMask(
                            item.nRegistro.length > 11
                              ? $t("maskCNPJ")
                              : $t("maskCPF"),
                          )
                      }}</span>
                    </template>

                    <template v-slot:[`item.cliente.nRegistro`]="{ item }">
                      <span v-if="item.cliente.nRegistro">{{
                        item.cliente.nRegistro
                          | VMask(
                            item.cliente.nRegistro.length > 11
                              ? $t("maskCNPJ")
                              : $t("maskCPF"),
                          )
                      }}</span>
                    </template>

                    <template v-slot:[`item.data`]="{ item }">
                      {{ item.data | dataHoraParaLeitura }}
                    </template>

                    <template v-slot:[`item.statusPedido`]="{ item }">
                      {{ $t(item.statusPedido) }}
                    </template>

                    <template v-slot:[`item.dataPedido`]="{ item }">
                      <span>{{ item.dataPedido | dataParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.dataResgate`]="{ item }">
                      <span>{{ item.dataResgate | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.dataRetorno`]="{ item }">
                      <span>{{ item.dataRetorno | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.dataAquisicao`]="{ item }">
                      <span>{{ item.dataAquisicao | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.dataVencimento`]="{ item }">
                      <span>{{ item.dataVencimento | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.percentual`]="{ item }">
                      <span>{{ item.percentual | formatoPercentual }}</span>
                    </template>

                    <template v-slot:[`item.percentualBC`]="{ item }">
                      <span>{{ item.percentualBC | formatoPercentual }}</span>
                    </template>
                    <template v-slot:[`item.pIBSMun`]="{ item }">
                      <span>{{ item.pIBSMun | formatoPercentual }}</span>
                    </template>
                    <template v-slot:[`item.pCBS`]="{ item }">
                      <span>{{ item.pCBS | formatoPercentual }}</span>
                    </template>

                    <template v-slot:[`item.tipoApuracao`]="{ item }">
                      {{ $t(item.tipoApuracao) }}
                    </template>

                    <template v-slot:[`item.beneficioConvenio.tipo`]="{ item }">
                      {{ $t(item.beneficioConvenio.tipo) }}
                    </template>

                    <template v-slot:[`item.tipoFeriado`]="{ item }">
                      {{ $t(item.tipoFeriado) }}
                    </template>

                    <template v-slot:[`item.valorUnitario`]="{ item }">
                      <span>{{ item.valorUnitario | formatoMonetario }}</span>
                    </template>

                    <template v-slot:[`item.contaVinculada`]="{ item }">
                      <span>{{
                        item.contaVinculada ? $t("sim") : $t("nao")
                      }}</span>
                    </template>

                    <template v-slot:[`item.deducaoPisCofins`]="{ item }">
                      <span>{{
                        item.deducaoPisCofins ? $t("sim") : $t("nao")
                      }}</span>
                    </template>

                    <template v-slot:[`item.origemAvisoPrevio`]="{ item }">
                      {{ $t(item.origemAvisoPrevio) }}
                    </template>

                    <template v-slot:[`item.beneficioAvisoPrevio`]="{ item }">
                      {{ $t(item.beneficioAvisoPrevio) }}
                    </template>

                    <template v-slot:[`item.tipoServico`]="{ item }">
                      {{ $t(item.tipoServico) }}
                    </template>

                    <template v-slot:[`item.executado`]="{ item }">
                      <span>{{ item.executado ? $t("sim") : $t("nao") }}</span>
                    </template>

                    <template v-slot:[`item.dataAbertura`]="{ item }">
                      <span>{{ item.dataAbertura | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.tipoAvisoPrevio`]="{ item }">
                      {{ $t(item.tipoAvisoPrevio) }}
                    </template>
                    <template v-slot:[`item.classificacao`]="{ item }">
                      {{ $t(item.classificacao) }}
                    </template>
                    <template v-slot:[`item.statusRoteiro`]="{ item }">
                      {{ $t(item.statusRoteiro) }}
                    </template>
                    <template v-slot:[`item.valido`]="{ item }">
                      <span>{{ item.valido ? $t("sim") : $t("nao") }}</span>
                    </template>

                    <template v-slot:[`item.impressaoComCabecalho`]="{ item }">
                      <span>{{
                        item.impressaoComCabecalho ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.impressaoSemCabecalho`]="{ item }">
                      <span>{{
                        item.impressaoSemCabecalho ? $t("sim") : $t("nao")
                      }}</span>
                    </template>

                    <template v-slot:[`item.janelaOrigemInicio`]="{ item }">
                      <span>{{
                        item.janelaOrigemInicio | dataParaLeitura
                      }}</span>
                    </template>
                    <template v-slot:[`item.janelaOrigemFinal`]="{ item }">
                      <span>{{
                        item.janelaOrigemFinal | dataParaLeitura
                      }}</span>
                    </template>

                    <template v-slot:[`item.dataFechamento`]="{ item }">
                      <span>{{ item.dataFechamento | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.saldoDinheiro`]="{ item }">
                      <span>{{ item.saldoDinheiro | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.saldoDilacerado`]="{ item }">
                      <span>{{ item.saldoDilacerado | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.saldoCheques`]="{ item }">
                      <span>{{ item.saldoCheques | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.saldoMoedas`]="{ item }">
                      <span>{{ item.saldoMoedas | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.saldoProdutos`]="{ item }">
                      <span>{{ item.saldoProdutos | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.saldoTotal`]="{ item }">
                      <span>{{ item.saldoTotal | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.limiteSeguro`]="{ item }">
                      <span>{{ item.limiteSeguro | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.limitePico`]="{ item }">
                      <span>{{ item.limitePico | formatoMonetario }}</span>
                    </template>

                    <template v-slot:[`item.dataInclusao`]="{ item }">
                      <span>{{ item.dataInclusao | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.dataAlteracao`]="{ item }">
                      <span>{{ item.dataAlteracao | dataParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.janelaDestinoFinal`]="{ item }">
                      <span>{{
                        item.janelaDestinoFinal | dataParaLeitura
                      }}</span>
                    </template>
                    <template v-slot:[`item.janelaDestinoInicio`]="{ item }">
                      <span>{{
                        item.janelaDestinoInicio | dataParaLeitura
                      }}</span>
                    </template>
                    <template v-slot:[`item.previsaoAtendimento`]="{ item }">
                      {{ item.previsaoAtendimento | horaParaLeitura }}
                    </template>
                    <template v-slot:[`item.inicioAtendimento`]="{ item }">
                      {{ item.inicioAtendimento | horaParaLeitura }}
                    </template>
                    <template v-slot:[`item.finalAtendimento`]="{ item }">
                      {{ item.finalAtendimento | horaParaLeitura }}
                    </template>
                    <template v-slot:[`item.valorDeclarado`]="{ item }">
                      <span>{{ item.valorDeclarado | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.statusAtendimento`]="{ item }">
                      <div class="d-flex align-center">
                        <span>{{ $t(item.statusAtendimento) }}</span>
                        <v-chip
                          v-if="item.servicoAtrasado"
                          x-small
                          color="#F7981D"
                          dark
                          class="ml-2 text-uppercase font-weight-bold"
                        >
                          {{ $t("ATRASADO") }}
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:[`item.tipoEquipamento`]="{ item }">
                      {{ $t(item.tipoEquipamento) }}
                    </template>
                    <template v-slot:[`item.fabricante`]="{ item }">
                      {{ item.fabricante }}
                    </template>
                    <template v-slot:[`item.assinado`]="{ item }">
                      <span>{{ item.assinado ? $t("sim") : $t("nao") }}</span>
                    </template>
                    <template v-slot:[`item.solicitarAssinatura`]="{ item }">
                      <span>{{
                        item.solicitarAssinatura ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.tipoDocumentoFiscal`]="{ item }">
                      {{ $t(item.tipoDocumentoFiscal) }}
                    </template>
                    <template
                      v-slot:[`item.faturamentoDocumentoFiscal.dataEmissao`]="{
                        item,
                      }"
                    >
                      <span>{{
                        (item.faturamentoDocumentoFiscal != null
                          ? item.faturamentoDocumentoFiscal.dataEmissao
                          : null) | dataParaLeitura
                      }}</span>
                    </template>

                    <template v-slot:[`item.validoDe`]="{ item }">
                      <span>{{ item.validoDe | dataParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.validoAte`]="{ item }">
                      <span>{{ item.validoAte | dataParaLeitura }}</span>
                    </template>

                    <template v-slot:[`item.actionsPedidoMaterial`]="{ item }">
                      <v-icon
                        v-if="item.statusPedido === 'PENDENTE'"
                        small
                        name="separacaoBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Separar')"
                        :title="$t('Separar')"
                        v-can="'ROLE_' + nomeSingular + '_Separar'"
                        @click="confirmaSeparacao(item)"
                        color="#67748e"
                        >mdi-distribute-vertical-top</v-icon
                      >

                      <v-icon
                        small
                        v-if="item.statusPedido === 'SEPARACAO'"
                        name="DisponibilizarBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Disponibilizar')"
                        :title="$t('Disponibilizar')"
                        v-can="'ROLE_' + nomeSingular + '_Disponibilizar'"
                        @click="confirmaDisponibilizacao(item)"
                        color="#67748e"
                        >mdi-archive-arrow-up</v-icon
                      >

                      <v-icon
                        v-if="
                          item.statusPedido === 'PENDENTE' ||
                          item.statusPedido === 'SEPARACAO'
                        "
                        small
                        name="retiradaTerceiroBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Retirada_terceiro')"
                        :title="$t('Retirada_terceiro')"
                        v-can="'ROLE_' + nomeSingular + '_Terceiro'"
                        @click="confirmaRetiradoTerceiro(item)"
                        >mdi-archive-minus-outline</v-icon
                      >

                      <v-icon
                        v-if="item.statusPedido === 'DISPONIBILIZADO'"
                        small
                        name="receberBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Receber')"
                        :title="$t('Receber')"
                        v-can="'ROLE_' + nomeSingular + '_Retirar'"
                        @click="confirmaRecebimento(item)"
                        color="#67748e"
                        >mdi-call-received</v-icon
                      >

                      <v-icon
                        v-if="
                          item.statusPedido === 'RECEBIDO' ||
                          item.statusPedido === 'RETIRADOTERCEIRO'
                        "
                        small
                        name="entregaPendenteBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Entrega_pendente')"
                        :title="$t('Entrega_pendente')"
                        v-can="'ROLE_' + nomeSingular + '_Receber'"
                        @click="confirmaEntrega(item)"
                        color="#67748e"
                        >mdi-dolly</v-icon
                      >

                      <v-icon
                        v-if="
                          item.statusPedido === 'RECEBIDO' ||
                          item.statusPedido === 'ENTREGAPENDENTE'
                        "
                        small
                        name="entregaTotalBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Entrega_total')"
                        :title="$t('Entrega_total')"
                        v-can="'ROLE_' + nomeSingular + '_Receber'"
                        @click="confirmaEntregaTotal(item)"
                        color="#67748e"
                        >mdi-human-dolly</v-icon
                      >

                      <v-icon
                        v-if="
                          item.statusPedido === 'RECEBIDO' ||
                          item.statusPedido === 'ENTREGAPENDENTE' ||
                          item.statusPedido === 'ENTREGAPARCIAL'
                        "
                        small
                        name="entregaParcialBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Entrega_parcial')"
                        :title="$t('Entrega_parcial')"
                        v-can="'ROLE_' + nomeSingular + '_Receber'"
                        @click="recebimentoDetalhadoInf(item)"
                        color="#67748e"
                        >mdi-human-male-board-poll</v-icon
                      >

                      <v-icon
                        small
                        name="printBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Imprimir')"
                        :title="$t('Imprimir')"
                        v-can="'ROLE_' + nomeSingular + '_List'"
                        @click="printSingle(item.id, 'pedidoMaterial')"
                        color="#67748e"
                        >mdi-printer-outline</v-icon
                      >
                      <!-- <v-icon
              v-can="'ROLE_' + nomeSingular + '_Delete'"
              small
              name="deleteBtn"
              @click="confirmaDelete(item)"
              >ni-fat-remove</v-icon
            > -->
                    </template>

                    <template v-slot:[`item.actionsPedidoUniforme`]="{ item }">
                      <v-icon
                        v-if="
                          item.statusPedido === 'PENDENTE' &&
                          !removerFluxoEntregaSolicitacaoUniforme()
                        "
                        small
                        name="separacaoBtn"
                        :label="$t('Separar')"
                        :title="$t('Separar')"
                        v-can="'ROLE_' + nomeSingular + '_Separar'"
                        @click="confirmaSeparacao(item)"
                        elevation="1"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        >mdi-distribute-vertical-top</v-icon
                      >
                      <v-icon
                        v-if="
                          item.statusPedido === 'SEPARACAO' &&
                          !removerFluxoEntregaSolicitacaoUniforme()
                        "
                        small
                        name="DisponibilizarBtn"
                        :label="$t('Disponibilizar')"
                        :title="$t('Disponibilizar')"
                        v-can="'ROLE_' + nomeSingular + '_Disponibilizar'"
                        @click="confirmaDisponibilizacao(item)"
                        elevation="1"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        >mdi-archive-arrow-up</v-icon
                      >
                      <v-icon
                        v-if="
                          item.statusPedido === 'DISPONIBILIZADO' &&
                          !removerFluxoEntregaSolicitacaoUniforme()
                        "
                        small
                        name="retirarBtn"
                        :label="$t('Retirar')"
                        :title="$t('Retirar')"
                        v-can="'ROLE_' + nomeSingular + '_Retirar'"
                        @click="confirmaRetirada(item)"
                        elevation="1"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        >mdi-truck-cargo-container</v-icon
                      >
                      <v-icon
                        v-if="
                          item.statusPedido === 'RETIRADO' ||
                          (item.statusPedido === 'PENDENTE' &&
                            removerFluxoEntregaSolicitacaoUniforme())
                        "
                        small
                        name="receberBtn"
                        :label="$t('Receber')"
                        :title="$t('Receber')"
                        v-can="'ROLE_' + nomeSingular + '_Receber'"
                        @click="confirmaRecebimento(item)"
                        elevation="1"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        >mdi-call-received</v-icon
                      >
                      <v-icon
                        v-if="
                          item.statusPedido !== 'DEVOLUCAOTOTAL' &&
                          item.statusPedido !== 'DEVOLUCAOPARCIAL' &&
                          item.statusPedido !== 'PENDENTE' &&
                          item.statusPedido !== 'CANCELADO'
                        "
                        small
                        name="DisponibilizarBtn"
                        :label="$t('Troca')"
                        :title="$t('Troca')"
                        v-can="'ROLE_' + nomeSingular + '_Disponibilizar'"
                        @click="confirmaTroca(item)"
                        elevation="1"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        >mdi-find-replace</v-icon
                      >
                      <v-icon
                        v-if="item.statusPedido === 'RECEBIDO'"
                        small
                        name="entregaTotalBtn"
                        :label="$t('Devolucao_total')"
                        :title="$t('Devolucao_total')"
                        v-can="'ROLE_' + nomeSingular + '_Receber'"
                        @click="confirmaEntregaTotal(item)"
                        elevation="1"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        >mdi-human-dolly</v-icon
                      >
                      <v-icon
                        v-if="
                          item.statusPedido === 'RECEBIDO' ||
                          item.statusPedido === 'DEVOLUCAOPARCIAL'
                        "
                        small
                        name="entregaParcialBtn"
                        :label="$t('Devolucao_parcial')"
                        :title="$t('Devolucao_parcial')"
                        v-can="'ROLE_' + nomeSingular + '_Receber'"
                        @click="recebimentoDetalhadoInf(item)"
                        elevation="1"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        >mdi-human-male-board-poll</v-icon
                      >
                      <v-icon
                        small
                        name="printBtn"
                        :label="$t('Imprimir')"
                        :title="$t('Imprimir')"
                        v-can="'ROLE_' + nomeSingular + '_List'"
                        @click="printSingle(item.id, 'pedidoUniforme')"
                        elevation="1"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        >mdi-printer-outline</v-icon
                      >
                    </template>

                    <template
                      v-slot:[`item.actionsPedidoConsumivel`]="{ item }"
                    >
                      <v-icon
                        v-if="item.statusPedido === 'PENDENTE'"
                        small
                        name="separacaoBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Separar')"
                        :title="$t('Separar')"
                        v-can="'ROLE_' + nomeSingular + '_Separar'"
                        @click="confirmaSeparacao(item)"
                        color="#67748e"
                        >mdi-distribute-vertical-top</v-icon
                      >

                      <v-icon
                        v-if="item.statusPedido === 'SEPARACAO'"
                        small
                        name="DisponibilizarBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Disponibilizar')"
                        :title="$t('Disponibilizar')"
                        v-can="'ROLE_' + nomeSingular + '_Disponibilizar'"
                        @click="confirmaDisponibilizacao(item)"
                        color="#67748e"
                        >mdi-archive-arrow-up</v-icon
                      >

                      <v-icon
                        v-if="
                          item.statusPedido === 'DISPONIBILIZADO' ||
                          item.statusPedido === 'SEPARACAO'
                        "
                        small
                        name="receberBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Receber')"
                        :title="$t('Receber')"
                        v-can="'ROLE_' + nomeSingular + '_Retirar'"
                        @click="confirmaRecebimento(item)"
                        color="#67748e"
                        >mdi-call-received</v-icon
                      >

                      <v-icon
                        small
                        name="printBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Imprimir')"
                        :title="$t('Imprimir')"
                        v-can="'ROLE_' + nomeSingular + '_List'"
                        @click="printSingle(item.id, 'pedidoConsumivel')"
                        color="#67748e"
                        >mdi-printer-outline</v-icon
                      >

                      <v-icon
                        small
                        name="printBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Imprimir')"
                        :title="$t('Imprimir')"
                        v-can="'ROLE_' + nomeSingular + '_Value'"
                        @click="
                          printSingle(item.id, 'pedidoConsumivelCompleto')
                        "
                        color="#67748e"
                        >ni-money-coins</v-icon
                      >

                      <v-icon
                        v-if="
                          item.documentoFiscal !== null &&
                          ((item.documentoFiscal.statusDocumento !== 'RPS' &&
                            item.documentoFiscal.statusDocumento !==
                              'EMPROCESSAMENTO' &&
                            item.documentoFiscal.statusDocumento !==
                              'NAOAUTORIZADO') ||
                            item.documentoFiscal.faturamentoPracaFiscal
                              .tipoDocumentoFiscal === 'RECIBO')
                        "
                        small
                        :title="$t('Imprimir')"
                        v-can="'ROLE_FaturamentoDocumentoFiscal_List'"
                        @click="printDoc(item.documentoFiscal)"
                        color="#67748e"
                        class="btn-ls me-0.90 my-1 rounded-sm ma-1"
                        icon
                        elevation="0"
                        :ripple="false"
                        >mdi-printer-outline</v-icon
                      >
                      <v-icon
                        v-if="
                          item.documentoFiscal !== null &&
                          item.documentoFiscal.xml !== null
                        "
                        small
                        :title="$t('XML')"
                        v-can="'ROLE_FaturamentoDocumentoFiscal_List'"
                        @click="printXml(item.documentoFiscal)"
                        color="#67748e"
                        class="btn-ls me-0.90 my-1 rounded-sm ma-1"
                        icon
                        elevation="0"
                        :ripple="false"
                        >mdi-xml</v-icon
                      >
                      <v-icon
                        v-if="
                          item.documentoFiscal !== null &&
                          (item.documentoFiscal.statusDocumento === 'RPS' ||
                            item.documentoFiscal.statusDocumento ===
                              'NAOAUTORIZADO') &&
                          item.documentoFiscal.faturamentoPracaFiscal
                            .tipoDocumentoFiscal !== 'RECIBO'
                        "
                        small
                        id="gerarDoc"
                        :title="$t('Gerar_documento')"
                        v-can="'ROLE_FaturamentoDocumentoFiscal_List'"
                        @click="integrar(item.documentoFiscal)"
                        color="#67748e"
                        class="btn-ls me-0.90 my-1 rounded-sm ma-1"
                        icon
                        elevation="0"
                        :ripple="false"
                        >ni-spaceship</v-icon
                      >
                      <v-icon
                        small
                        v-if="
                          item.documentoFiscal !== null &&
                          (item.documentoFiscal.statusDocumento ===
                            'EMPROCESSAMENTO' ||
                            item.documentoFiscal.statusDocumento ===
                              'NAOAUTORIZADO' ||
                            (item.documentoFiscal.statusDocumento ===
                              'AUTORIZADO' &&
                              item.documentoFiscal.integradorEmissao ===
                                'PROPRIO' &&
                              item.documentoFiscal.faturamentoPracaFiscal
                                .tipoDocumentoFiscal === 'NFSE'))
                        "
                        :title="
                          item.documentoFiscal.statusDocumento === 'AUTORIZADO'
                            ? $t('Consultar_situacao_fiscal')
                            : $t('Consultar_documento')
                        "
                        v-can="'ROLE_FaturamentoDocumentoFiscal_List'"
                        @click="consultar(item.documentoFiscal)"
                        color="#67748e"
                        class="btn-ls me-0.90 my-1 rounded-sm ma-1"
                        icon
                        elevation="0"
                        :ripple="false"
                        >ni-paper-diploma</v-icon
                      >
                      <!-- <v-icon
              v-can="'ROLE_' + nomeSingular + '_Delete'"
              small
              name="deleteBtn"
              @click="confirmaDelete(item)"
              >ni-fat-remove</v-icon
            > -->
                    </template>

                    <template
                      v-slot:[`item.actionsMovimentacaoMaterial`]="{ item }"
                    >
                      <v-icon
                        v-if="item.statusPedido === 'PENDENTE'"
                        small
                        name="DisponibilizarBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Disponibilizar')"
                        :title="$t('Disponibilizar')"
                        v-can="'ROLE_' + nomeSingular + '_Disponibilizar'"
                        @click="confirmaDisponibilizacao(item)"
                        color="#67748e"
                        >mdi-archive-arrow-up</v-icon
                      >

                      <v-icon
                        v-if="
                          item.statusPedido === 'PENDENTE' ||
                          item.statusPedido === 'DISPONIBILIZADO'
                        "
                        small
                        name="retirarBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Receber')"
                        :title="$t('Receber')"
                        v-can="'ROLE_' + nomeSingular + '_Retirar'"
                        @click="confirmaRecebimento(item)"
                        color="#67748e"
                        >mdi-call-received</v-icon
                      >

                      <v-icon
                        v-if="
                          item.statusPedido === 'RETIRADO' ||
                          item.statusPedido === 'RETIRADOCLIENTE'
                        "
                        small
                        name="ReceberBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Receber')"
                        :title="$t('Receber')"
                        v-can="'ROLE_' + nomeSingular + '_Receber'"
                        @click="confirmaEntregaTotal(item)"
                        color="#67748e"
                        >mdi-human-dolly</v-icon
                      >

                      <v-icon
                        small
                        name="printBtn"
                        class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
                        :label="$t('Imprimir')"
                        :title="$t('Imprimir')"
                        v-can="'ROLE_' + nomeSingular + '_List'"
                        @click="printSingle(item.id, 'movimentacaoImobilizado')"
                        color="#67748e"
                        >mdi-printer-outline</v-icon
                      >
                      <!-- <v-icon
              v-can="'ROLE_' + nomeSingular + '_Delete'"
              small
              name="deleteBtn"
              @click="confirmaDelete(item)"
              >ni-fat-remove</v-icon
            > -->
                    </template>
                    <template v-slot:[`item.validacao01`]="{ item }">
                      <span>{{
                        item.validacao01 ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template v-slot:[`item.validacao02`]="{ item }">
                      <span>{{
                        item.validacao02 ? $t("sim") : $t("nao")
                      }}</span>
                    </template>
                    <template
                      v-slot:[`item.actionsRegistrosFinanceiroValidacao`]="{
                        item,
                      }"
                    >
                      <v-icon
                        v-if="item.validacao01 !== null && !item.validacao01"
                        small
                        name="validacao01"
                        :label="$t('Validar')"
                        :title="$t('Validar')"
                        v-can="'ROLE_' + nomeSingular + '_Validation01'"
                        @click="confirmaValidacaoFinanceira01(item)"
                        elevation="1"
                        class="ma-1 btn-ls me-1 my-1 rounded-sm"
                        color="#67748e"
                        >mdi-clipboard-account</v-icon
                      >
                      <v-icon
                        v-if="
                          item.validacao01 !== null &&
                          item.validacao02 !== null &&
                          item.validacao01 &&
                          !item.validacao02
                        "
                        small
                        name="validacao02"
                        :label="$t('Validar')"
                        :title="$t('Validar')"
                        v-can="'ROLE_' + nomeSingular + '_Validation02'"
                        @click="confirmaValidacaoFinanceira02(item)"
                        elevation="1"
                        class="ma-1 btn-ls me-1 my-1 rounded-sm"
                        color="#67748e"
                        >mdi-clipboard-check</v-icon
                      >
                    </template>
                    <template
                      v-slot:[`item.janelaAtendimentoInicio`]="{ item }"
                    >
                      {{ item.janelaAtendimentoInicio | dataHoraParaLeitura }}
                    </template>
                    <template v-slot:[`item.janelaAtendimentoFinal`]="{ item }">
                      {{ item.janelaAtendimentoFinal | dataHoraParaLeitura }}
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-card-actions class="card-padding crud-listagem-footer">
                  <v-row class="align-center pagination-footer-row">
                    <v-col
                      cols="12"
                      md="7"
                      lg="6"
                      class="d-flex flex-wrap align-center pagination-toolbar"
                    >
                      <span class="text-body me-3"
                        >{{ $t("Itens_por_pagina") }}:</span
                      >
                      <v-select
                        v-model="pageSize"
                        :items="pageSizes"
                        @change="handlePageSizeChange"
                        :disabled="
                          loading ||
                          (this.isSearching &&
                            !isBuscaSimplificadaPaginadaAtiva &&
                            !buscaParametrizadaPaginada)
                        "
                        hide-details
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                          pagination-page-size
                        "
                        dense
                        flat
                        filled
                        solo
                      ></v-select>
                      <v-menu
                        v-model="ordenacaoMenu"
                        offset-y
                        :close-on-content-click="false"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-badge
                            :content="sortFields.length"
                            :value="sortFields.length"
                            color="#516a78"
                            overlap
                          >
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!camposOrdenacao.length || loading"
                              height="39"
                              class="
                                ma-1
                                font-weight-bold
                                text-none
                                btn-ls btn-secondary
                                bg-gradient-light
                                py-3
                                px-4
                              "
                            >
                              <v-icon left> mdi-sort </v-icon>
                              {{ $t("Ordenacao") }}
                            </v-btn>
                          </v-badge>
                        </template>
                        <v-card class="ordenacao-menu">
                          <v-card-title class="py-3 text-subtitle-2">
                            {{ $t("Ordenacao") }}
                          </v-card-title>
                          <v-card-text class="pb-0">
                            <v-autocomplete
                              v-model="sortFieldSelecionado"
                              :items="camposOrdenacao"
                              item-text="text"
                              item-value="value"
                              :label="$t('Campos')"
                              clearable
                              hide-details
                              class="
                                input-style
                                font-size-input
                                text-light-input
                                placeholder-light
                                input-icon
                              "
                              dense
                              flat
                              filled
                              solo
                              @change="handleSortFieldsChange"
                            ></v-autocomplete>
                            <v-select
                              v-model="direction"
                              :items="directions"
                              item-text="text"
                              item-value="value"
                              :label="$t('Direcao')"
                              :disabled="!sortFields.length"
                              hide-details
                              class="
                                input-style
                                font-size-input
                                text-light-input
                                placeholder-light
                                input-icon
                                mt-3
                              "
                              dense
                              flat
                              filled
                              solo
                              @change="handleDirectionChange"
                            ></v-select>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              text
                              small
                              class="text-none"
                              :disabled="!sortFields.length"
                              @click="limparOrdenacao"
                            >
                              {{ $t("Limpar") }}
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="
                                font-weight-bold
                                text-none
                                btn-primary
                                bg-gradient-primary
                                px-4
                              "
                              @click="confirmarOrdenacao"
                            >
                              {{ $t("Confirmar") }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                      lg="6"
                      class="ml-auto d-flex justify-end pagination-wrapper"
                    >
                      <v-pagination
                        prev-icon="fa fa-angle-left"
                        next-icon="fa fa-angle-right"
                        class="pagination"
                        color="#516a78ee"
                        v-model="page"
                        :length="totalPages"
                        @input="handlePageChange"
                        :disabled="paginacaoDesabilitada"
                        circle
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </div> </template></v-col
      ></v-row>
    </v-container>
  </div>
</template>

<script>
import CrudKeyboardShortcutsDialog from "@/components/base/Crud/CrudKeyboardShortcutsDialog.vue";
import CrudSearchFieldDialog from "@/components/base/Crud/CrudSearchFieldDialog.vue";
import BotaoTutorial from "@/components/tutorials/BotaoTutorial.vue";
import CampoHorario from "@/components/base/proprios/CampoHorario.vue";
import CardMapaGoogle from "@/components/base/proprios/CardMapaGoogle";
import ShowImage from "@/components/base/proprios/ShowImage";
import ExpandedRoteiro from "@/components/operacoes/roteiros/ExpandedRoteiro";
import { componentPaths } from "@/router/componentPaths";

import ComumDataService from "@/services/ComumDataService";
import {
  activateControl,
  consumeKeyboardEvent,
  focusControl,
  getCrudSearchControlLabel,
  getCrudSearchControls,
  getTopActiveDialog,
  isCrudSearchShortcut,
  isEditableKeyboardTarget,
  isElementVisible,
  isKeyboardScopeActive,
} from "@/utils/crudKeyboard";
import {
  integracaoFiscalRejeitada,
  mensagemErroIntegracaoFiscal,
} from "@/utils/fiscalIntegrationErrors";
import { coletarItensPaginados } from "@/utils/listagemImpressaoPaginada";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import * as XLSX from "xlsx";

const currencyMask = createNumberMask({
  prefix: "R$",
  allowDecimal: true,
  includeThousandsSeparator: true,
  allowNegative: false,
});

function normalizeIdentity(value) {
  if (value === null || typeof value === "undefined") return "";
  return String(value);
}

function isTenantChangeInProgress() {
  return (
    typeof window !== "undefined" &&
    window.__cajupeTenantChangeInProgress === true
  );
}

export default {
  name: "ListagemBase",
  components: {
    ImportacaoExcelLote: () =>
      import("@/components/base/Crud/ImportacaoExcelLote.vue"),
    CardMapaGoogle,
    CrudKeyboardShortcutsDialog,
    CrudSearchFieldDialog,
    BotaoTutorial,
    ShowImage,
    ExpandedRoteiro,
    CampoHorario,
  },
  props: {
    consultaPaginada: { type: Object, default: null },
    nomePlural: { type: String, required: true },
    nomeSingular: { type: String, required: true },
    importacaoExcel: { type: Object, default: null },
    atualizacaoExcel: { type: Object, default: null },
    headers: { type: Array, required: true },
    camposOrdenacaoProp: { type: Array, default: null },
    isReport: { type: Boolean, default: false },
    filtrosIniciais: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    ocultarCabecalhoListagem: {
      type: Boolean,
      required: false,
      default: false,
    },
    keyboardShortcutsEnabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    mobileBreakpoint: {
      type: [Number, String],
      required: false,
      default: 600,
    },
    modoSelecaoRecurso: {
      type: Boolean,
      required: false,
      default: false,
    },

    //Props para alterações específicas ao caso
    stringCadastro: { type: String, required: false, default: "novo_cadastro" },
    caixaLegenda: { type: Boolean, required: false, default: true },
    expandableProp: { type: Boolean, required: false, default: false },
    singleExpandProp: { type: Boolean, required: false, default: false },
    itemKeyProp: { type: String, required: false, default: "id" },
    exclusaoSolicitarMotivo: { type: Boolean, required: false, default: false },
    buscaSimplificada: { type: Boolean, required: false, default: true },
    buscaSimplificadaPaginada: {
      type: Boolean,
      required: false,
      default: true,
    },
    buscaSimplificadaDebounceMs: {
      type: Number,
      required: false,
      default: 750,
    },
    buscaSimplificadaPageSize: {
      type: Number,
      required: false,
      default: 100,
    },
    buscaSimplificadaConcorrencia: {
      type: Number,
      required: false,
      default: 2,
    },
    buscaParametrizadaPaginada: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaVencimento: { type: Boolean, required: false, default: false },
    pesquisaPeriodo: { type: Boolean, required: false, default: false },
    pesquisaCpfCnpj: { type: Boolean, required: false, default: false },
    pesquisaDetalhe: { type: Boolean, required: false, default: false },
    pesquisaTitulo: { type: Boolean, required: false, default: false },
    pesquisaCentroDeCusto: { type: Boolean, required: false, default: false },
    pesquisaContaFinanceira: { type: Boolean, required: false, default: false },
    pesquisaContaVinculada: { type: Boolean, required: false, default: false },
    pesquisasituacaoMovimentacaoContaVinculada: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaFornecedor: { type: Boolean, required: false, default: false },
    pesquisaCliente: { type: Boolean, required: false, default: false },
    pesquisaClienteLike: { type: Boolean, required: false, default: false },
    pesquisaValor: { type: Boolean, required: false, default: false },
    pesquisaFaturado: { type: Boolean, required: false, default: false },
    pesquisaStatusFinanceiro: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaStatusSolicitacaoConsumivel: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaStatusPedidosMateriais: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaStatusComum: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaFuncionario: { type: Boolean, required: false, default: false },
    pesquisaBeneficioConvenio: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaMoedas: {
      type: Boolean,
      required: false,
      default: false,
    },
    checkBoxForcarAtualizacao: {
      type: Boolean,
      required: false,
      default: false,
    },
    btnAtualizarInquilino: {
      type: Boolean,
      required: false,
      default: false,
    },
    btnAtualizarTodosInquilino: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaProvedor: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaStatusPedidoUniforme: {
      type: Boolean,
      required: false,
      default: false,
    },

    pesquisaNome: { type: Boolean, required: false, default: false },
    pesquisaNomeCpf: { type: Boolean, required: false, default: false },
    pesquisaNomeFuncionario: { type: Boolean, required: false, default: false },
    pesquisaMatricula: { type: Boolean, required: false, default: false },
    pesquisaID: { type: Boolean, required: false, default: false },
    pesquisaPostoTrabalhoLike: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaRegistradorLike: {
      type: Boolean,
      required: false,
      default: false,
    },
    filtrosGenericosString: { type: Array, required: false, default: () => [] },
    filtrosGenericosNumericos: { type: Array, required: false, default: () => [] },
    pesquisaPostoTrabalho: { type: Boolean, required: false, default: false },
    pesquisaPostoTrabalhoLivroOcorre: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaData: { type: Boolean, required: false, default: false },
    pesquisaStatusFuncionario: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaStatusFuncionarioFiltro: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaPessoa: { type: Boolean, required: false, default: false },
    pesquisaCompetencia: { type: Boolean, required: false, default: false },
    pesquisaDataAtualTv: { type: Boolean, required: false, default: false },
    pesquisaDataSeguinteTv: { type: Boolean, required: false, default: false },
    persistDateFilterKey: { type: String, required: false, default: "" },
    pesquisaContaBancaria: { type: Boolean, required: false, default: false },
    pesquisaDescricao: { type: Boolean, required: false, default: false },
    pesquisaIdentificador: { type: Boolean, required: false, default: false },
    pesquisaTipoVisualizacaoEmpresa: {
      type: Boolean,
      required: false,
      default: false,
    },
    pesquisaStatusAfastamentoSolicitacao: {
      type: Boolean,
      required: false,
      default: false,
    },
    atualizarDadosAoEditar: {
      type: Boolean,
      required: false,
      default: true,
    },
    recarregarDadosAoEditar: {
      type: Boolean,
      required: false,
      default: false,
    },
    opcoesLegenda: {
      type: Array,
      required: false,
      default() {
        return [
          { text: "Ativo", color: "green" },
          { text: "Inativo", color: "red" },
        ];
      },
    },
    editar: { type: Boolean, required: false, default: true },
    acaoPrincipalPermissao: {
      type: String,
      required: false,
      default: null,
    },
    acaoPrincipalIcone: {
      type: String,
      required: false,
      default: "ni-ruler-pencil",
    },
    acaoPrincipalTitulo: {
      type: String,
      required: false,
      default: "Editar",
    },
    editDisponivel: {
      type: Function,
      required: false,
      default: null,
    },
    deleteDisponivel: {
      type: Function,
      required: false,
      default: null,
    },
    replicarDisponivel: {
      type: Function,
      required: false,
      default: null,
    },
    customRowActions: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    permissaoPrint: {
      type: String,
      required: false,
      default: null,
    },
    printDisponivel: {
      type: Function,
      required: false,
      default: null,
    },
    alterarTenantDisponivel: {
      type: Function,
      required: false,
      default: null,
    },
    // Falso para a linha esconder as ações padrão (o slot item.actions-extra continua).
    acoesDisponiveis: {
      type: Function,
      required: false,
      default: null,
    },
    customFilterPayload: {
      type: Function,
      required: false,
      default: null,
    },
    customFiltersAtivos: {
      type: Function,
      required: false,
      default: null,
    },
    botaoCadastro: { type: Boolean, required: false, default: true },
    exportacaoListagem: { type: Boolean, required: false, default: true },
    botaoTransferenciaEmpresaFuncionario: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Arquivo .txt da integração de folha Dexion; os cadastros usam importacaoExcel.
    botaoImportDexion: {
      type: Boolean,
      required: false,
      default: false,
    },
    botaoImportContaContabil: {
      type: Boolean,
      required: false,
      default: false,
    },
    botaoGerarRoteiroModelo: { type: Boolean, required: false, default: false },
    enableSelection: { type: Boolean, required: false, default: false },
    bulkDeleteEnabled: { type: Boolean, required: false, default: true },
    bulkActions: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    bulkActionStatusField: {
      type: String,
      required: false,
      default: "statusPedido",
    },
    atualizarLocalAposAcao: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  provide() {
    return {
      closeCrudDialog: (mode) => {
        if (mode === "edit") {
          this.closeEditarModal();
          return;
        }

        this.closeInsertModal();
      },
    };
  },

  data() {
    return {
      dialogInsert: false,
      dialogEdit: false,
      crudModalLoading: {
        edit: false,
        insert: false,
      },
      crudModalLoadId: {
        edit: 0,
        insert: 0,
      },

      dialogSuccesEdit: false,
      dialogSuccesInsert: false,

      currentItem: {},
      recursoAtual: { id: 0 },
      editComponent: null,
      insertComponent: null,
      crudComponentCache: {},
      crudComponentPromiseCache: {},
      crudComponentPreloadTimer: null,
      crudComponentPreloadTimerType: null,
      lowerCaseComponentPaths: [],
      nomeSingularCadastroOverride: null,

      mask: currencyMask,
      //Recursos
      recursos: [],
      errors: [],
      //Modais
      confirmar: false,
      confirmarReplicar: false,
      confirmarDisponibilizacaoDocumento: false,
      objetoAtual: {},
      deletado: false,
      deletadoQuantidade: 0,
      deletadoEmCascata: 0,
      delecaoEmLote: false,
      bulkDeleteModeActive: false,
      exclusaoMotivo: "",
      exclusaoOpcoes: {},
      recebimentoDetalhado: false,
      formChangeProdutoPedido: false,
      quantidadeDevolvida: 0,

      quantidadePendente: 0,
      previsao: false,
      confirmarQuantidadeDesabilitarBotao: false,
      confirmarSeparacao: false,
      confirmarDisponibilizacao: false,
      confirmarTroca: false,
      confirmarRetiradoTerceiro: false,
      confirmarEntrega: false,
      confirmarRecebimento: false,
      confirmarEntregaTotal: false,
      confirmarRetirada: false,
      statusFinanceiro: "",
      statusFuncionario: "",
      dsStatusFuncionario: "ATIVO",
      statusComumFiltro: "ATIVO",
      valorTitulosQuitados: null,
      valorTitulosPendentes: null,
      valorTitulosVencidos: null,
      keyModal: 0,
      quantidadePedidosPendentes: 0,
      pedidosPendentes: [],
      modalPedidosPendentes: false,
      modalSolicitacoesTarefaPendente: false,
      pedidoAtual: {
        origem: { descricao: "", cidade: { nome: "", estado: { sigla: "" } } },
        destino: { descricao: "", cidade: { nome: "", estado: { sigla: "" } } },
        local: { descricao: "", cidade: { nome: "", estado: { sigla: "" } } },
      },
      roteirosDisponiveis: [],
      imobilizadosDisponiveis: [],
      modalRoteirizarPedido: false,
      modalRoteirizarTarefaSolicitacao: false,
      selectedImobilizados: [],
      searchImobilizado: "",
      novoTrajeto: {
        previsaoAtendimentoOrigem: "",
        previsaoAtendimentoDestino: "",
        roteiro: { id: 0 },
        roteiroId: 0,
      },
      modalGerarRoteiroModelo: false,

      modalEventosTv: false,
      modalEventoTv: false,
      eventosTv: [],
      eventosTvOpcoes: [],
      eventoTvAtual: {
        evento: {},
        ocorrencia: {},
        data: "",
        detalhes: "",
      },

      modalOcorrenciasTv: false,
      modalNovoOcorrenciaTv: false,
      ocorrenciasTv: [],
      ocorrenciasTvOpcoes: [],
      ocorrenciaTvAtual: {},

      componentId: 0,

      roteiroModelo: { id: 0 },
      roteiroModelos: [],
      headerPedidos: [
        // { text: this.$t("Data"), value: "data", sortable: "false" },
        // { text: this.$t("Status"), value: "statusPedido", sortable: "false" },
        {
          text: this.$t("Classificacao"),
          value: "classificacao",
          sortable: "false",
        },
        {
          text: this.$t("Cliente"),
          value: "cliente.fantasia",
          sortable: "false",
        },
        {
          text: this.$t("Origem"),
          value: "origem.descricao",
          sortable: "false",
        },
        {
          text: this.$t("Cidade"),
          value: "origemCidadeUf",
          sortable: "false",
        },
        {
          text: this.$t("Bairro"),
          value: "origem.bairro",
          sortable: "false",
        },
        {
          text: this.$t("janelaOrigemInicio"),
          value: "janelaOrigemInicio",
          sortable: "false",
        },
        {
          text: this.$t("janelaOrigemFinal"),
          value: "janelaOrigemFinal",
          sortable: "false",
        },

        {
          text: this.$t("Destino"),
          value: "destino.descricao",
          sortable: "false",
        },
        {
          text: this.$t("Cidade"),
          value: "destinoCidadeUf",
          sortable: "false",
        },
        {
          text: this.$t("Bairro"),
          value: "destino.bairro",
          sortable: "false",
        },
        {
          text: this.$t("janelaDestinoInicio"),
          value: "janelaDestinoInicio",
          sortable: "false",
        },
        {
          text: this.$t("janelaDestinoFinal"),
          value: "janelaDestinoFinal",
          sortable: "false",
        },
        {
          text: this.$t("Valor_total"),
          value: "valorTotal",
          sortable: "false",
        },

        { text: this.$t("Acoes"), value: "actionsPedidos", sortable: "false" },
      ],

      headerTarefaSolicitacao: [
        // { text: this.$t("Data"), value: "data", sortable: "false" },
        // { text: this.$t("Status"), value: "statusPedido", sortable: "false" },
        {
          text: this.$t("Classificacao"),
          value: "tarefaClassificacao.descricao",
          sortable: "false",
        },
        {
          text: this.$t("Cliente"),
          value: "cliente.fantasia",
          sortable: "false",
        },
        {
          text: this.$t("Local"),
          value: "local.descricao",
          sortable: "false",
        },
        {
          text: this.$t("Cidade"),
          value: "localCidadeUf",
          sortable: "false",
        },
        {
          text: this.$t("Bairro"),
          value: "local.bairro",
          sortable: "false",
        },
        {
          text: this.$t("JanelaAtendimentoInicio"),
          value: "janelaAtendimentoInicio",
          sortable: "false",
        },
        {
          text: this.$t("JanelaAtendimentoFinal"),
          value: "janelaAtendimentoFinal",
          sortable: "false",
        },

        { text: this.$t("Acoes"), value: "actionsPedidos", sortable: "false" },
      ],
      quantidadeTitulosQuitados: 0,
      quantidadeTitulosPendentes: 0,
      quantidadeTitulosVencidos: 0,
      quantidadeFiltros: 0,
      loading: false,
      listagemRequestId: 0,
      tenantContextId: normalizeIdentity(this.$store?.state?.inquilino?.id),
      pendingTenantReload: false,
      filtrosIniciaisAplicados: false,
      modalTransferenciaEmpresa: false,
      objTransferenciaEmpresa: {
        dataTransferencia: "",
        matriculaAtual: "",
        matriculaNova: "",
        nregistroDestino: "",
      },
      inquilinoDestinoTransferencia: null,

      modalConfirmaValidacaoFinanceira01: false,
      modalConfirmaValidacaoFinanceira02: false,
      modalConfirmaValidacaoFuncionarioAfastamento01: false,
      modalConfirmaValidacaoFuncionarioAfastamento02: false,

      produto: {},

      menuFuncionarioPontoDetalhes: false,

      //tabelas
      search: "",
      keyboardShortcutsDialog: false,
      searchFieldDialog: false,
      searchFieldOptions: [],
      searchFieldTargets: {},
      keyboardActiveItemKey: null,
      isSearching: false,
      searchDebounceTimer: null,
      buscaSimplificadaRequestId: 0,
      buscaSimplificadaStatus: {
        active: false,
        term: "",
        scannedPages: 0,
        totalPages: 0,
        scannedItems: 0,
        totalItems: 0,
        found: 0,
        fallback: false,
      },

      page: 1,
      tablePage: 1,
      totalPages: 0,
      totalItems: 0,
      pageSize: 8,
      pageSizes: [8, 16, 24],
      orderBy: null,
      sortFields: [],
      appliedSortFields: [],
      appliedDirection: null,
      ordenacaoMenu: false,
      impressaoMenu: false,
      recursosOrdenacaoLocal: [],
      ordenacaoLocalAtiva: false,
      inicio: "",
      fim: "",
      filtrosGenericosValores: [
        ...this.filtrosGenericosString,
        ...this.filtrosGenericosNumericos,
      ].reduce((valores, filtro) => {
        valores[filtro.coluna] = "";
        return valores;
      }, {}),

      filteredItems: null,
      selectedRows: [],
      bulkActionSelected: null,
      bulkActionLoading: false,
      inlineEdit: {
        itemId: null,
        field: null,
        value: "",
        loading: false,
      },
      pedidoItems: {},
      competencia: "",
      vencimentoInicio: "",
      vencimentoFim: "",
      inicioPeriodo: "",
      encerramentoPeriodo: "",
      detalhe: "",
      titulo: "",
      descricao: "",
      identificador: "",
      tipoVisualizacaoEmpresa: "",
      matricula: "",
      idPedido: "",
      nome: "",
      nomeCpf: "",
      nomeFuncionario: "",
      data: "",
      valorFinanceiro: "",
      fornecedores: [],
      itemsFornecedor: "",
      contasFinanceiras: [],
      contasVinculada: [],
      contaVinculada: {},
      contaBancaria: "",
      situacaoMovimentacaoContaVinculada: "",
      statusAfastamentoSolicitacao: "",
      itemsContaFinanceira: "",
      clientes: [],
      clienteLike: null,
      postoTrabalhoLike: null,
      registradorLike: null,
      numeroRegistro: "",
      itemsCliente: "",
      funcionarios: [],
      itemsFuncionario: [],
      pessoas: [],
      itemsPessoa: [],
      beneficioConvenios: [],
      moedas: [],
      itemsBeneficioConvenio: [],
      itemsMoedas: [],
      itemsProvedor: [],
      forcarAtualizacao: false,
      postoTrabalhos: [],
      itemsPostoTrabalho: [],
      itemsCargo: [],
      cargos: [],
      tipoVisualizacaoEmpresaOptions: [
        { text: "CORPORATIVO", value: "CORPORATIVO" },
        { text: "UNITARIO", value: "UNITARIO" },
      ],
      quantidade: 0,
      headersItemPedido: [
        {
          text: this.$t("Descricao"),
          value: "produto.descricao",
          align: "start",
          sortable: "false",
        },
        {
          text: this.$t("Quantidade"),
          value: "quantidade",
          sortable: "true",
        },
      ],
      statusReader: "",
      line: "",
      contentFile: null,
      direction: null,
      directions: [
        { text: this.$t("Crescente"), value: "ASC" },
        { text: this.$t("Decrescente"), value: "DESC" },
      ],
      modalImportArquivo: false,
      modalConfirmaAprovacao: false,
      modalConfirmaGeracaoDocumento: false,
      modalConfirmaExecucaoServico: false,
      modalGuias: false,
      headerGuias: [
        {
          text: this.$t("numeroDocumento"),
          value: "numeroDocumento",
          sortable: "false",
        },
        {
          text: this.$t("serieDocumento"),
          value: "serieDocumento",
          sortable: "false",
        },
        {
          text: this.$t("Cliente"),
          value: "cliente.razaoSocial",
          sortable: "false",
        },
        {
          text: this.$t("statusDocumento"),
          value: "statusDocumento",
          sortable: "false",
        },
        {
          text: this.$t("valorDeclarado"),
          value: "valorDeclarado",
        },

        { text: this.$t("Acoes"), value: "actionsGuias", sortable: "false" },
      ],

      headerTarefaExecucaoItems: [
        {
          text: this.$t("Imobilizado"),
          value: "imobilizado.identificacao",
          sortable: "false",
        },
        {
          text: this.$t("Identificador"),
          value: "imobilizado.identificador",
          sortable: "false",
        },
        {
          text: this.$t("Ocorrencia"),
          value: "ocorrencia",
          sortable: "false",
        },
        {
          text: this.$t("Observacao"),
          value: "observacao",
          sortable: "false",
        },
        {
          text: this.$t("Imagem"),
          value: "imagem",
        },
      ],

      headerEventosTv: [
        {
          text: this.$t("Data"),
          value: "data",
          sortable: "false",
        },
        {
          text: this.$t("Ocorrencia"),
          value: "logisticaTipoOcorrencia.descricao",
          sortable: "false",
        },
        {
          text: this.$t("Evento"),
          value: "logisticaTipoEvento.descricao",
          sortable: "false",
        },
        {
          text: this.$t("Responsavel"),
          value: "responsavel.nome",
          sortable: "false",
        },
        {
          text: this.$t("ExportacaoRealizada"),
          value: "exportacaoRealizada",
          sortable: "false",
        },

        {
          text: this.$t("Data_de_inclusao"),
          value: "dtInclusao",
          sortable: "false",
        },
        { text: this.$t("Acoes"), value: "edit", sortable: "false" },
      ],

      headerOcorrenciasTv: [
        {
          text: this.$t("Tipo"),
          value: "logisticaTipoOcorrencia.descricao",
          sortable: "false",
        },
        {
          text: this.$t("Responsavel"),
          value: "responsavel.nome",
          sortable: "false",
        },
        {
          text: this.$t("Data_de_inclusao"),
          value: "dtInclusao",
          sortable: "false",
        },
      ],
      ruleQuantidadePendente: (val) => {
        console.log("ruleQuantidadePendente", val);
        if (val > this.quantidadePendente) {
          this.confirmarQuantidadeDesabilitarBotao = true;
          return this.$t("Quantidade_maior_que_pendencia");
        } else if (val <= 0) {
          this.confirmarQuantidadeDesabilitarBotao = true;
          return this.$t("Quantidade_deve_ser_maior_que_zero");
        } else {
          this.confirmarQuantidadeDesabilitarBotao = false;
          return true;
        }
      },
      ruleRequired: (val) => {
        return !!val || this.$t("Campo_obrigatorio");
      },
      tipoImportacaoExterna: "",
      dataAprovacao: null,
      idDialog: 0,
      modalTarefaExecucaoItems: false,
      modalChangeTenant: false,
      inquilinosDisponiveis: [],
      inquilinoDestino: null,

      variavelFixa01: null,
      variavelFixa02: null,
      variavelFixa03: null,
      variavelFixa04: null,
      variavelFixa05: null,
      variavelFixa06: null,
      variavelFixa07: null,
      variavelFixa08: null,
      variavelFixa09: null,
      variavelFixa10: null,
      provedores: [
        { text: "BCB", value: "BCB" },
        { text: "Frankfurter", value: "FRANKFURTER" },
        { text: "Manual", value: "MANUAL" },
        { text: "Interno", value: "INTERNO" },
      ],
    };
  },

  watch: {
    search: function () {
      this.scheduleSearchChange();
    },
    "$store.state.inquilino.id": function (newValue, oldValue) {
      if (normalizeIdentity(newValue) === normalizeIdentity(oldValue)) {
        return;
      }
      this.handleTenantContextChange();
    },
    selectedRows: function () {
      this.syncBulkActionSelection();
    },
    bulkActionsDisponiveis: function () {
      this.syncBulkActionSelection();
    },
  },

  mounted() {
    if (this.consultaPaginada) return;
    this.scheduleCrudComponentPreload();
    this.sugestaoVencimento();
    this.sugestaoPeriodo();
    this.carregarDadosAuxiliaresListagem();
    if (this.pesquisaDataAtualTv || this.pesquisaDataSeguinteTv) {
      this.inicializarFiltroDataAutomatica();
    }
    const possuiFiltrosIniciais = this.aplicarFiltrosIniciais();
    this.filtrosIniciaisAplicados = possuiFiltrosIniciais;

    if (
      this.pesquisaDataAtualTv ||
      possuiFiltrosIniciais ||
      this.hasCustomFiltersAtivos()
    ) {
      this.handleSearchChange();
    } else {
      this.retrieveData();
    }

    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    this.clearSearchDebounceTimer();
    this.clearCrudComponentPreloadTimer();
    this.invalidateListagemRequests();
    // Remove o listener ao destruir o componente
    window.removeEventListener("keydown", this.handleKeydown);
  },

  activated() {
    if (this.pendingTenantReload && !isTenantChangeInProgress()) {
      this.pendingTenantReload = false;
      this.reloadListagemForTenant();
      return;
    }

    if (
      normalizeIdentity(this.tenantContextId) !==
      normalizeIdentity(this.getCurrentTenantId())
    ) {
      this.handleTenantContextChange();
      return;
    }

    if (!this.filtrosIniciaisAplicados && this.aplicarFiltrosIniciais()) {
      this.filtrosIniciaisAplicados = true;
      this.handleSearchChange();
    }
  },

  deactivated() {
    this.filtrosIniciaisAplicados = false;
  },

  computed: {
    isOrgaoPublico() {
      return this.$store?.state?.inquilino?.tipoContratacao === "ORGAOPUBLICO";
    },
    clienteLabel() {
      return this.$t(this.isOrgaoPublico ? "Lotacao" : "Cliente");
    },
    clienteLikeLabel() {
      return this.$t(this.isOrgaoPublico ? "Lotacao_contem" : "Cliente_contem");
    },
    clientesLabel() {
      return this.$t(this.isOrgaoPublico ? "Lotacoes" : "Clientes");
    },
    postoTrabalhoLabel() {
      return this.$t(this.isOrgaoPublico ? "LocalTrabalho" : "PostoTrabalho");
    },
    postoTrabalhoLikeLabel() {
      return this.$t(
        this.isOrgaoPublico ? "LocalTrabalho_contem" : "PostoTrabalho_contem",
      );
    },
    recursoUpper: function () {
      return this.nomePlural.charAt(0).toUpperCase() + this.nomePlural.slice(1);
    },
    sortFieldSelecionado: {
      get: function () {
        return this.sortFields.length ? this.sortFields[0] : null;
      },
      set: function (value) {
        this.sortFields = value ? [value] : [];
      },
    },

    headersFiltrados: function () {
      return this.headers.map((item) => {
        return { ...item, sortable: false };
      });
    },
    camposImpressao: function () {
      return this.getHeadersDados(this.headers).map((header) => {
        return {
          text: header.text || header.value,
          value: header.value,
        };
      });
    },
    camposOrdenacao: function () {
      const valores = new Set();
      return (this.camposOrdenacaoProp || this.getHeadersDados(this.headers))
        .filter((header) => {
          if (!header.value || valores.has(header.value)) {
            return false;
          }
          valores.add(header.value);
          return true;
        })
        .map((header) => {
          return {
            text: header.text || header.value,
            value: header.value,
          };
        });
    },
    tiposImpressao: function () {
      return [
        { text: this.$t("PDF"), value: "pdf", icon: "mdi-file-pdf-box" },
        { text: this.$t("TXT"), value: "txt", icon: "mdi-file-document" },
        { text: this.$t("EXCEL_XLS"), value: "xls", icon: "mdi-file-excel" },
        { text: this.$t("CSV"), value: "csv", icon: "mdi-file-delimited" },
      ];
    },
    isBuscaSimplificadaPaginadaAtiva: function () {
      return (
        this.buscaSimplificada &&
        this.buscaSimplificadaPaginada &&
        this.isSearching
      );
    },
    tableSearch: function () {
      return this.isBuscaSimplificadaPaginadaAtiva ? "" : this.search;
    },
    mostrarStatusBuscaSimplificada: function () {
      return (
        this.buscaSimplificada &&
        this.buscaSimplificadaPaginada &&
        this.isSearching &&
        String(this.search || "").trim().length > 0
      );
    },
    buscaSimplificadaProgressValue: function () {
      const totalPages = Number(this.buscaSimplificadaStatus.totalPages || 0);
      if (!this.buscaSimplificadaStatus.active || totalPages <= 0) {
        return 100;
      }
      const scannedPages = Number(
        this.buscaSimplificadaStatus.scannedPages || 0,
      );
      return Math.min(100, Math.round((scannedPages / totalPages) * 100));
    },
    buscaSimplificadaStatusLabel: function () {
      const status = this.buscaSimplificadaStatus || {};
      const term = status.term || String(this.search || "").trim();
      const found = Number(status.found || this.recursos.length || 0);
      const scannedItems = Number(status.scannedItems || 0);
      const totalItems = Number(status.totalItems || 0);

      if (status.active && status.fallback) {
        return `Buscando "${term}" em modo de compatibilidade...`;
      }

      if (status.active) {
        const progresso = totalItems
          ? `${scannedItems}/${totalItems}`
          : `${scannedItems}`;
        return `Buscando "${term}" - ${found} encontrados em ${progresso} registros`;
      }

      return `${found} encontrados para "${term}"`;
    },
    recursosTabela: function () {
      let itens =
        this.ordenacaoLocalAtiva && !this.isSearching
          ? this.recursosOrdenacaoLocal
          : this.recursos;

      if (
        this.appliedSortFields.length &&
        (this.ordenacaoLocalAtiva || this.isSearching)
      ) {
        itens = this.ordenarItensPorCampos(itens);
      }

      if (this.ordenacaoLocalAtiva && !this.isSearching) {
        return this.paginarItens(itens, this.page, this.pageSize);
      }

      return itens;
    },
    itemsPerPageTabela: function () {
      if (this.isBuscaSimplificadaPaginadaAtiva) {
        return this.pageSize;
      }
      return this.isSearching && !this.buscaParametrizadaPaginada
        ? 200
        : this.pageSize;
    },
    paginacaoDesabilitada: function () {
      return (
        this.isSearching &&
        !this.buscaParametrizadaPaginada &&
        !this.isBuscaSimplificadaPaginadaAtiva
      );
    },
    inquilinosTransferencia: function () {
      const inquilinos = this.$store?.state?.user?.inquilinos;
      return Array.isArray(inquilinos) ? inquilinos : [];
    },
    hasBulkActions: function () {
      return (
        this.enableSelection &&
        Array.isArray(this.bulkActions) &&
        this.bulkActions.length > 0
      );
    },
    hasBulkStatusActions: function () {
      return (
        this.hasBulkActions &&
        this.bulkActions.some((action) => {
          return action && action.statuses && action.statuses.length;
        })
      );
    },
    selectionEnabled: function () {
      return (
        this.enableSelection ||
        (this.canDeleteSelection && this.bulkDeleteModeActive)
      );
    },
    canDeleteSelection: function () {
      if (!this.bulkDeleteEnabled) {
        return false;
      }
      const roleDelete = `ROLE_${this.nomeSingular}_Delete`;
      const permissoes = this.$store?.state?.permissoes;
      const possuiPermissao =
        Array.isArray(permissoes) && permissoes.includes(roleDelete);
      if (!possuiPermissao) {
        return false;
      }
      const service = this.$parent?.DataService;
      return !!service && typeof service.delete === "function";
    },
    canInlineEdit: function () {
      if (!this.editar) {
        return false;
      }
      const roleUpdate = `ROLE_${this.nomeSingular}_Update`;
      const permissoes = this.$store?.state?.permissoes;
      const possuiPermissao =
        Array.isArray(permissoes) && permissoes.includes(roleUpdate);
      if (!possuiPermissao) {
        return false;
      }
      const service = this.$parent?.DataService;
      return !!service && typeof service.update === "function";
    },
    bulkDeleteDisabled: function () {
      return (
        this.loading || this.bulkActionLoading || !this.selectedRows.length
      );
    },
    bulkSelectedStatus: function () {
      if (!this.enableSelection || !this.selectedRows.length) {
        return null;
      }
      const statusField = this.bulkActionStatusField || "statusPedido";
      const status = this.selectedRows[0]
        ? this.selectedRows[0][statusField]
        : null;
      if (!status) {
        return null;
      }
      const sameStatus = this.selectedRows.every((item) => {
        return item && item[statusField] === status;
      });
      return sameStatus ? status : null;
    },
    bulkHasMixedStatus: function () {
      if (!this.enableSelection || !this.selectedRows.length) {
        return false;
      }
      const statusField = this.bulkActionStatusField || "statusPedido";
      const status = this.selectedRows[0]
        ? this.selectedRows[0][statusField]
        : null;
      return this.selectedRows.some((item) => {
        return item && item[statusField] !== status;
      });
    },
    bulkActionsDisponiveis: function () {
      if (!this.enableSelection || !this.bulkActions.length) {
        return [];
      }
      if (!this.bulkSelectedStatus) {
        return this.bulkActions.filter((action) => {
          return !action || !action.statuses || !action.statuses.length;
        });
      }
      return this.bulkActions.filter((action) => {
        if (!action || !action.statuses || !action.statuses.length) {
          return true;
        }
        return action.statuses.includes(this.bulkSelectedStatus);
      });
    },
    bulkActionSelectDisabled: function () {
      if (!this.enableSelection) {
        return true;
      }
      if (!this.selectedRows.length) {
        return true;
      }
      return !this.bulkActionsDisponiveis.length;
    },
    bulkActionDisabled: function () {
      if (this.bulkActionLoading || this.loading) {
        return true;
      }
      if (!this.selectedRows.length) {
        return true;
      }
      if (!this.bulkActionSelected) {
        return true;
      }
      const validAction = this.bulkActionsDisponiveis.some((action) => {
        return action.value === this.bulkActionSelected;
      });
      return !validAction;
    },
    bulkActionSelectionMessage: function () {
      if (!this.hasBulkActions || !this.selectedRows.length) {
        return "";
      }
      if (this.bulkHasMixedStatus && !this.bulkActionsDisponiveis.length) {
        return this.$t("Selecione_itens_com_o_mesmo_status");
      }
      if (!this.bulkActionsDisponiveis.length) {
        return this.$t("Nenhuma_acao_disponivel_para_status");
      }
      return "";
    },
    listKeyboardShortcuts: function () {
      const shortcuts = [];

      if (this.botaoCadastro) {
        shortcuts.push({
          teclas: "Ctrl / ⌘ + I",
          descricao: "Incluir_um_novo_registro",
        });
      }

      shortcuts.push(
        {
          teclas: "Ctrl / ⌘ + Alt / ⌥ + S",
          descricao: "Ir_para_a_busca_da_listagem",
        },
        {
          teclas: "Ctrl / ⌘ + Shift + F",
          descricao: "Aplicar_os_filtros_da_listagem",
        },
        {
          teclas: "Seta para cima + Seta para baixo",
          descricao: "Navegar_pelas_linhas_da_tabela",
        },
        {
          teclas: "Enter",
          descricao: "Abrir_a_linha_em_foco",
        },
      );

      if (this.editar) {
        shortcuts.push({
          teclas: "Ctrl + E",
          descricao: "Editar_a_linha_em_foco",
        });
      }

      if (this.selectionEnabled) {
        shortcuts.push(
          {
            teclas: "Espaço",
            descricao: "Marcar_ou_desmarcar_a_linha_em_foco",
          },
          {
            teclas: "Ctrl / ⌘ + A",
            descricao: "Marcar_ou_desmarcar_as_linhas_exibidas",
          },
        );
      }
      if (this.hasBulkActions || this.canDeleteSelection) {
        shortcuts.push({
          teclas: "Ctrl / ⌘ + Enter",
          descricao: "Executar_a_acao_em_lote_selecionada",
        });
      }
      if (this.camposImpressao.length) {
        shortcuts.push({
          teclas: "Ctrl / ⌘ + P",
          descricao: "Abrir_as_opcoes_de_impressao",
        });
      }

      shortcuts.push(
        {
          teclas: "Esc",
          descricao: "Fechar_a_camada_atual",
        },
        {
          teclas: "Ctrl / ⌘ + /",
          descricao: "Exibir_esta_lista_de_atalhos",
        },
      );

      return shortcuts;
    },
  },

  methods: {
    normalizarValorFiltroInicial(valor) {
      const valorNormalizado = Array.isArray(valor) ? valor[0] : valor;
      return String(valorNormalizado ?? "").trim();
    },

    normalizarDataFiltroInicial(valor) {
      const data = this.normalizarValorFiltroInicial(valor);
      const resultado = data.match(/^(\d{4}-\d{2}-\d{2})/);
      return resultado ? resultado[1] : "";
    },

    aplicarFiltrosIniciais() {
      const filtrosRecebidos = this.filtrosIniciais || {};
      const filtros = Object.keys(filtrosRecebidos).length
        ? filtrosRecebidos
        : this.$route?.query || {};
      let possuiFiltros = false;

      if (this.pesquisaMatricula) {
        const matricula = this.normalizarValorFiltroInicial(filtros.matricula);
        if (matricula) {
          this.matricula = matricula;
          possuiFiltros = true;
        }
      }

      if (this.pesquisaPeriodo) {
        const inicioPeriodo = this.normalizarDataFiltroInicial(
          filtros.inicioPeriodo,
        );
        const encerramentoPeriodo = this.normalizarDataFiltroInicial(
          filtros.encerramentoPeriodo,
        );

        if (inicioPeriodo) {
          this.inicioPeriodo = inicioPeriodo;
          possuiFiltros = true;
        }
        if (encerramentoPeriodo) {
          this.encerramentoPeriodo = encerramentoPeriodo;
          possuiFiltros = true;
        }
      }

      return possuiFiltros;
    },

    getCurrentTenantId() {
      return this.$store?.state?.inquilino?.id || null;
    },

    isCurrentTenantRequest(tenantId) {
      return (
        normalizeIdentity(tenantId) ===
        normalizeIdentity(this.getCurrentTenantId())
      );
    },

    startListagemRequest() {
      this.listagemRequestId += 1;
      return {
        id: this.listagemRequestId,
        tenantId: this.getCurrentTenantId(),
      };
    },

    isCurrentListagemRequest(requestContext) {
      return (
        requestContext &&
        requestContext.id === this.listagemRequestId &&
        this.isCurrentTenantRequest(requestContext.tenantId)
      );
    },

    invalidateListagemRequests() {
      this.listagemRequestId += 1;
      this.buscaSimplificadaRequestId += 1;
    },

    carregarDadosAuxiliaresListagem() {
      if (this.pesquisaContaFinanceira) {
        // this.getContasFinanceiras();
      }
      if (this.pesquisaContaVinculada) {
        this.getContasVinculada();
      }
      if (this.pesquisaFornecedor) {
        // this.getFornecedores();
      }
      if (
        this.pesquisaCliente
        // ||
        // this.nomeSingular === "ModeloDocumentacaoAcessoria"
      ) {
        //this.getClientes();
      }
      if (this.pesquisaFuncionario) {
        this.getFuncionarios();
      }
      if (this.pesquisaBeneficioConvenio) {
        this.getBeneficioConvenios();
      }
      if (this.pesquisaMoedas) {
        this.getMoedas();
      }
      if (
        this.pesquisaPostoTrabalho
        //||
        // this.nomeSingular === "ModeloDocumentacaoAcessoria"
      ) {
        this.getPostoTrabalhos();
        //this.getCargos();
      }
      //  if (
      //   this.pesquisaPostoTrabalhoLivroOcorre ||
      //   this.nomeSingular === "PostoTrabalhoOcorrencia"
      // ) {
      //   this.getPostoTrabalhos();
      //  }
      if (this.pesquisaPessoa) {
        this.getPessoas();
      }
    },

    resetListagemStateForTenant() {
      this.clearSearchDebounceTimer();
      this.invalidateListagemRequests();
      this.cancelInlineEdit();

      this.loading = false;
      this.errors = [];
      this.recursos = [];
      this.filteredItems = null;
      this.keyboardActiveItemKey = null;
      this.recursosOrdenacaoLocal = [];
      this.ordenacaoLocalAtiva = false;
      this.selectedRows = [];
      this.bulkActionSelected = null;
      this.bulkActionLoading = false;
      this.isSearching = false;
      this.page = 1;
      this.tablePage = 1;
      this.totalPages = 0;
      this.totalItems = 0;

      this.dialogInsert = false;
      this.dialogEdit = false;
      this.confirmar = false;
      this.confirmarReplicar = false;
      this.confirmarDisponibilizacaoDocumento = false;
      this.recebimentoDetalhado = false;
      this.modalChangeTenant = false;

      this.getFiltrosGenericosConfigurados().forEach((filtro) => {
        this.filtrosGenericosValores[filtro.coluna] = "";
      });
      this.itemsCliente = "";
      this.clientes = [];
      this.clienteLike = null;
      this.postoTrabalhoLike = null;
      this.registradorLike = null;
      this.itemsFuncionario = [];
      this.funcionarios = [];
      this.itemsPostoTrabalho = [];
      this.postoTrabalhos = [];
      this.itemsCargo = [];
      this.cargos = [];
      this.itemsFornecedor = "";
      this.fornecedores = [];
      this.itemsContaFinanceira = "";
      this.contasFinanceiras = [];
      this.itemsPessoa = [];
      this.pessoas = [];
      this.itemsBeneficioConvenio = [];
      this.beneficioConvenios = [];
      this.moedas = [];
      this.itemsMoedas = [];
      this.itemsProvedor = [];
      this.forcarAtualizacao = false;

      this.matricula = "";
      this.nome = "";
      this.nomeCpf = "";
      this.nomeFuncionario = "";
      this.numeroRegistro = "";
      this.identificador = "";
      this.descricao = "";
      this.detalhe = "";
      this.titulo = "";
      this.valorFinanceiro = "";
      this.statusFinanceiro = null;
      this.statusFuncionario = null;
      this.dsStatusFuncionario = null;
      this.statusComumFiltro = null;
      this.tipoVisualizacaoEmpresa = "";

      this.resetBuscaSimplificadaStatus();
    },

    reloadListagemForTenant() {
      this.carregarDadosAuxiliaresListagem();
      if (this.pesquisaDataAtualTv) {
        this.handleSearchChange();
      } else {
        this.retrieveData();
      }
    },

    handleTenantContextChange() {
      this.tenantContextId = normalizeIdentity(this.getCurrentTenantId());
      this.resetListagemStateForTenant();

      if (isTenantChangeInProgress()) {
        this.pendingTenantReload = true;
        return;
      }

      this.pendingTenantReload = false;
      this.$nextTick(() => {
        this.reloadListagemForTenant();
      });
    },

    handleKeydown(event) {
      if (event.defaultPrevented) return;

      const key = String(event.key || "");
      const keyLower = key.toLowerCase();
      const ctrlOrCmd = event.ctrlKey || event.metaKey;

      if (key === "Escape" || key === "Esc") {
        this.handleListEscape(event);
        return;
      }

      if (!this.isListagemAtivaParaAtalhos(event)) return;

      if (ctrlOrCmd && event.shiftKey && !event.altKey && keyLower === "f") {
        consumeKeyboardEvent(event);
        this.filtrar();
        return;
      }

      if (isCrudSearchShortcut(event)) {
        if (!this.focusListSearch()) return;
        consumeKeyboardEvent(event);
        return;
      }

      if (ctrlOrCmd && !event.shiftKey && !event.altKey && !event.repeat) {
        if (
          event.ctrlKey &&
          !event.metaKey &&
          keyLower === "e" &&
          !isEditableKeyboardTarget(event.target) &&
          !event.target?.closest?.("button, a, [role='button'], .v-input") &&
          event.target?.closest?.(".crud-listagem-table")
        ) {
          const item = this.getKeyboardActiveItem();
          if (!item || !this.canOpenEditByKeyboard(item)) return;
          consumeKeyboardEvent(event);
          this.openEditarModal(item);
          return;
        }

        if (keyLower === "i") {
          consumeKeyboardEvent(event);
          this.acionarBotaoPorAtalho("botaoCadastro");
          return;
        }

        if (keyLower === "p") {
          consumeKeyboardEvent(event);
          this.acionarBotaoPorAtalho("botaoImpressao");
          return;
        }

        if (
          keyLower === "a" &&
          this.selectionEnabled &&
          !isEditableKeyboardTarget(event.target)
        ) {
          consumeKeyboardEvent(event);
          this.toggleAllVisibleRows();
          return;
        }

        if (key === "Enter" && this.executeSelectedBulkAction()) {
          consumeKeyboardEvent(event);
          return;
        }
      }

      if (
        key === "/" &&
        ctrlOrCmd &&
        !event.shiftKey &&
        !event.altKey &&
        !event.repeat
      ) {
        consumeKeyboardEvent(event);
        this.openKeyboardShortcuts();
        return;
      }

      if (
        event.repeat ||
        ctrlOrCmd ||
        event.altKey ||
        event.shiftKey ||
        isEditableKeyboardTarget(event.target) ||
        event.target?.closest?.("button, a, [role='button'], .v-input")
      ) {
        return;
      }

      const insideTable = event.target?.closest?.(".crud-listagem-table");
      if (!insideTable) return;

      if (key === "ArrowDown" || key === "ArrowUp") {
        consumeKeyboardEvent(event);
        this.moveKeyboardActiveRow(key === "ArrowDown" ? 1 : -1);
        return;
      }

      if ((key === " " || key === "Spacebar") && this.selectionEnabled) {
        const item = this.getKeyboardActiveItem();
        if (!item) return;
        consumeKeyboardEvent(event);
        this.toggleKeyboardRowSelection(item);
        return;
      }

      if (key === "Enter") {
        const item = this.getKeyboardActiveItem();
        if (!item) return;
        consumeKeyboardEvent(event);
        this.activateKeyboardRow(item, event);
        return;
      }
    },
    isListagemAtivaParaAtalhos(event) {
      if (
        !this.keyboardShortcutsEnabled ||
        typeof document === "undefined" ||
        getTopActiveDialog(document) ||
        document.querySelector(".swal2-container.swal2-backdrop-show")
      ) {
        return false;
      }
      return isKeyboardScopeActive(this.$el, ".listagem-base", event?.target);
    },
    hasActiveCrudFormDialog() {
      return Boolean(
        typeof document !== "undefined" &&
          document.querySelector(".v-dialog--active .crud-form-page"),
      );
    },
    hasListOwnedLayer() {
      return Boolean(
        this.dialogInsert ||
          this.dialogEdit ||
          this.keyboardShortcutsDialog ||
          this.searchFieldDialog ||
          this.dialogSuccesEdit ||
          this.dialogSuccesInsert ||
          this.modalConfirmaAprovacao ||
          this.modalConfirmaExecucaoServico ||
          this.modalConfirmaGeracaoDocumento ||
          this.modalConfirmaValidacaoFinanceira01 ||
          this.modalConfirmaValidacaoFinanceira02 ||
          this.modalConfirmaValidacaoFuncionarioAfastamento01 ||
          this.modalConfirmaValidacaoFuncionarioAfastamento02 ||
          this.modalEventoTv ||
          this.modalEventosTv ||
          this.modalGerarRoteiroModelo ||
          this.modalGuias ||
          this.modalTarefaExecucaoItems ||
          this.modalImportArquivo ||
          this.modalNovoOcorrenciaTv ||
          this.modalOcorrenciasTv ||
          this.modalPedidosPendentes ||
          this.modalSolicitacoesTarefaPendente ||
          this.modalRoteirizarPedido ||
          this.modalRoteirizarTarefaSolicitacao ||
          this.modalTransferenciaEmpresa ||
          this.confirmarDisponibilizacao ||
          this.confirmarDisponibilizacaoDocumento ||
          this.confirmarEntrega ||
          this.confirmarEntregaTotal ||
          this.confirmarRecebimento ||
          this.confirmarReplicar ||
          this.confirmarRetirada ||
          this.confirmarRetiradoTerceiro ||
          this.confirmarSeparacao ||
          this.confirmarTroca,
      );
    },
    handleListEscape(event) {
      if (!this.keyboardShortcutsEnabled) return;
      if (!isElementVisible(this.$el)) return;
      if (this.hasActiveCrudFormDialog()) return;

      const hasLayer = this.hasListOwnedLayer();
      if (!hasLayer && !this.isListagemAtivaParaAtalhos(event)) return;

      consumeKeyboardEvent(event);
      if (this.inlineEdit.itemId !== null && !this.inlineEdit.loading) {
        this.cancelInlineEdit();
      }
      if (this.dialogInsert) this.closeInsertModal();
      if (this.dialogEdit) this.closeEditarModal();
      this.keyboardShortcutsDialog = false;
      this.searchFieldDialog = false;
      this.dialogSuccesEdit = false;
      this.dialogSuccesInsert = false;
      this.modalConfirmaAprovacao = false;
      this.modalConfirmaExecucaoServico = false;
      this.modalConfirmaGeracaoDocumento = false;
      this.modalConfirmaValidacaoFinanceira01 = false;
      this.modalConfirmaValidacaoFinanceira02 = false;
      this.modalConfirmaValidacaoFuncionarioAfastamento01 = false;
      this.modalConfirmaValidacaoFuncionarioAfastamento02 = false;
      this.modalEventoTv = false;
      this.modalEventosTv = false;
      this.modalGerarRoteiroModelo = false;
      this.modalGuias = false;
      this.modalTarefaExecucaoItems = false;
      this.modalImportArquivo = false;
      this.modalNovoOcorrenciaTv = false;
      this.modalOcorrenciasTv = false;
      this.modalPedidosPendentes = false;
      this.modalSolicitacoesTarefaPendente = false;
      this.modalRoteirizarPedido = false;
      this.modalRoteirizarTarefaSolicitacao = false;
      this.modalTransferenciaEmpresa = false;
      this.confirmarDisponibilizacao = false;
      this.confirmarDisponibilizacaoDocumento = false;
      this.confirmarEntrega = false;
      this.confirmarEntregaTotal = false;
      this.confirmarRecebimento = false;
      this.confirmarReplicar = false;
      this.confirmarRetirada = false;
      this.confirmarRetiradoTerceiro = false;
      this.confirmarSeparacao = false;
      this.confirmarTroca = false;
      if (!this.enableSelection && this.bulkDeleteModeActive) {
        this.encerrarDelecaoEmLote();
      }
    },
    openKeyboardShortcuts() {
      this.keyboardShortcutsDialog = true;
    },
    acionarBotaoPorAtalho(refName) {
      return activateControl(this.$refs[refName]);
    },
    focusListSearch() {
      const controls = getCrudSearchControls(this.$el);
      if (!controls.length) return false;
      if (controls.length === 1) return focusControl(controls[0]);

      this.searchFieldTargets = {};
      this.searchFieldOptions = controls.map((control, index) => {
        const id = `list-search-field-${index}`;
        this.searchFieldTargets[id] = control;
        return {
          id,
          label: getCrudSearchControlLabel(
            control,
            `${this.$t("Campo_de_pesquisa")} ${index + 1}`,
          ),
        };
      });
      this.searchFieldDialog = true;
      return true;
    },
    focusSelectedListSearchField(fieldId) {
      const target = this.searchFieldTargets[fieldId];
      this.searchFieldDialog = false;
      this.$nextTick(() => focusControl(target));
    },
    keyboardRows() {
      if (Array.isArray(this.filteredItems)) {
        return this.filteredItems;
      }
      return Array.isArray(this.recursosTabela) ? this.recursosTabela : [];
    },
    keyboardItemKey(item) {
      const id = this.resolveResourceId(item);
      return id === null ? item : String(id);
    },
    getKeyboardActiveItem() {
      return (
        this.keyboardRows().find(
          (item) => this.keyboardItemKey(item) === this.keyboardActiveItemKey,
        ) || null
      );
    },
    handleCurrentItems(items) {
      this.filteredItems = Array.isArray(items) ? items : [];
      if (
        this.keyboardActiveItemKey !== null &&
        !this.getKeyboardActiveItem()
      ) {
        this.keyboardActiveItemKey = null;
      }
      this.$nextTick(this.syncKeyboardRowTabIndexes);
    },
    ensureKeyboardActiveRow() {
      if (this.getKeyboardActiveItem()) return;
      const first = this.keyboardRows()[0];
      if (!first) return;
      this.keyboardActiveItemKey = this.keyboardItemKey(first);
      this.$nextTick(this.syncKeyboardRowTabIndexes);
    },
    moveKeyboardActiveRow(direction) {
      const rows = this.keyboardRows();
      if (!rows.length) return;
      const current = this.getKeyboardActiveItem();
      const currentIndex = current ? rows.indexOf(current) : -1;
      const nextIndex =
        currentIndex === -1
          ? direction > 0
            ? 0
            : rows.length - 1
          : Math.max(0, Math.min(rows.length - 1, currentIndex + direction));
      this.keyboardActiveItemKey = this.keyboardItemKey(rows[nextIndex]);
      this.$nextTick(this.focusKeyboardActiveRow);
    },
    syncKeyboardRowTabIndexes() {
      const table = this.$refs.tabelaPrincipal?.$el;
      if (!table) return;
      const rows = table.querySelectorAll("tbody tr");
      rows.forEach((row) => row.setAttribute("tabindex", "-1"));
      const active = table.querySelector(
        "tbody tr.crud-listagem-table__row--keyboard-active",
      );
      if (active) active.setAttribute("tabindex", "0");
    },
    focusKeyboardActiveRow() {
      this.syncKeyboardRowTabIndexes();
      const table = this.$refs.tabelaPrincipal?.$el;
      const active = table?.querySelector?.(
        "tbody tr.crud-listagem-table__row--keyboard-active",
      );
      active?.focus?.();
    },
    tableRowClass(item) {
      const classes = [this.isStatusComum(item)];
      if (this.keyboardItemKey(item) === this.keyboardActiveItemKey) {
        classes.push("crud-listagem-table__row--keyboard-active");
      }
      return classes.filter(Boolean).join(" ");
    },
    toggleKeyboardRowSelection(item) {
      const key = this.keyboardItemKey(item);
      const index = this.selectedRows.findIndex(
        (selected) => this.keyboardItemKey(selected) === key,
      );
      if (index === -1) this.selectedRows = [...this.selectedRows, item];
      else this.selectedRows = this.selectedRows.filter((_, i) => i !== index);
    },
    toggleAllVisibleRows() {
      const visibleRows = this.keyboardRows();
      if (!visibleRows.length) return;
      const visibleKeys = new Set(
        visibleRows.map((item) => this.keyboardItemKey(item)),
      );
      const allSelected = visibleRows.every((item) =>
        this.selectedRows.some(
          (selected) =>
            this.keyboardItemKey(selected) === this.keyboardItemKey(item),
        ),
      );

      if (allSelected) {
        this.selectedRows = this.selectedRows.filter(
          (item) => !visibleKeys.has(this.keyboardItemKey(item)),
        );
        return;
      }

      const selectedKeys = new Set(
        this.selectedRows.map((item) => this.keyboardItemKey(item)),
      );
      this.selectedRows = [
        ...this.selectedRows,
        ...visibleRows.filter(
          (item) => !selectedKeys.has(this.keyboardItemKey(item)),
        ),
      ];
    },
    executeSelectedBulkAction() {
      if (this.hasBulkActions && !this.bulkActionDisabled) {
        this.executarAcaoEmMassa();
        return true;
      }
      if (this.canDeleteSelection && !this.bulkDeleteDisabled) {
        this.confirmaDeleteSelecionados();
        return true;
      }
      return false;
    },
    canOpenEditByKeyboard(item) {
      const permission =
        this.acaoPrincipalPermissao || `ROLE_${this.nomeSingular}_List`;
      const permissions = this.$store?.state?.permissoes;
      return (
        this.editar &&
        !this.loading &&
        this.isEditAvailable(item) &&
        (!permission ||
          !Array.isArray(permissions) ||
          permissions.includes(permission))
      );
    },
    activateKeyboardRow(item, event) {
      if (this.$listeners && this.$listeners["row-click"]) {
        this.forwardTableRowClick(item, null, event);
        return;
      }
      if (this.canOpenEditByKeyboard(item)) this.openEditarModal(item);
    },
    possuiDocumentacaoAcessoria() {
      try {
        let param = this.$store.state.inquilino.modulosContratacao.find(
          (item) => {
            return item.tipo == "DOCUMENTACAOACESSORIAAUTOMATICA";
          },
        );
        if (param != undefined && param.id != undefined) {
          return true;
        } else {
          return false;
        }
      } catch (err) {
        return false;
      }
    },
    possuiLogisticaTransporte() {
      try {
        let param = this.$store.state.inquilino.modulosContratacao.find(
          (item) => {
            return item.tipo == "GLT";
          },
        );
        if (param != undefined && param.id != undefined) {
          return true;
        } else {
          return false;
        }
      } catch (err) {
        return false;
      }
    },
    getEditComponentTargetName() {
      return `editar.${this.nomeSingular.toLowerCase()}`;
    },

    getInsertComponentTargetName() {
      const nomeSingularCadastro =
        this.nomeSingularCadastroOverride || this.nomeSingular;
      return `cadastro.${nomeSingularCadastro}`;
    },

    isValidCrudComponent(component) {
      return !!(component && (component.template || component.render));
    },

    async resolveCrudComponent(targetName) {
      if (this.crudComponentCache[targetName]) {
        return this.crudComponentCache[targetName];
      }

      if (this.crudComponentPromiseCache[targetName]) {
        return this.crudComponentPromiseCache[targetName];
      }

      const componentPromise = this.importCrudComponent(targetName);
      this.$set(this.crudComponentPromiseCache, targetName, componentPromise);
      return componentPromise;
    },

    async importCrudComponent(targetName) {
      try {
        if (componentPaths[targetName]) {
          const componentModule = await componentPaths[targetName]();
          const component = componentModule.default || componentModule;
          if (!this.isValidCrudComponent(component)) {
            console.error(`Componente inválido para a rota: ${targetName}`);
            const fallbackComponent = {
              template: "<div>Componente não encontrado ou inválido</div>",
            };
            this.$set(this.crudComponentCache, targetName, fallbackComponent);
            return fallbackComponent;
          }

          this.$set(this.crudComponentCache, targetName, component);
          return component;
        } else {
          console.error(
            `Caminho do componente não encontrado para a rota: ${targetName}`,
          );
          const fallbackComponent = {
            template: "<div>Componente não encontrado</div>",
          };
          this.$set(this.crudComponentCache, targetName, fallbackComponent);
          return fallbackComponent;
        }
      } catch (error) {
        console.error(
          `Erro ao importar componente para a rota ${targetName}:`,
          error,
        );
        const fallbackComponent = {
          template: "<div>Erro ao carregar o componente</div>",
        };
        this.$set(this.crudComponentCache, targetName, fallbackComponent);
        return fallbackComponent;
      }
    },

    async loadEditComponent(targetName = this.getEditComponentTargetName()) {
      this.editComponent = await this.resolveCrudComponent(targetName);
    },

    async loadInsertComponent(
      targetName = this.getInsertComponentTargetName(),
    ) {
      this.insertComponent = await this.resolveCrudComponent(targetName);
    },

    preloadCrudComponent(targetName) {
      if (!componentPaths[targetName] || this.crudComponentCache[targetName]) {
        return;
      }

      this.resolveCrudComponent(targetName);
    },

    preloadEditComponent() {
      this.preloadCrudComponent(this.getEditComponentTargetName());
    },

    preloadInsertComponent(nomeSingularCadastro = this.nomeSingular) {
      this.preloadCrudComponent(`cadastro.${nomeSingularCadastro}`);
    },

    scheduleCrudComponentPreload() {
      if (this.crudComponentPreloadTimer) {
        return;
      }

      const preload = () => {
        this.crudComponentPreloadTimer = null;
        this.crudComponentPreloadTimerType = null;
        this.preloadInsertComponent();
        this.preloadEditComponent();
      };

      if (
        typeof window !== "undefined" &&
        typeof window.requestIdleCallback === "function"
      ) {
        this.crudComponentPreloadTimerType = "idle";
        this.crudComponentPreloadTimer = window.requestIdleCallback(preload, {
          timeout: 1500,
        });
        return;
      }

      this.crudComponentPreloadTimerType = "timeout";
      this.crudComponentPreloadTimer = setTimeout(preload, 500);
    },

    clearCrudComponentPreloadTimer() {
      if (!this.crudComponentPreloadTimer) {
        return;
      }

      if (
        this.crudComponentPreloadTimerType === "idle" &&
        typeof window !== "undefined" &&
        typeof window.cancelIdleCallback === "function"
      ) {
        window.cancelIdleCallback(this.crudComponentPreloadTimer);
      } else {
        clearTimeout(this.crudComponentPreloadTimer);
      }

      this.crudComponentPreloadTimer = null;
      this.crudComponentPreloadTimerType = null;
    },
    setCrudModalLoading(mode, value) {
      if (!this.crudModalLoading || !(mode in this.crudModalLoading)) return;
      this.$set(this.crudModalLoading, mode, value);
    },

    isCrudDialogOpen(mode) {
      return mode === "edit" ? this.dialogEdit : this.dialogInsert;
    },

    startCrudModalLoading(mode) {
      const nextId = (this.crudModalLoadId[mode] || 0) + 1;
      this.$set(this.crudModalLoadId, mode, nextId);
      this.setCrudModalLoading(mode, true);
      return nextId;
    },

    finishCrudModalLoading(mode, loadId) {
      if (
        this.crudModalLoadId[mode] === loadId &&
        this.isCrudDialogOpen(mode)
      ) {
        this.setCrudModalLoading(mode, false);
      }
    },

    waitForNextAnimationFrame() {
      if (
        typeof window === "undefined" ||
        typeof window.requestAnimationFrame !== "function"
      ) {
        return new Promise((resolve) => setTimeout(resolve, 0));
      }

      return new Promise((resolve) => {
        window.requestAnimationFrame(resolve);
      });
    },

    async waitForCrudModalPaint() {
      await this.$nextTick();
      await this.waitForNextAnimationFrame();
      await this.waitForNextAnimationFrame();
    },

    async openEditarModal(item) {
      if (this.dialogEdit || this.crudModalLoading.edit) {
        return;
      }

      const targetName = this.getEditComponentTargetName();
      const loadId = this.startCrudModalLoading("edit");
      this.recursoAtual = item;
      this.editComponent = null;
      this.dialogEdit = true;
      await this.waitForCrudModalPaint();

      if (this.crudModalLoadId.edit !== loadId || !this.dialogEdit) return;
      this.editComponent = await this.resolveCrudComponent(targetName);

      if (this.crudModalLoadId.edit !== loadId || !this.dialogEdit) return;
      this.finishCrudModalLoading("edit", loadId);
    },

    openChangeTenantModal(item) {
      this.recursoAtual = item;
      this.inquilinosDisponiveis = this.$store.state.user.inquilinos.map(
        (obj) => obj.inquilino,
      );
      this.inquilinosDisponiveis = this.inquilinosDisponiveis.filter(
        (inquilino) => inquilino.statusComum === "ATIVO",
      );
      this.modalChangeTenant = true;
    },

    async openInsertModal() {
      if (this.dialogInsert || this.crudModalLoading.insert) {
        return;
      }

      this.nomeSingularCadastroOverride = null;
      const targetName = this.getInsertComponentTargetName();
      const loadId = this.startCrudModalLoading("insert");
      this.insertComponent = null;
      this.dialogInsert = true;
      await this.waitForCrudModalPaint();

      if (this.crudModalLoadId.insert !== loadId || !this.dialogInsert) return;
      this.insertComponent = await this.resolveCrudComponent(targetName);

      if (this.crudModalLoadId.insert !== loadId || !this.dialogInsert) return;
      this.finishCrudModalLoading("insert", loadId);
    },

    async openInsertModalAdmissaoResumida() {
      if (this.dialogInsert || this.crudModalLoading.insert) {
        return;
      }

      this.nomeSingularCadastroOverride = "FuncionarioResumed";
      const targetName = this.getInsertComponentTargetName();
      const loadId = this.startCrudModalLoading("insert");
      this.insertComponent = null;
      this.dialogInsert = true;
      await this.waitForCrudModalPaint();

      if (this.crudModalLoadId.insert !== loadId || !this.dialogInsert) return;
      this.insertComponent = await this.resolveCrudComponent(targetName);

      if (this.crudModalLoadId.insert !== loadId || !this.dialogInsert) return;
      this.finishCrudModalLoading("insert", loadId);
    },
    closeInsertModal() {
      this.$set(
        this.crudModalLoadId,
        "insert",
        this.crudModalLoadId.insert + 1,
      );
      this.setCrudModalLoading("insert", false);
      this.dialogInsert = false;
      this.insertComponent = null;
      this.nomeSingularCadastroOverride = null;
    },

    closeEditarModal() {
      console.log("closeEditarModal");
      this.$set(this.crudModalLoadId, "edit", this.crudModalLoadId.edit + 1);
      this.setCrudModalLoading("edit", false);
      this.dialogEdit = false;
      this.editComponent = null;
    },
    onSubmitSuccessEdit(recursoAtualizado) {
      console.log("onSubmitSuccessEdit acessou");
      console.log("onSubmitSuccessEdit", this.atualizarDadosAoEditar);
      if (this.atualizarDadosAoEditar) {
        const deveRecarregar = this.deveRecarregarDadosAoEditar();
        const atualizouLocalmente =
          !deveRecarregar &&
          this.atualizarItemEditadoNaListagem(recursoAtualizado);

        if (deveRecarregar || !atualizouLocalmente) {
          this.refreshList();
        }
      }

      this.notificarDadosAlterados("edicao", {
        recurso: recursoAtualizado,
      });
      this.closeEditarModal();
      this.dialogSuccesEdit = false;
      this.dialogSuccesEdit = true;
    },

    onSubmitSuccessInsert(repeat, formData) {
      console.log("ListagemBase, repeat", repeat);
      console.log("ListagemBase, formData", formData);
      const estavaPesquisando = this.isSearching;
      this.isSearching = false;
      if (estavaPesquisando || this.pesquisaDataAtualTv) {
        console.log(" if (estavaPesquisando || this.pesquisaDataAtualTv)");
        this.handleSearchChange();
      } else {
        this.retrieveData();
      }
      console.log("repeat", repeat);
      if (repeat) {
        this.$swal.fire(
          this.$t("cadastrado_sucesso"),
          this.$t("pode_realizar_alteracoes_novo_cadastro"),
          "success",
        );
        // Caso o checkbox "Repetir" esteja marcado, reabrimos o modal
        this.repeatFormData = formData;
        this.openInsertModal();
      } else {
        this.closeInsertModal();
        this.dialogSuccesInsert = false;
        this.dialogSuccesInsert = true;
      }
      this.notificarDadosAlterados("inclusao", { recurso: formData });
    },

    onImportacaoExcelConcluida(resultado) {
      this.refreshList();
      this.notificarDadosAlterados("importacao-excel", { resultado });
      this.$emit("importacao-concluida", resultado);
    },
    onAtualizacaoExcelConcluida(resultado) {
      this.refreshList();
      this.notificarDadosAlterados("atualizacao-excel", { resultado });
      this.$emit("atualizacao-concluida", resultado);
    },
    notificarDadosAlterados(tipo, detalhes = {}) {
      this.$emit("dados-alterados", {
        tipo,
        ...detalhes,
      });
    },
    onSubmitError() {
      console.log("onSubmitError");
      // this.closeEditarModal();
    },
    onSubmitErrorInsert() {
      console.log("onSubmitErrorInsert");
      // this.closeEditarModal();
    },
    // openEditarModal(item) {
    //   this.recursoAtual = item; // Set the current resource to be edited
    //   this.dialogEdit = true;
    // },

    filtrar() {
      this.page = 1;
      this.tablePage = 1;
      this.handleSearchChange();
    },
    atualizarInquilino() {
      return this.atualizarCotacoes("atualizar-inquilino");
    },
    atualizarTodosInquilino() {
      return this.atualizarCotacoes("atualizar-todos-inquilinos");
    },
    async atualizarCotacoes(operacao) {
      if (this.loading) return;
      this.loading = true;
      this.errors = [];
      try {
        await ComumDataService.post(
          `operacaoMoedaCotacao/${operacao}?data=${this.encerramentoPeriodo}&forcarAtualizacao=${this.forcarAtualizacao}`,
        );
      } catch (error) {
        this.errors = [
          {
            fieldName: "Cotação",
            message:
              error?.response?.data?.message ||
              "Não foi possível atualizar as cotações.",
          },
        ];
      } finally {
        this.loading = false;
      }
    },
    handleFilterChange(event) {
      console.log("current-items", event);
    },

    editRecurso(id) {
      console.log(id);
      this.$router.push({
        name: "editar." + this.nomeSingular.toLowerCase(),
        params: { id: id },
      });
    },

    buildExportParams() {
      if (this.statusFinanceiro === "") {
        this.statusFinanceiro = null;
      }
      if (this.statusFuncionario === "") {
        this.statusFuncionario = null;
      }
      if (this.dsStatusFuncionario === "") {
        this.dsStatusFuncionario = null;
      }
      if (this.situacaoMovimentacaoContaVinculada === "") {
        this.situacaoMovimentacaoContaVinculada = null;
      }
      if (this.statusComumFiltro === "") {
        this.statusComumFiltro = null;
      }

      return {
        vencimentoInicio: this.vencimentoInicio,
        vencimentoFim: this.vencimentoFim,
        detalhes: this.detalhe,
        titulo: this.titulo,
        descricao: this.descricao,
        contas: this.itemsContaFinanceira,
        fornecedores: this.itemsFornecedor,
        numeroRegistro: this.numeroRegistro,
        clientes: this.getClientesFilterPayload(),
        cliente: this.clienteLike,
        postoTrabalho: this.postoTrabalhoLike,
        registrador: this.registradorLike,
        valor: this.valorFinanceiro,
        status: this.statusFinanceiro,
        statusFuncionario: this.statusFuncionario,
        dsStatusFuncionario: this.dsStatusFuncionario,
        statusComum: this.statusComumFiltro,
        funcionarios: this.itemsFuncionario,
        convenios: this.itemsBeneficioConvenio,
        moedas: this.itemsMoedas,
        forcarAtualizacao: this.forcarAtualizacao,
        itemsProvedor: this.itemsProvedor,
        postoTrabalhos: this.getPostoTrabalhosFilterPayload(),
        cargos: this.itemsCargo,
        matricula: this.matricula,
        idPedido: this.idPedido,
        nome: this.nome,
        nomeCpf: this.nomeCpf,
        nomeFuncionario: this.nomeFuncionario,
        data: this.data,
        pessoas: this.itemsPessoa,
        faturado: this.faturado,
        inicioPeriodo: this.inicioPeriodo,
        encerramentoPeriodo: this.encerramentoPeriodo,
        competencia: this.competencia,
        situacaoMovimentacaoContaVinculada:
          this.situacaoMovimentacaoContaVinculada,
        contaVinculada: this.contaVinculada,
        identificador: this.identificador || null,
        tipoVisualizacaoEmpresa: this.tipoVisualizacaoEmpresa || null,
        ...this.getCustomFilterPayload(),
      };
    },
    getFiltrosGenericosConfigurados() {
      return [
        ...this.filtrosGenericosString,
        ...this.filtrosGenericosNumericos,
      ];
    },
    getFiltrosGenericosPayload() {
      if (
        !this.getFiltrosGenericosConfigurados().length &&
        !this.pesquisaStatusComum
      ) {
        return {};
      }

      const filtrosGenericos = {};
      if (
        this.pesquisaStatusComum &&
        this.valorFiltroPreenchido(this.statusComumFiltro)
      ) {
        filtrosGenericos.statusComum = this.statusComumFiltro;
      }
      this.filtrosGenericosString.forEach((filtro) => {
        const valor = this.filtrosGenericosValores[filtro.coluna];
        if (valor !== "" && valor !== null && valor !== undefined) {
          filtrosGenericos[filtro.coluna] = valor;
        }
      });
      this.filtrosGenericosNumericos.forEach((filtro) => {
        const valor = this.filtrosGenericosValores[filtro.coluna];
        if (valor !== "" && valor !== null && valor !== undefined) {
          filtrosGenericos[filtro.coluna] = Number(valor);
        }
      });

      return { filtrosGenericos };
    },
    possuiFiltrosGenericosAtivos() {
      return this.getFiltrosGenericosConfigurados().some((filtro) =>
        this.valorFiltroPreenchido(
          this.filtrosGenericosValores[filtro.coluna]
        )
      );
    },
    getCustomFilterPayload() {
      if (typeof this.customFilterPayload !== "function") {
        return {};
      }
      const payload = this.customFilterPayload();
      if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
        return {};
      }
      return payload;
    },
    getClientesFilterPayload() {
      if (this.pesquisaClienteLike && !this.pesquisaCliente) {
        return [];
      }
      return this.itemsCliente;
    },
    normalizarFiltroLista(value) {
      if (Array.isArray(value)) {
        return value;
      }
      if (value === null || value === undefined || value === "") {
        return [];
      }
      return [value];
    },
    getPostoTrabalhosFilterPayload() {
      if (this.pesquisaPostoTrabalhoLike && !this.pesquisaPostoTrabalho) {
        return [];
      }
      return this.itemsPostoTrabalho;
    },
    hasCustomFiltersAtivos() {
      if (typeof this.customFiltersAtivos !== "function") {
        return false;
      }
      return this.customFiltersAtivos() === true;
    },
    valorFiltroPreenchido(value) {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (value === null || value === undefined) {
        return false;
      }
      if (typeof value === "string") {
        return value.length > 0;
      }
      if (typeof value === "object") {
        return Object.keys(value).length > 0;
      }
      return true;
    },
    possuiFiltrosParametrizadosAtivos(possuiCustomFiltersAtivos) {
      return (
        this.valorFiltroPreenchido(this.detalhe) ||
        this.valorFiltroPreenchido(this.titulo) ||
        this.valorFiltroPreenchido(this.descricao) ||
        this.valorFiltroPreenchido(this.itemsContaFinanceira) ||
        this.valorFiltroPreenchido(this.itemsFornecedor) ||
        this.valorFiltroPreenchido(this.numeroRegistro) ||
        this.valorFiltroPreenchido(this.itemsCliente) ||
        this.valorFiltroPreenchido(this.valorFinanceiro) ||
        this.valorFiltroPreenchido(this.statusFinanceiro) ||
        this.valorFiltroPreenchido(this.statusFuncionario) ||
        this.valorFiltroPreenchido(this.dsStatusFuncionario) ||
        this.valorFiltroPreenchido(this.statusComumFiltro) ||
        this.valorFiltroPreenchido(this.itemsFuncionario) ||
        this.valorFiltroPreenchido(this.itemsBeneficioConvenio) ||
        this.valorFiltroPreenchido(this.itemsMoedas) ||
        this.valorFiltroPreenchido(this.forcarAtualizacao) ||
        this.valorFiltroPreenchido(this.itemsProvedor) ||
        this.valorFiltroPreenchido(this.itemsPostoTrabalho) ||
        this.valorFiltroPreenchido(this.postoTrabalhoLike) ||
        this.valorFiltroPreenchido(this.registradorLike) ||
        this.valorFiltroPreenchido(this.itemsCargo) ||
        this.valorFiltroPreenchido(this.matricula) ||
        this.valorFiltroPreenchido(this.idPedido) ||
        this.valorFiltroPreenchido(this.nome) ||
        this.valorFiltroPreenchido(this.nomeCpf) ||
        this.valorFiltroPreenchido(this.nomeFuncionario) ||
        this.valorFiltroPreenchido(this.data) ||
        this.pesquisaVencimento ||
        this.pesquisaPeriodo ||
        (this.faturado !== null && this.faturado !== undefined) ||
        this.valorFiltroPreenchido(this.itemsPessoa) ||
        this.valorFiltroPreenchido(this.situacaoMovimentacaoContaVinculada) ||
        this.valorFiltroPreenchido(this.clienteLike) ||
        this.valorFiltroPreenchido(this.contaVinculada) ||
        this.valorFiltroPreenchido(this.contaBancaria) ||
        this.valorFiltroPreenchido(this.identificador) ||
        this.valorFiltroPreenchido(this.tipoVisualizacaoEmpresa) ||
        this.possuiFiltrosGenericosAtivos() ||
        possuiCustomFiltersAtivos
      );
    },
    buildFilterPayload(customFilterPayload = this.getCustomFilterPayload()) {
      if (this.valorFinanceiro === "0.00") {
        this.valorFinanceiro = null;
      }
      if (this.statusFinanceiro === "") {
        this.statusFinanceiro = null;
      }
      if (this.statusFuncionario === "") {
        this.statusFuncionario = null;
      }
      if (this.dsStatusFuncionario === "") {
        this.dsStatusFuncionario = null;
      }
      if (this.statusComumFiltro === "") {
        this.statusComumFiltro = null;
      }
      if (this.situacaoMovimentacaoContaVinculada === "") {
        this.situacaoMovimentacaoContaVinculada = null;
      }
      if (this.clienteLike === "") {
        this.clienteLike = null;
      }
      if (this.postoTrabalhoLike === "") {
        this.postoTrabalhoLike = null;
      }
      if (this.registradorLike === "") {
        this.registradorLike = null;
      }

      return {
        vencimentoInicio: this.vencimentoInicio,
        vencimentoFim: this.vencimentoFim,
        detalhes: this.detalhe,
        titulo: this.titulo,
        descricao: this.descricao,
        contas: this.itemsContaFinanceira,
        fornecedores: this.itemsFornecedor,
        numeroRegistro: this.numeroRegistro,
        clientes: this.getClientesFilterPayload(),
        cliente: this.clienteLike,
        postoTrabalho: this.postoTrabalhoLike,
        registrador: this.registradorLike,
        valor: this.valorFinanceiro,
        status: this.statusFinanceiro,
        statusComum: this.statusComumFiltro,
        statusFuncionario: this.statusFuncionario,
        dsStatusFuncionario: this.dsStatusFuncionario,
        funcionarios: this.itemsFuncionario,
        convenios: this.itemsBeneficioConvenio,
        itemsMoedas: this.itemsMoedas,
        forcarAtualizacao: this.forcarAtualizacao,
        itemsProvedor: this.itemsProvedor,
        postoTrabalhos: this.getPostoTrabalhosFilterPayload(),
        cargos: this.itemsCargo,
        matricula: this.matricula,
        idPedido: this.idPedido,
        nome: this.nome,
        nomeCpf: this.nomeCpf,
        nomeFuncionario: this.nomeFuncionario,
        data: this.data,
        pessoas: this.itemsPessoa,
        faturado: this.faturado,
        inicioPeriodo: this.inicioPeriodo,
        encerramentoPeriodo: this.encerramentoPeriodo,
        competencia: this.competencia,
        situacaoMovimentacaoContaVinculada:
          this.situacaoMovimentacaoContaVinculada,
        contaVinculada: this.contaVinculada,
        contaBancaria: this.contaBancaria,
        identificador: this.identificador || null,
        tipoVisualizacaoEmpresa: this.tipoVisualizacaoEmpresa || null,
        ...this.getFiltrosGenericosPayload(),
        ...customFilterPayload,
        ...this.mergeFiltrosGenericos(customFilterPayload),
      };
    },
    mergeFiltrosGenericos(customFilterPayload) {
      const custom = customFilterPayload?.filtrosGenericos;
      if (!custom || typeof custom !== "object") {
        return {};
      }
      return {
        filtrosGenericos: {
          ...this.getFiltrosGenericosPayload().filtrosGenericos,
          ...custom,
        },
      };
    },
    isEditAvailable(item) {
      if (typeof this.editDisponivel !== "function") {
        return true;
      }
      return this.editDisponivel(item) !== false;
    },
    isDeleteAvailable(item) {
      if (typeof this.deleteDisponivel !== "function") {
        return true;
      }
      return this.deleteDisponivel(item) !== false;
    },
    isReplicateAvailable(item) {
      if (typeof this.replicarDisponivel !== "function") {
        return true;
      }
      return this.replicarDisponivel(item) !== false;
    },
    getCustomRowActions(item) {
      if (!Array.isArray(this.customRowActions)) {
        return [];
      }
      return this.customRowActions.filter((action) => {
        return this.isCustomRowActionVisible(action, item);
      });
    },
    isCustomRowActionVisible(action, item) {
      if (!action || typeof action !== "object") {
        return false;
      }
      if (
        Array.isArray(action.statuses) &&
        action.statuses.length &&
        !action.statuses.includes(item?.status)
      ) {
        return false;
      }
      if (typeof action.visible === "function") {
        return action.visible(item, { listagem: this }) !== false;
      }
      return true;
    },
    getCustomRowActionKey(action, index) {
      return `${
        action?.value || action?.title || action?.icon || "action"
      }-${index}`;
    },
    executarCustomRowAction(action, item) {
      if (!action || typeof action !== "object") {
        return;
      }
      const service = this.$parent?.DataService;
      const handler =
        typeof action.handler === "function"
          ? action.handler
          : action.method && this.$parent
          ? this.$parent[action.method]
          : null;

      if (typeof handler !== "function") {
        return;
      }

      const result = handler(item, { listagem: this, service });
      if (!result || typeof result.then !== "function") {
        return;
      }

      this.loading = true;
      result
        .then(() => {
          if (action.successMessage) {
            this.$swal.fire(
              this.$t("Sucesso"),
              this.$t(action.successMessage),
              "success",
            );
          }
          if (action.refreshAfter !== false) {
            this.refreshList();
          }
        })
        .catch((error) => {
          this.$swal.fire(
            this.$t("Erro"),
            action.errorMessage
              ? this.$t(action.errorMessage)
              : this.getApiErrorMessage(error),
            "error",
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isPrintAvailable(item) {
      if (typeof this.printDisponivel !== "function") {
        return true;
      }
      return this.printDisponivel(item) !== false;
    },
    isChangeTenantAvailable(item) {
      if (typeof this.alterarTenantDisponivel !== "function") {
        return true;
      }
      return this.alterarTenantDisponivel(item) !== false;
    },
    isRowActionsAvailable(item) {
      if (typeof this.acoesDisponiveis !== "function") {
        return true;
      }
      return this.acoesDisponiveis(item) !== false;
    },
    isUploadAuditoriaAvailable(item) {
      return (
        [
          "CaixaForteAuditoria",
          "TransporteChaveAuditoria",
          "ArmaFogoAuditoria",
        ].includes(this.nomeSingular) &&
        item &&
        item.encerrada &&
        this.$parent &&
        typeof this.$parent.selecionarArquivo === "function"
      );
    },
    uploadAuditoria(item) {
      if (!this.isUploadAuditoriaAvailable(item)) {
        return;
      }
      this.$parent.selecionarArquivo(item);
    },

    exportCSV() {
      this.loading = true;

      const params = {
        responseType: "blob",
        ...this.buildExportParams(),
      };

      this.$parent.DataService.export(params)
        .then((res) => {
          this.loading = false;
          this.download(res.data, "Cajupe_Export.csv", "text/csv");
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success",
          );
        })
        .catch((err) => {
          this.loading = false;
          console.log("err", err);
        });
    },

    exportExcel() {
      this.loading = true;

      const params = {
        responseType: "blob",
        ...this.buildExportParams(),
      };
      const config = { responseType: "blob" };
      const service = this.$parent.DataService;
      const exportFn = service.exportExcel
        ? service.exportExcel
        : service.export;

      exportFn
        .call(service, params, config)
        .then((res) => {
          this.loading = false;
          this.download(
            res.data,
            "Cajupe_Export.xlsx",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          );
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success",
          );
        })
        .catch((err) => {
          this.loading = false;
          console.log("err", err);
        });
    },

    exportPDF() {
      this.loading = true;

      const params = this.buildExportParams();

      this.$parent.DataService.exportPdf(params, { responseType: "blob" })
        .then((res) => {
          this.loading = false;
          console.log("res.data", res.data);
          this.download(res.data, "Document.pdf", "application/pdf");
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success",
          );
        })
        .catch((err) => {
          this.loading = false;
          console.log("err", err);
        });
    },

    async gerarImpressao(tipo) {
      this.impressaoMenu = false;
      this.loading = true;
      this.$emit("update:isReport", true);
      try {
        const itens = await this.coletarItensImpressao();
        if (!itens.length) {
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nenhum_registro_para_impressao"),
            "warning",
          );
          return;
        }

        if (tipo === "pdf") {
          this.gerarPdfImpressao(itens);
        } else if (tipo === "xls") {
          this.gerarXlsImpressao(itens);
        } else if (tipo === "csv") {
          this.gerarCsvImpressao(itens);
        } else if (tipo === "txt") {
          this.gerarTxtImpressao(itens);
        }

        this.$swal.fire(
          this.$t("Sucesso"),
          this.$t("Documento_gerado_com_sucesso"),
          "success",
        );
      } catch (e) {
        console.log(e);
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Tente_novamente_mais_tarde"),
          "error",
        );
      } finally {
        this.loading = false;
        this.$emit("update:isReport", false);
      }
    },
    async coletarItensImpressao() {
      if (this.buscaParametrizadaPaginada) {
        const itens = await this.buscarTodosRegistrosFiltradosPaginados(
          this.buildFilterPayload(),
        );
        return this.ordenarItensPorCampos(itens);
      }

      if (this.isSearching) {
        let itens = Array.isArray(this.recursos) ? [...this.recursos] : [];
        if (this.buscaSimplificada && this.search) {
          itens = this.filtrarItensPorBusca(itens, this.search);
        }
        return this.ordenarItensPorCampos(itens);
      }

      if (this.ordenacaoLocalAtiva && this.recursosOrdenacaoLocal.length) {
        return this.ordenarItensPorCampos(this.recursosOrdenacaoLocal);
      }

      const itens = await this.buscarTodosRegistrosPaginados();
      return this.ordenarItensPorCampos(itens);
    },
    async buscarTodosRegistrosFiltradosPaginados(payload) {
      const service = this.$parent?.DataService;
      if (!service || typeof service.getFilterPage !== "function") {
        return [];
      }

      const pageSize = Math.max(Number(this.pageSize) || 8, 100);
      const orderBy = this.getServerSortFieldForFetch();
      const direction = orderBy ? this.direction : null;
      const getParams = (page) =>
        this.getRequestParams(
          page,
          pageSize,
          orderBy,
          direction,
          this.vencimentoInicio,
          this.vencimentoFim,
          this.data,
        );
      return coletarItensPaginados(
        (page) => service.getFilterPage(payload, getParams(page)),
        pageSize,
      );
    },

    filtrarItensPorBusca(items, search) {
      const termo = this.normalizarTermoBusca(search);
      if (!termo) {
        return items;
      }
      return (items || []).filter((item) => {
        return this.camposImpressao.some((campo) => {
          const value = this.formatarValorImpressao(
            this.getNestedValue(item, campo.value),
            campo,
          );
          return this.normalizarTermoBusca(value).includes(termo);
        });
      });
    },
    ordenarItensPorCampos(
      items,
      campos = this.appliedSortFields,
      direction = this.appliedDirection,
    ) {
      const lista = Array.isArray(items) ? [...items] : [];
      const camposOrdenacao = Array.isArray(campos)
        ? campos.filter(Boolean)
        : [];
      if (!camposOrdenacao.length) {
        return lista;
      }
      const direcao = direction === "DESC" ? -1 : 1;
      return lista.sort((a, b) => {
        for (const campo of camposOrdenacao) {
          const resultado = this.compararValores(
            this.getNestedValue(a, campo),
            this.getNestedValue(b, campo),
          );
          if (resultado !== 0) {
            return resultado * direcao;
          }
        }
        return 0;
      });
    },
    compararValores(a, b) {
      const aVazio = this.isValorVazio(a);
      const bVazio = this.isValorVazio(b);
      if (aVazio && bVazio) {
        return 0;
      }
      if (aVazio) {
        return 1;
      }
      if (bVazio) {
        return -1;
      }

      const valorA = this.normalizarValorOrdenacao(a);
      const valorB = this.normalizarValorOrdenacao(b);
      if (typeof valorA === "number" && typeof valorB === "number") {
        return valorA === valorB ? 0 : valorA > valorB ? 1 : -1;
      }

      return String(valorA).localeCompare(String(valorB), "pt-BR", {
        numeric: true,
        sensitivity: "base",
      });
    },
    normalizarValorOrdenacao(value) {
      if (typeof value === "boolean") {
        return value ? 1 : 0;
      }
      if (typeof value === "number") {
        return value;
      }
      if (value instanceof Date) {
        return value.getTime();
      }
      if (Array.isArray(value)) {
        return value
          .map((item) => this.normalizarValorOrdenacao(item))
          .join(", ");
      }
      if (value && typeof value === "object") {
        return this.getDescricaoObjeto(value);
      }

      const text = String(value || "").trim();
      if (/^\d{4}-\d{2}-\d{2}/.test(text)) {
        const timestamp = Date.parse(text);
        if (!Number.isNaN(timestamp)) {
          return timestamp;
        }
      }
      const textoNumerico = text.replace(/\s/g, "");
      if (/^(R\$)?-?[\d.]+(,\d+)?$|^-?\d+(\.\d+)?$/.test(textoNumerico)) {
        const numero = Number(
          textoNumerico
            .replace(/^R\$/, "")
            .replace(/\./g, "")
            .replace(",", "."),
        );
        if (!Number.isNaN(numero)) {
          return numero;
        }
      }
      return text.toLocaleLowerCase("pt-BR");
    },
    isValorVazio(value) {
      return (
        value === null ||
        value === undefined ||
        (typeof value === "string" && value.trim() === "")
      );
    },
    getNestedValue(item, path) {
      if (!item || !path) {
        return "";
      }
      return String(path)
        .split(".")
        .reduce((value, key) => {
          if (value === null || value === undefined) {
            return "";
          }
          return value[key];
        }, item);
    },
    montarTabelaImpressao(items, options = {}) {
      const headers = this.camposImpressao;
      const linhas = [
        headers.map((header) => {
          return header.text;
        }),
      ];
      (items || []).forEach((item) => {
        linhas.push(
          headers.map((header) => {
            return this.formatarValorImpressao(
              this.getNestedValue(item, header.value),
              header,
              options,
            );
          }),
        );
      });
      return linhas;
    },
    gerarXlsImpressao(items) {
      const linhas = this.montarTabelaImpressao(items, { output: "xls" });
      const worksheet = XLSX.utils.aoa_to_sheet(linhas);
      worksheet["!cols"] = this.calcularLargurasColunasImpressao(linhas);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        this.normalizarNomePlanilhaImpressao(this.$t(this.nomePlural)),
      );

      const conteudo = XLSX.write(workbook, { type: "array", bookType: "xls" });
      this.download(
        conteudo,
        this.getNomeArquivoImpressao("xls"),
        "application/vnd.ms-excel",
      );
    },
    gerarCsvImpressao(items) {
      const linhas = this.montarTabelaImpressao(items, { output: "csv" });
      const conteudo =
        "\ufeff" +
        linhas
          .map((linha) => {
            return linha.map((valor) => this.escaparCsv(valor)).join(";");
          })
          .join("\r\n");
      this.download(
        conteudo,
        this.getNomeArquivoImpressao("csv"),
        "text/csv;charset=utf-8",
      );
    },
    calcularLargurasColunasImpressao(linhas) {
      const larguras = [];
      (linhas || []).forEach((linha) => {
        (linha || []).forEach((valor, index) => {
          const tamanho = String(valor || "").length + 2;
          larguras[index] = Math.max(larguras[index] || 12, tamanho);
        });
      });
      return larguras.map((largura) => {
        return { wch: Math.min(largura, 48) };
      });
    },
    normalizarNomePlanilhaImpressao(nome) {
      return String(nome || "Listagem")
        .replace(/[[\]\\/?*:]/g, " ")
        .slice(0, 31);
    },
    gerarTxtImpressao(items) {
      const linhas = this.montarTabelaImpressao(items);
      const conteudo = linhas
        .map((linha) => {
          return linha
            .map((valor) => String(valor || "").replace(/[|\t\r\n]+/g, " "))
            .join("|");
        })
        .join("\r\n");
      this.download(
        conteudo,
        this.getNomeArquivoImpressao("txt"),
        "text/plain;charset=utf-8",
      );
    },
    gerarPdfImpressao(items) {
      const popup = window.open("", "_blank");
      if (!popup) {
        throw new Error("Nao foi possivel abrir a janela de impressao.");
      }

      popup.document.open();
      popup.document.write(this.montarHtmlPdfImpressao(items));
      popup.document.close();

      setTimeout(() => {
        if (!popup.closed) {
          popup.focus();
          popup.print();
        }
      }, 500);
    },
    formatarValorImpressao(value, header = {}, options = {}) {
      if (value === null || value === undefined) {
        return "";
      }
      if (typeof value === "boolean") {
        return this.$t(value ? "sim" : "nao");
      }
      if (Array.isArray(value)) {
        return value
          .map((item) => this.formatarValorImpressao(item, header, options))
          .join(", ");
      }
      if (value instanceof Date) {
        return value.toLocaleString("pt-BR");
      }
      if (value && typeof value === "object") {
        return this.getDescricaoObjeto(value);
      }

      const text = String(value);
      if (/^\d{4}-\d{2}-\d{2}/.test(text)) {
        return this.$options.filters.dataHoraParaLeitura(text) || text;
      }

      if (this.isCampoMonetario(header.value)) {
        if (options.output === "csv" || options.output === "xls") {
          const numeroMonetario = this.normalizarNumeroMonetarioCsv(value);
          if (numeroMonetario !== null) {
            if (options.output === "xls") {
              return numeroMonetario;
            }
            return this.formatarNumeroMonetarioCsv(numeroMonetario);
          }
        }
      }

      if (typeof value === "number") {
        if (this.isCampoMonetario(header.value)) {
          return this.$options.filters.formatoMonetario(value);
        }
        return value.toLocaleString("pt-BR");
      }
      return text;
    },
    formatarNumeroMonetarioCsv(value) {
      const valueNumber = Number(value);
      if (Number.isNaN(valueNumber)) {
        return "";
      }
      return valueNumber.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true,
      });
    },
    normalizarNumeroMonetarioCsv(value) {
      if (typeof value === "number") {
        return Number.isFinite(value) ? value : null;
      }

      const texto = String(value || "").trim();
      if (!texto) {
        return null;
      }

      let normalizado = texto.replace(/[^\d,.-]/g, "");
      if (!normalizado) {
        return null;
      }

      if (normalizado.includes(",")) {
        normalizado = normalizado.replace(/\./g, "").replace(",", ".");
      }

      const valueNumber = Number(normalizado);
      return Number.isNaN(valueNumber) ? null : valueNumber;
    },
    getDescricaoObjeto(value) {
      const campos = [
        "descricao",
        "nome",
        "fantasia",
        "razaoSocial",
        "email",
        "id",
      ];
      const campo = campos.find((item) => {
        return value[item] !== null && value[item] !== undefined;
      });
      if (campo) {
        return String(value[campo]);
      }
      try {
        return JSON.stringify(value);
      } catch (e) {
        return "";
      }
    },
    isCampoMonetario(value) {
      return /valor|saldo|salario|limite|total/i.test(String(value || ""));
    },
    escaparCsv(value) {
      const text = String(value || "");
      const escaped = text.replace(/"/g, '""');
      return /[;"\r\n]/.test(escaped) ? `"${escaped}"` : escaped;
    },
    montarHtmlPdfImpressao(items) {
      const dados = this.getDadosRelatorioImpressao(items);
      return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${this.escaparHtml(dados.titulo)}</title>
  <style>${this.montarCssPdfImpressao()}</style>
</head>
<body>
  ${this.montarRodapePdfImpressao(dados)}
  ${this.montarCabecalhoPdfImpressao(dados)}
  ${this.montarResumoPdfImpressao(dados)}
  ${this.montarItensPdfImpressao(items)}
</body>
</html>`;
    },
    montarCssPdfImpressao() {
      return `
    body {
      color: #17212b;
      font-family: Helvetica, Arial, sans-serif;
      font-size: 10px;
      line-height: 1.35;
      margin: 0;
      padding-bottom: 34px;
    }

    @page {
      size: A4 landscape;
      margin: 14mm 12mm 18mm 12mm;

      @bottom-left {
        content: element(footer);
        font-size: 10px;
      }

      @bottom-right {
        content: "Página " counter(page) " de " counter(pages);
        font-size: 10px;
      }
    }

    #footer {
      align-items: center;
      background: #fff;
      border-top: 1px solid #d7dee8;
      bottom: 0;
      color: #4a5565;
      display: flex;
      font-size: 10px;
      justify-content: space-between;
      left: 0;
      padding: 6px 0 0;
      position: fixed;
      right: 0;
    }

    #footer .footer-pages:after {
      content: "Página " counter(page) " de " counter(pages);
    }

    .report-header {
      align-items: flex-start;
      border-bottom: 1px solid #b9c5d3;
      display: flex;
      gap: 12px;
      margin-bottom: 12px;
      padding-bottom: 10px;
    }

    .report-logo {
      flex: 0 0 65px;
      height: 65px;
      width: 65px;
    }

    .report-logo img {
      height: 65px;
      object-fit: contain;
      width: 65px;
    }

    .report-logo-placeholder {
      align-items: center;
      background: #eef2f6;
      border: 1px solid #d7dee8;
      color: #51606f;
      display: flex;
      font-size: 18px;
      font-weight: bold;
      height: 65px;
      justify-content: center;
      text-transform: uppercase;
      width: 65px;
    }

    .report-title {
      color: #17212b;
      font-size: 17px;
      font-weight: bold;
      letter-spacing: 0.5px;
      margin: 0 0 5px;
      text-transform: uppercase;
    }

    .tenant-name {
      color: #273445;
      font-size: 12px;
      font-weight: bold;
      margin-bottom: 2px;
      text-transform: uppercase;
    }

    .tenant-line {
      color: #4a5565;
      font-size: 10px;
      margin-top: 1px;
      text-transform: uppercase;
    }

    .report-summary {
      border: 1px solid #d7dee8;
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      margin-bottom: 12px;
    }

    .summary-item {
      border-right: 1px solid #d7dee8;
      padding: 7px 9px;
    }

    .summary-item:last-child {
      border-right: 0;
    }

    .summary-label,
    .field-label {
      color: #697586;
      display: block;
      font-size: 8px;
      font-weight: bold;
      letter-spacing: 0.2px;
      text-transform: uppercase;
    }

    .summary-value {
      color: #17212b;
      display: block;
      font-size: 10px;
      margin-top: 2px;
      word-break: break-word;
    }

    .items-list {
      display: block;
    }

    .print-item {
      border: 1px solid #d7dee8;
      break-inside: avoid;
      display: grid;
      grid-template-columns: 58px minmax(0, 1fr);
      margin-bottom: 8px;
      page-break-inside: avoid;
    }

    .item-index {
      align-items: center;
      background: #eef2f6;
      border-right: 1px solid #d7dee8;
      color: #273445;
      display: flex;
      flex-direction: column;
      font-weight: bold;
      justify-content: center;
      padding: 8px 4px;
      text-align: center;
    }

    .item-index span {
      color: #697586;
      display: block;
      font-size: 8px;
      font-weight: normal;
      margin-top: 2px;
      text-transform: uppercase;
    }

    .item-fields {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .field {
      border-bottom: 1px solid #eef2f6;
      border-right: 1px solid #eef2f6;
      min-height: 34px;
      padding: 7px 9px;
    }

    .field:nth-child(3n) {
      border-right: 0;
    }

    .field-value {
      color: #17212b;
      display: block;
      font-size: 10px;
      margin-top: 2px;
      min-height: 12px;
      overflow-wrap: anywhere;
      white-space: pre-wrap;
    }

    @media print {
      body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      .print-item {
        break-inside: avoid;
        page-break-inside: avoid;
      }
    }`;
    },
    montarCabecalhoPdfImpressao(dados) {
      const logo = dados.logo
        ? `<img src="${this.escaparHtml(dados.logo)}" alt="">`
        : `<div class="report-logo-placeholder">${this.escaparHtml(
            dados.iniciais,
          )}</div>`;

      return `<div class="report-header">
    <div class="report-logo">${logo}</div>
    <div>
      <h1 class="report-title">${this.escaparHtml(dados.titulo)}</h1>
      <div class="tenant-name">${this.escaparHtml(dados.razaoSocial)}</div>
      <div class="tenant-line"><strong>${this.escaparHtml(
        this.$t("CNPJ"),
      )}:</strong> ${this.escaparHtml(dados.nRegistro)}</div>
      <div class="tenant-line">${this.escaparHtml(dados.endereco)}</div>
    </div>
  </div>`;
    },
    montarRodapePdfImpressao(dados) {
      return `<div id="footer">
    <span>${this.escaparHtml("Impresso por")} ${this.escaparHtml(
        dados.usuario,
      )} ${this.escaparHtml("em")} ${this.escaparHtml(
        dados.dataImpressao,
      )} ${this.escaparHtml("as")} ${this.escaparHtml(
        dados.horaImpressao,
      )}</span>
    <span class="footer-pages"></span>
  </div>`;
    },
    montarResumoPdfImpressao(dados) {
      const itens = [
        { label: this.$t("Gerado_em"), value: dados.dataHoraImpressao },
        { label: this.$t("Registros"), value: dados.quantidadeRegistros },
        { label: this.$t("Ordenacao"), value: dados.ordenacao },
        { label: this.$t("Campos"), value: dados.quantidadeCampos },
      ];
      return `<div class="report-summary">${itens
        .map((item) => {
          return `<div class="summary-item">
      <span class="summary-label">${this.escaparHtml(item.label)}</span>
      <span class="summary-value">${this.escaparHtml(item.value)}</span>
    </div>`;
        })
        .join("")}</div>`;
    },
    montarItensPdfImpressao(items) {
      const campos = this.camposImpressao;
      return `<div class="items-list">${(items || [])
        .map((item, index) => {
          const camposHtml = campos
            .map((header) => {
              const valor = this.formatarValorImpressao(
                this.getNestedValue(item, header.value),
                header,
              );
              return `<div class="field">
        <span class="field-label">${this.escaparHtml(header.text)}</span>
        <span class="field-value">${this.escaparHtml(
          this.isValorVazio(valor) ? "-" : valor,
        )}</span>
      </div>`;
            })
            .join("");

          return `<section class="print-item">
      <div class="item-index">#${String(index + 1).padStart(
        3,
        "0",
      )}<span>${this.escaparHtml(this.$t("Registro"))}</span></div>
      <div class="item-fields">${camposHtml}</div>
    </section>`;
        })
        .join("")}</div>`;
    },
    getDadosRelatorioImpressao(items) {
      const agora = new Date();
      const inquilino = this.getInquilinoSessaoImpressao();
      const razaoSocial =
        inquilino.razaoSocial || inquilino.fantasia || this.$t("Inquilino");
      return {
        titulo: `${this.$t("Impressao")} - ${this.$t(this.nomePlural)}`,
        razaoSocial,
        iniciais: this.getIniciaisImpressao(razaoSocial),
        nRegistro: this.getNRegistroInquilinoImpressao(inquilino) || "-",
        endereco: this.formatarEnderecoInquilinoImpressao(inquilino) || "-",
        logo: this.normalizarLogoInquilinoImpressao(inquilino),
        usuario: this.getNomeUsuarioSessaoImpressao(),
        dataHoraImpressao: agora.toLocaleString("pt-BR"),
        dataImpressao: agora.toLocaleDateString("pt-BR"),
        horaImpressao: agora.toLocaleTimeString("pt-BR", {
          hour: "2-digit",
          minute: "2-digit",
        }),
        quantidadeRegistros: (items || []).length,
        quantidadeCampos: this.camposImpressao.length,
        ordenacao: this.getDescricaoOrdenacao(),
      };
    },
    getInquilinoSessaoImpressao() {
      const candidatos = [
        this.$store?.state?.inquilino,
        this.getStorageJsonImpressao("inquilino"),
        this.getStorageJsonImpressao("tenant"),
        this.$store?.state?.user?.inquilino,
        this.getStorageJsonImpressao("user")?.inquilino,
      ];
      return (
        candidatos.find((item) => {
          return item && typeof item === "object" && Object.keys(item).length;
        }) || {}
      );
    },
    getStorageJsonImpressao(key) {
      if (typeof window === "undefined") {
        return null;
      }

      const storages = [window.sessionStorage, window.localStorage];
      for (const storage of storages) {
        try {
          const raw = storage?.getItem(key);
          if (!raw) {
            continue;
          }
          return JSON.parse(raw);
        } catch {
          continue;
        }
      }
      return null;
    },
    getNomeUsuarioSessaoImpressao() {
      const user =
        this.$store?.state?.user || this.getStorageJsonImpressao("user") || {};
      return (
        user?.pessoa?.nome || user?.nome || user?.email || this.$t("usuario")
      );
    },
    getNRegistroInquilinoImpressao(inquilino) {
      const registro =
        inquilino?.nRegistro ||
        inquilino?.nregistro ||
        inquilino?.n_registro ||
        inquilino?.cnpj ||
        inquilino?.cpfCnpj;
      return this.formatNRegistro(registro);
    },
    formatarEnderecoInquilinoImpressao(inquilino) {
      const endereco = inquilino?.endereco || {};
      const cidade = endereco.cidade || {};
      const estado = cidade.estado || endereco.estado || {};
      const logradouroNumero = [endereco.logradouro, endereco.numero]
        .filter(Boolean)
        .join(", ");
      const cidadeUf = [
        cidade.nome || endereco.cidadeNome || endereco.nomeCidade,
        estado.sigla || cidade.uf || endereco.uf,
      ]
        .filter(Boolean)
        .join("/");
      const cep = this.formatarCepImpressao(endereco.cep);

      return [logradouroNumero, endereco.bairro, cidadeUf, cep && `CEP: ${cep}`]
        .filter(Boolean)
        .join(" - ");
    },
    formatarCepImpressao(value) {
      const digits = String(value || "").replace(/\D/g, "");
      if (digits.length === 8) {
        return digits.replace(/(\d{5})(\d{3})/, "$1-$2");
      }
      return value || "";
    },
    normalizarLogoInquilinoImpressao(inquilino) {
      const imagem = inquilino?.imagem64 || inquilino?.imagem || "";
      if (!imagem || imagem === "string") {
        return "";
      }
      if (/^(data:image\/|https?:\/\/|\/)/i.test(imagem)) {
        return imagem;
      }
      return `data:image/png;base64,${imagem}`;
    },
    getIniciaisImpressao(text) {
      const partes = String(text || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      if (!partes.length) {
        return "IN";
      }
      return partes
        .slice(0, 2)
        .map((item) => item.charAt(0))
        .join("");
    },
    escaparHtml(value) {
      return String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    getDescricaoOrdenacao() {
      if (!this.appliedSortFields.length) {
        return this.$t("NENHUM");
      }
      const campos = this.appliedSortFields
        .map((field) => {
          const item = this.camposOrdenacao.find(
            (campo) => campo.value === field,
          );
          return item ? item.text : field;
        })
        .join(", ");
      const direcao = this.directions.find((item) => {
        return item.value === this.appliedDirection;
      });
      return direcao ? `${campos} - ${direcao.text}` : campos;
    },
    getNomeArquivoImpressao(extensao) {
      const base = String(this.nomePlural || "listagem")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w-]+/g, "_")
        .replace(/^_+|_+$/g, "")
        .toLowerCase();
      const data = new Date().toISOString().slice(0, 19).replace(/[T:]/g, "-");
      return `${base || "listagem"}_${data}.${extensao}`;
    },

    confirmaTransferenciaEmpresa() {
      console.log("confirmaTransferenciaEmpresa");
      this.resetTransferenciaEmpresa();
      this.modalTransferenciaEmpresa = true;
    },
    replicateRecurso() {
      this.loading = true;
      this.$parent.DataService.replicate({
        item: this.objetoAtual,
        quantidade: this.quantidade,
        previsao: this.previsao,
      })
        .then(() => {
          this.retrieveData();
          this.quantidade = 0;
          this.confirmarReplicar = false;
          this.previsao = false;
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Replicado_com_sucesso"),
            "success",
          );
          this.loading = false;
        })
        .catch((error) => {
          this.confirmarReplicar = false;
          this.quantidade = 0;
          this.previsao = false;
          console.log(error);
          const mensagemErro = `${this.getApiErrorMessage(error)} ${this.$t(
            "Tente_novamente_mais_tarde",
          )}`;
          this.$swal.fire(this.$t("Erro"), mensagemErro, "error");
          this.loading = false;
        });
    },

    clearSelectedRows() {
      this.selectedRows = [];
      this.bulkActionSelected = null;
    },

    iniciarDelecaoEmLote() {
      if (!this.canDeleteSelection || this.loading || this.bulkActionLoading) {
        return;
      }
      this.bulkDeleteModeActive = true;
      this.clearSelectedRows();
    },

    encerrarDelecaoEmLote() {
      if (this.enableSelection) {
        return;
      }
      this.bulkDeleteModeActive = false;
      this.clearSelectedRows();
      this.delecaoEmLote = false;
      this.exclusaoMotivo = "";
      this.confirmar = false;
    },

    fecharModalDeletado() {
      this.deletado = false;
      this.deletadoQuantidade = 0;
      this.deletadoEmCascata = 0;
    },

    cancelarConfirmacaoDelete() {
      this.confirmar = false;
      this.delecaoEmLote = false;
      this.exclusaoMotivo = "";
      this.exclusaoOpcoes = {};
    },

    // Opções extras enviadas na exclusão, definidas pelo slot exclusaoDetalhes
    // (com opções, o modal fica mais largo para o conteúdo do slot).
    // Não enviadas: "bloqueada" impede confirmar enquanto o slot aguarda o
    // operador; "sequencial" exclui um item por vez, pois a exclusão de um pode
    // levar outros junto (response.data.excluidosEmCascata)
    definirExclusaoOpcoes(opcoes) {
      this.exclusaoOpcoes = { ...(opcoes || {}) };
    },

    resolveResourceId(recurso) {
      if (!recurso || typeof recurso !== "object") {
        return null;
      }
      const itemKey = this.itemKeyProp || "id";
      const id = recurso[itemKey];
      if (id !== undefined && id !== null) {
        return id;
      }
      return recurso.id !== undefined && recurso.id !== null
        ? recurso.id
        : null;
    },

    canEditInlineField(field) {
      if (!this.canInlineEdit) {
        return false;
      }
      const inlineFields = [
        "descricao",
        "detalhe",
        "vencimento",
        "competencia",
        "previsaoCompensacao",
      ];
      if (!inlineFields.includes(field)) {
        return false;
      }
      return this.headers.some((header) => {
        return header && header.value === field;
      });
    },

    isInlineEditing(item, field) {
      const itemId = this.resolveResourceId(item);
      return (
        itemId !== null &&
        this.inlineEdit.itemId === itemId &&
        this.inlineEdit.field === field
      );
    },

    startInlineEdit(item, field) {
      if (!this.canEditInlineField(field) || this.inlineEdit.loading) {
        return;
      }
      const itemId = this.resolveResourceId(item);
      if (itemId === null || itemId === undefined) {
        return;
      }
      this.inlineEdit = {
        itemId,
        field,
        value: this.prepareInlineInputValue(field, item[field]),
        loading: false,
      };
    },

    cancelInlineEdit() {
      this.inlineEdit = {
        itemId: null,
        field: null,
        value: "",
        loading: false,
      };
    },

    getInlineDisplayValue(item, field) {
      const value = item ? item[field] : null;
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      if (field === "vencimento" || field === "previsaoCompensacao") {
        return this.$options.filters.dataParaLeitura(value);
      }
      if (field === "competencia") {
        return this.$options.filters.competenciaParaLeitura(value);
      }
      return value;
    },

    formatDateToYmd(value) {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return "";
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    prepareInlineInputValue(field, value) {
      if (value === null || value === undefined) {
        return "";
      }
      const stringValue = String(value).trim();
      if (!stringValue) {
        return "";
      }
      if (field === "vencimento" || field === "previsaoCompensacao") {
        if (/^\d{4}-\d{2}-\d{2}/.test(stringValue)) {
          return stringValue.slice(0, 10);
        }
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(stringValue)) {
          const [dia, mes, ano] = stringValue.split("/");
          return `${ano}-${mes}-${dia}`;
        }
        return this.formatDateToYmd(stringValue);
      }
      if (field === "competencia") {
        if (/^\d{2}\/\d{4}$/.test(stringValue)) {
          return stringValue;
        }
        if (/^\d{4}-\d{2}(-\d{2})?$/.test(stringValue)) {
          const [ano, mes] = stringValue.split("-");
          return `${mes}/${ano}`;
        }
      }
      return stringValue;
    },

    normalizeInlineEditValue(field, value) {
      const raw = String(value || "").trim();
      if (!raw) {
        return null;
      }
      if (field === "descricao" || field === "detalhe") {
        return raw;
      }
      if (field === "vencimento" || field === "previsaoCompensacao") {
        if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
          return raw;
        }
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
          const [dia, mes, ano] = raw.split("/");
          return `${ano}-${mes}-${dia}`;
        }
        return null;
      }
      if (field === "competencia") {
        if (/^\d{2}\/\d{4}$/.test(raw)) {
          const [mes, ano] = raw.split("/");
          const mesNumero = Number(mes);
          if (mesNumero < 1 || mesNumero > 12) {
            return null;
          }
          return `${ano}-${mes}-01`;
        }
        if (/^\d{4}-\d{2}(-\d{2})?$/.test(raw)) {
          const [ano, mes] = raw.split("-");
          const mesNumero = Number(mes);
          if (mesNumero < 1 || mesNumero > 12) {
            return null;
          }
          return `${ano}-${mes}-01`;
        }
        return null;
      }
      return raw;
    },

    async saveInlineEdit(item, field) {
      if (!this.isInlineEditing(item, field)) {
        return;
      }
      const service = this.$parent?.DataService;
      if (!service || typeof service.update !== "function") {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Tente_novamente_mais_tarde"),
          "error",
        );
        return;
      }

      const normalizedValue = this.normalizeInlineEditValue(
        field,
        this.inlineEdit.value,
      );
      if (normalizedValue === null) {
        const mensagemInvalida =
          field === "descricao" || field === "detalhe"
            ? this.$t("Campo_obrigatorio")
            : this.$t("Data_invalida");
        this.$swal.fire(this.$t("Erro"), mensagemInvalida, "error");
        return;
      }

      const currentValue = this.normalizeInlineEditValue(
        field,
        this.prepareInlineInputValue(field, item[field]),
      );
      if (currentValue === normalizedValue) {
        this.cancelInlineEdit();
        return;
      }

      const editingId = this.inlineEdit.itemId;
      const editingField = this.inlineEdit.field;
      this.inlineEdit.loading = true;

      try {
        const payload = {
          ...item,
          [field]: normalizedValue,
        };
        const response = await service.update(payload);
        const recursoAtualizado =
          response && response.data && typeof response.data === "object"
            ? response.data
            : payload;
        Object.assign(item, recursoAtualizado);
        this.notificarDadosAlterados("edicao-inline", {
          recurso: recursoAtualizado,
        });
        this.cancelInlineEdit();
      } catch (error) {
        const apiErrors = error?.response?.data?.errors;
        if (Array.isArray(apiErrors) && apiErrors.length) {
          this.errors = apiErrors;
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Tente_novamente_mais_tarde"),
          "error",
        );
      } finally {
        if (
          this.inlineEdit.itemId === editingId &&
          this.inlineEdit.field === editingField
        ) {
          this.inlineEdit.loading = false;
        }
      }
    },

    deleteRecurso() {
      const service = this.$parent?.DataService;
      if (!service || typeof service.delete !== "function") {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Tente_novamente_mais_tarde"),
          "error",
        );
        this.cancelarConfirmacaoDelete();
        return;
      }

      const wasBulkDelete = this.delecaoEmLote;
      const recursosParaExcluir = wasBulkDelete
        ? this.selectedRows
        : [this.objetoAtual];
      const idsUnicos = [];
      const idsSet = new Set();
      recursosParaExcluir.forEach((item) => {
        const id = this.resolveResourceId(item);
        if (id === undefined || id === null || idsSet.has(id)) {
          return;
        }
        idsSet.add(id);
        idsUnicos.push(id);
      });

      if (!idsUnicos.length) {
        this.cancelarConfirmacaoDelete();
        return;
      }

      this.loading = true;
      this.errors = [];
      const extractDeleteWarning = (response) => {
        const motivo = response?.data?.motivo;
        return typeof motivo === "string" && motivo.trim()
          ? motivo.trim()
          : null;
      };
      const extractDeleteErrorMessage = (error) => {
        const responseData = error?.response?.data;
        const motivo = responseData?.motivo;
        if (typeof motivo === "string" && motivo.trim()) {
          return motivo.trim();
        }
        const message = responseData?.message;
        if (typeof message === "string" && message.trim()) {
          return message.trim();
        }
        const firstError = Array.isArray(responseData?.errors)
          ? responseData.errors.find((item) => item?.message)
          : null;
        if (firstError?.message) {
          return firstError.message;
        }
        return this.$t("Tente_novamente_mais_tarde");
      };
      const opcoesExclusao = { ...this.exclusaoOpcoes };
      const sequencial = opcoesExclusao.sequencial === true;
      delete opcoesExclusao.bloqueada;
      delete opcoesExclusao.sequencial;
      const payload = {
        ...opcoesExclusao,
        motivo: this.exclusaoMotivo,
      };
      const excluirId = (id) => {
        return service
          .delete(id, payload)
          .then((response) => {
            return { ok: true, id, response };
          })
          .catch((error) => {
            return { ok: false, id, error };
          });
      };
      const extractExcluidosEmCascata = (result) => {
        const ids = result.ok && result.response?.data?.excluidosEmCascata;
        return Array.isArray(ids) ? ids : [];
      };
      // Em sequência, um id já excluído junto com um anterior não é reenviado
      const requests = sequencial
        ? idsUnicos.reduce((anterior, id) => {
            return anterior.then((results) => {
              const jaExcluido = results.some((result) =>
                extractExcluidosEmCascata(result).includes(id),
              );
              if (jaExcluido) {
                return results;
              }
              return excluirId(id).then((result) => [...results, result]);
            });
          }, Promise.resolve([]))
        : Promise.all(idsUnicos.map(excluirId));

      requests
        .then((results) => {
          const excluidosEmCascata = new Set(
            results.flatMap(extractExcluidosEmCascata),
          );
          const successCount =
            results.filter((result) => {
              return result.ok;
            }).length + excluidosEmCascata.size;
          const warnings = results
            .filter((result) => result.ok)
            .map((result) => extractDeleteWarning(result.response))
            .filter(Boolean);
          const failures = results.filter((result) => {
            return !result.ok;
          });

          if (successCount > 0) {
            this.notificarDadosAlterados("exclusao", {
              quantidade: successCount,
            });
          }

          if (!failures.length) {
            this.clearSelectedRows();
            this.refreshList();
            if (warnings.length) {
              this.$swal.fire(
                this.$t("Atencao"),
                warnings.join(" | "),
                "warning",
              );
              return;
            }
            this.deletadoQuantidade = successCount;
            // Selecionados que saíram junto com outro contam como selecionados
            this.deletadoEmCascata = [...excluidosEmCascata].filter(
              (id) => !idsSet.has(id),
            ).length;
            this.deletado = true;
            return;
          }

          const firstError = failures[0]?.error;
          const apiErrors = firstError?.response?.data?.errors;
          const hasApiErrors = Array.isArray(apiErrors) && apiErrors.length > 0;
          if (hasApiErrors) {
            this.errors = apiErrors;
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          }

          if (successCount > 0) {
            this.clearSelectedRows();
            this.refreshList();
            const partialWarningMessage = warnings.length
              ? `${warnings.join(" | ")}${
                  failures.length
                    ? ` | ${successCount} ${this.$t("Sucesso")} / ${
                        failures.length
                      } ${this.$t("Erro")}`
                    : ""
                }`
              : `${successCount} ${this.$t("Sucesso")} / ${
                  failures.length
                } ${this.$t("Erro")}`;
            this.$swal.fire(
              this.$t("Atencao"),
              partialWarningMessage,
              "warning",
            );
          } else if (!hasApiErrors) {
            this.$swal.fire(
              this.$t("Erro"),
              extractDeleteErrorMessage(firstError),
              "error",
            );
          }
        })
        .catch(() => {
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Tente_novamente_mais_tarde"),
            "error",
          );
        })
        .finally(() => {
          this.cancelarConfirmacaoDelete();
          if (wasBulkDelete) {
            this.encerrarDelecaoEmLote();
          }
          this.loading = false;
          this.exclusaoMotivo = "";
        });
    },

    disponibilizarDocumentoFuncionarios() {
      console.log("disponibilizarDocumentoFuncionarios", this.itemsCargos);
      this.loading = true;
      this.$parent.DataService.disponibilizarDocumentoFuncionarios(
        this.objetoAtual.id,
        {
          clientes: this.normalizarFiltroLista(this.itemsCliente),
          postoTrabalhos: this.normalizarFiltroLista(this.itemsPostoTrabalho),
          cargos: this.normalizarFiltroLista(this.itemsCargo),
          matricula: this.matricula,
          nome: this.nome,
          nomeCpf: this.nomeCpf,
          variavelFixa01: this.variavelFixa01,
          variavelFixa02: this.variavelFixa02,
          variavelFixa03: this.variavelFixa03,
          variavelFixa04: this.variavelFixa04,
          variavelFixa05: this.variavelFixa05,
          variavelFixa06: this.variavelFixa06,
          variavelFixa07: this.variavelFixa07,
          variavelFixa08: this.variavelFixa08,
          variavelFixa09: this.variavelFixa09,
          variavelFixa10: this.variavelFixa10,
        },
      )
        .then(() => {
          this.confirmarDisponibilizacaoDocumento = false;
          this.loading = false;
          this.retrieveData();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success",
          );
        })
        .catch((error) => {
          this.confirmar = false;
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          this.confirmarDisponibilizacaoDocumento = false;
          this.errors = error.response.data.errors;
          this.loading = false;
        });
    },

    forwardTableRowClick(item, rowProps, event) {
      this.keyboardActiveItemKey = this.keyboardItemKey(item);
      this.$nextTick(this.syncKeyboardRowTabIndexes);
      this.$emit("row-click", { item, rowProps, event });
    },

    isStatusComum: function (item) {
      if (item && item._rowClass) {
        return item._rowClass;
      } else if (item.statusPedido) {
        if (item.statusPedido === "CANCELADO") {
          return "INATIVO";
        }
        return item.statusPedido;
      } else if (item.situacao) {
        if (
          new Date(item.vencimento) < new Date() &&
          item.situacao == "PENDENTE"
        ) {
          return "VENCIDO";
        }

        return item.situacao;
      } else if (item.statusAtendimento && item.roteiro) {
        if (item.servicoAtrasado) {
          return "TRAJETOATRASADO";
        }
        const roteiroNumero = parseInt(item.roteiro);
        if (roteiroNumero % 2 !== 0) {
          if (item.statusAtendimento === "CONCLUIDO") {
            return "TRAJETOIMPARCONCLUIDO";
          } else if (item.statusAtendimento === "ANDAMENTO") {
            return "TRAJETOIMPARANDAMENTO";
          } else {
            return "TRAJETOIMPAR";
          }
        } else {
          if (item.statusAtendimento === "CONCLUIDO") {
            return "TRAJETOPARCONCLUIDO";
          } else if (item.statusAtendimento === "ANDAMENTO") {
            return "TRAJETOPARANDAMENTO";
          } else {
            return "TRAJETOPAR";
          }
        }
      } else if (item.statusAtendimento) {
        if (item.servicoAtrasado) {
          return "TRAJETOATRASADO";
        }
        return item.statusAtendimento;
      } else if (item.statusComum) {
        return item.statusComum;
      } else if (item.status) {
        if (item.status == "DESLIGADO") {
          return "INATIVO";
        } else {
          return item.status;
        }
      } else {
        return "ATIVO";
      }
    },

    podeConfirmarMovimentacaoDiaria(item) {
      if (this.nomeSingular !== "MovimentacaoDiaria") {
        return false;
      }
      const pessoaLogada = this.$store?.state?.user?.pessoa;
      if (!pessoaLogada || !pessoaLogada.id) {
        return false;
      }
      if (item.confirmacaoPresenca) {
        return false;
      }
      return item.pessoaAcionada;
    },

    confirmarMovimentacaoDiaria(item) {
      if (!this.$parent.DataService.confirmacaoPresenca) {
        return;
      }
      this.loading = true;
      this.$parent.DataService.confirmacaoPresenca(item.id)
        .then(() => {
          this.loading = false;
          this.retrieveData();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Confirmacao_registrada"),
            "success",
          );
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Falha_ao_confirmar"),
            "error",
          );
        });
    },

    //Modais de confirmação
    confirmaDeleteSelecionados() {
      if (!this.canDeleteSelection || this.bulkDeleteDisabled) {
        return;
      }
      this.objetoAtual = {};
      this.delecaoEmLote = true;
      this.exclusaoMotivo = "";
      this.exclusaoOpcoes = {};
      this.confirmar = true;
    },

    confirmaDelete(recurso) {
      this.objetoAtual = recurso;
      this.delecaoEmLote = false;
      this.exclusaoMotivo = "";
      this.exclusaoOpcoes = {};
      this.confirmar = true;
    },

    confirmaReplicate(recurso) {
      // A listagem pode tratar a replicação com o próprio modal
      if (this.$listeners.replicar) {
        this.$emit("replicar", recurso);
        return;
      }
      this.objetoAtual = recurso;
      this.confirmarReplicar = true;
    },

    confirmaTransbordo(recurso) {
      this.$emit("transbordo", recurso);
    },

    confirmaDisponibilizacaoDocumento(recurso) {
      if (this.nomeSingular === "ModeloDocumentacaoAcessoria") {
        if (!Array.isArray(this.clientes) || !this.clientes.length) {
          this.getClientes();
        }
        if (
          !Array.isArray(this.postoTrabalhos) ||
          !this.postoTrabalhos.length
        ) {
          this.getPostoTrabalhos();
        }
        if (!Array.isArray(this.cargos) || !this.cargos.length) {
          this.getCargos();
        }
      }
      this.objetoAtual = recurso;
      this.confirmarDisponibilizacaoDocumento = true;
    },

    confirmaAprovacao(recurso) {
      this.idDialog += 1;
      this.objetoAtual = recurso;
      this.modalConfirmaAprovacao = true;
    },

    confirmaGeracaoDocumento(recurso) {
      this.idDialog += 1;
      this.objetoAtual = recurso;
      this.modalConfirmaGeracaoDocumento = true;
    },

    confirmaExecucaoServico(recurso) {
      this.idDialog += 1;
      this.objetoAtual = recurso;
      console.log("confirmaExecucaoServico", this.objetoAtual);
      this.modalConfirmaExecucaoServico = true;
    },

    listGuias(recurso) {
      this.idDialog += 1;
      this.objetoAtual = recurso;
      this.modalGuias = true;
    },

    listTarefaExecucaoItems(recurso) {
      this.idDialog += 1;
      this.objetoAtual = recurso;
      this.modalTarefaExecucaoItems = true;
    },

    listEventosTv(recurso) {
      this.idDialog += 1;
      this.objetoAtual = recurso;
      this.eventosTv = [];
      this.loading = true;

      ComumDataService.get("roteiroTrajetos/eventos/" + recurso.id, {})
        .then((res) => {
          this.eventosTv = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });

      this.modalEventosTv = true;
    },

    confirmaNovoEventoTv() {
      this.idDialog += 1;
      this.eventosTvOpcoes = [];
      this.eventoTvAtual = {
        evento: {},
        ocorrencia: {},
        data: "",
        detalhes: "",
      };
      this.loading = true;
      ComumDataService.get("logisticaTipoEventos", {})
        .then((res) => {
          this.eventosTvOpcoes = res.data;
        })
        .catch(() => {});
      ComumDataService.get("logisticaTipoOcorrencias", {})
        .then((res) => {
          this.ocorrenciasTvOpcoes = res.data;
        })
        .catch(() => {});

      this.loading = false;

      this.modalEventoTv = true;
    },

    openEditarModalEventoTv(item) {
      this.eventoTvAtual = item;
      this.eventoTvAtual.ocorrencia = item.logisticaTipoOcorrencia;
      this.eventoTvAtual.evento = item.logisticaTipoEvento;
      this.loading = true;
      ComumDataService.get("logisticaTipoEventos", {})
        .then((res) => {
          this.eventosTvOpcoes = res.data;
        })
        .catch(() => {});
      ComumDataService.get("logisticaTipoOcorrencias", {})
        .then((res) => {
          this.ocorrenciasTvOpcoes = res.data;
        })
        .catch(() => {});

      console.log("openEditarModalEventoTv", this.eventoTvAtual);
      this.loading = false;
      this.modalEventoTv = true;
    },

    registroNovoEventoTv() {
      this.idDialog += 1;

      this.loading = true;

      if (this.eventoTvAtual.id === undefined) {
        ComumDataService.post("roteiroTrajetos/evento", {
          idTrajeto: this.objetoAtual.id,
          idOcorrencia: this.eventoTvAtual.ocorrencia.id,
          idEvento: this.eventoTvAtual.evento.id,
          data: this.eventoTvAtual.data,
          detalhes: this.eventoTvAtual.detalhes,
        })
          .then(() => {
            this.loading = false;
            this.modalEventoTv = false;

            this.listEventosTv(this.objetoAtual);
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        ComumDataService.put("roteiroTrajetos/evento", {
          id: this.eventoTvAtual.id,
          idTrajeto: this.objetoAtual.id,
          idOcorrencia: this.eventoTvAtual.ocorrencia.id,
          idEvento: this.eventoTvAtual.evento.id,
          data: this.eventoTvAtual.data,
          detalhes: this.eventoTvAtual.detalhes,
        })
          .then(() => {
            this.loading = false;
            this.modalEventoTv = false;

            this.listEventosTv(this.objetoAtual);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    printGtv(item) {
      this.$parent.DataService.get("guiaTransportes/print/" + item.id, {
        responseType: "blob",
      })
        .then((res) => {
          console.log("res", res, res.data);
          this.download(
            res.data,
            "GTV_" + item.numeroDocumento + ".pdf",
            "application/pdf",
          );
          this.loading = false;
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Falha_ao_exportar"),
            "error",
          );
        });
    },

    confirmaSeparacao(recurso) {
      this.objetoAtual = recurso;
      this.confirmarSeparacao = true;
    },

    confirmaDisponibilizacao(recurso) {
      this.objetoAtual = recurso;
      this.confirmarDisponibilizacao = true;
    },

    confirmaTroca(recurso) {
      this.objetoAtual = recurso;
      this.confirmarTroca = true;
    },

    confirmaRetiradoTerceiro(recurso) {
      this.objetoAtual = recurso;
      this.confirmarRetiradoTerceiro = true;
    },

    confirmaEntrega(recurso) {
      this.objetoAtual = recurso;
      this.confirmarEntrega = true;
    },

    confirmaRecebimento(recurso) {
      this.objetoAtual = recurso;
      this.confirmarRecebimento = true;
    },

    confirmaRetirada(recurso) {
      this.objetoAtual = recurso;
      this.confirmarRetirada = true;
    },

    confirmaEntregaTotal(recurso) {
      this.objetoAtual = recurso;
      this.confirmarEntregaTotal = true;
    },

    confirmaValidacaoFinanceira01(recurso) {
      this.objetoAtual = recurso;
      this.modalConfirmaValidacaoFinanceira01 = true;
    },
    confirmaValidacaoFinanceira02(recurso) {
      this.objetoAtual = recurso;
      this.modalConfirmaValidacaoFinanceira02 = true;
    },
    confirmaValidacaoFuncionarioAfastamento01(recurso) {
      this.objetoAtual = recurso;
      this.modalConfirmaValidacaoFuncionarioAfastamento01 = true;
    },
    confirmaValidacaoFuncionarioAfastamento02(recurso) {
      this.objetoAtual = recurso;
      this.modalConfirmaValidacaoFuncionarioAfastamento02 = true;
    },
    confirmaValidacaoFuncionarioAfastamento(recurso) {
      const etapa = this.etapaValidacaoAfastamento(recurso);
      if (etapa === 1) {
        this.confirmaValidacaoFuncionarioAfastamento01(recurso);
      } else if (etapa === 2) {
        this.confirmaValidacaoFuncionarioAfastamento02(recurso);
      }
    },

    recebimentoDetalhadoInf(recurso) {
      console.log("recurso", recurso);
      if (
        recurso.statusPedido === "RECEBIDO" ||
        recurso.statusPedido === "ENTREGAPENDENTE" ||
        recurso.statusPedido === "DEVOLUCAOPARCIAL" ||
        recurso.statusPedido === "ENTREGAPARCIAL"
      ) {
        this.objetoAtual = recurso;
        // this.pedidoItems = recurso.items;
        // console.log("pedidoItems", recurso);
        this.recebimentoDetalhado = true;
      } else {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Nao_foi_possivel_alterar_o_status"),
          "error",
        );
      }
    },

    normalizeInquilinoTransferencia(item) {
      if (!item) return null;
      return item.inquilino ? item.inquilino : item;
    },
    formatNRegistro(value) {
      if (!value) return "";
      const digits = String(value).replace(/\D/g, "");
      if (digits.length === 14) {
        return digits.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5",
        );
      }
      if (digits.length === 11) {
        return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
      return String(value);
    },
    formatInquilinoTransferencia(item) {
      const inquilino = this.normalizeInquilinoTransferencia(item);
      if (!inquilino) return "";
      const razaoSocial = inquilino.fantasia || "-";
      const nRegistro = this.formatNRegistro(inquilino.nRegistro);
      return nRegistro ? `${razaoSocial} - ${nRegistro}` : razaoSocial;
    },
    onTransferenciaDestinoChange(item) {
      const inquilino = this.normalizeInquilinoTransferencia(item);
      this.objTransferenciaEmpresa.nregistroDestino =
        inquilino?.nRegistro || "";
    },
    sanitizeNRegistro(value) {
      return String(value || "").replace(/\D/g, "");
    },
    resetTransferenciaEmpresa() {
      this.objTransferenciaEmpresa.matriculaAtual = "";
      this.objTransferenciaEmpresa.matriculaNova = "";
      this.objTransferenciaEmpresa.dataTransferencia = "";
      this.objTransferenciaEmpresa.nregistroDestino = "";
      this.inquilinoDestinoTransferencia = null;
    },
    isTransferenciaEmpresaValida(payload) {
      return (
        payload &&
        payload.matriculaAtual &&
        payload.matriculaNova &&
        payload.dataTransferencia &&
        payload.nregistroDestino
      );
    },
    transferenciaEmpresa() {
      console.log("inf", this.objTransferenciaEmpresa);

      const destinoSelecionado =
        this.objTransferenciaEmpresa.nregistroDestino ||
        this.normalizeInquilinoTransferencia(this.inquilinoDestinoTransferencia)
          ?.nRegistro ||
        "";

      const payload = {
        ...this.objTransferenciaEmpresa,
        nregistroDestino: this.sanitizeNRegistro(destinoSelecionado),
      };

      if (!this.isTransferenciaEmpresaValida(payload)) {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Preencha_todos_os_campos_obrigatorios"),
          "error",
        );
        return;
      }

      this.loading = true;
      this.$parent.DataService.transferCompany(payload)
        .then(() => {
          this.modalTransferenciaEmpresa = false;
          this.retrieveData();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Transferencia_realizada_com_sucesso"),
            "success",
          );
        })
        .catch((error) => {
          console.log("erro", error);
          this.modalTransferenciaEmpresa = false;
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

          if (error && error.response && error.response.data) {
            this.errors = error.response.data.errors || [];
            if (!this.errors.length && error.response.data.message) {
              this.$swal.fire(
                this.$t("Erro"),
                this.$t(error.response.data.message),
                "error",
              );
            }
          } else {
            this.$swal.fire(
              this.$t("Erro"),
              this.$t("Tente_novamente_mais_tarde"),
              "error",
            );
          }
        })
        .finally(() => {
          this.loading = false;
          this.idDialog += 1;
          this.resetTransferenciaEmpresa();
        });
    },

    changeTenant() {
      this.loading = true;
      this.$parent.DataService.changeTenant(
        this.recursoAtual.id,
        this.inquilinoDestino.id,
      )
        .then(() => {
          this.modalChangeTenant = false;
          this.inquilinosDisponiveis = [];
          this.inquilinoDestino = null;

          this.loading = false;

          this.retrieveData();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Transferencia_realizada_com_sucesso"),
            "success",
          );
        })
        .catch((e) => {
          console.log("erro", e.errors);
          this.modalChangeTenant = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t(e?.response?.data?.message || e),
            "error",
          );
        });
    },

    //Requisições
    setRecursos(items) {
      const recursosPadrao = Array.isArray(items) ? items : [];

      if (typeof this.$parent?.applyCustomListagemFilters === "function") {
        const recursosFiltrados =
          this.$parent.applyCustomListagemFilters(recursosPadrao);
        this.recursos = Array.isArray(recursosFiltrados)
          ? recursosFiltrados
          : recursosPadrao;
        return;
      }

      this.recursos = recursosPadrao;
    },
    updateListagemFromPageResponse(response) {
      const data = response && response.data ? response.data : {};
      this.setRecursos(data.content);
      this.totalPages = data.totalPages;
      this.totalItems = data.totalElements || 0;
      this.pageSize = data.size || this.pageSize;
      this.tablePage = 1;
    },
    updateListagemFromPageFilterResponse(response) {
      const data = response && response.data ? response.data : {};
      if (this.nomeSingular === "TituloPagar") {
        console.log("[TituloPagar] resposta recebida do backend:", response);
        console.log(
          "[TituloPagar] itens usados para popular a página:",
          data.titulos,
        );
      }
      this.setRecursos(Array.isArray(data.titulos) ? data.titulos : []);
      this.totalPages = data.totalPaginas || 0;
      this.totalItems = Number(data.totalRegistros) || 0;
      this.pageSize = data.tamanhoPagina || this.pageSize;
      this.tablePage = 1;

      if (
        this.nomeSingular === "TituloPagar" ||
        this.nomeSingular === "TituloReceber"
      ) {
        this.valorTitulosQuitados = Number(data.valorQuitados) || 0;
        this.valorTitulosPendentes = Number(data.valorAvencer) || 0;
        this.valorTitulosVencidos = Number(data.valorVencidos) || 0;
        this.quantidadeTitulosQuitados = data.quantidadeQuitados || 0;
        this.quantidadeTitulosPendentes = data.quantidadeAvencer || 0;
        this.quantidadeTitulosVencidos = data.quantidadeVencidos || 0;
      }
    },
    getHeadersDados(headers) {
      const valores = new Set();
      return (headers || []).filter((header) => {
        if (!header || !header.value || typeof header.value !== "string") {
          return false;
        }
        if (valores.has(header.value)) {
          return false;
        }
        const value = header.value;
        const isAction =
          value.indexOf("actions") === 0 ||
          value === "data-table-expand" ||
          value === "data-table-select";
        if (isAction) {
          return false;
        }
        valores.add(value);
        return true;
      });
    },
    getPrimarySortField() {
      return this.sortFields.length ? this.sortFields[0] : this.orderBy;
    },
    isCampoOrdenacaoBackend(field) {
      const header = (this.headers || []).find((item) => {
        return item && item.value === field;
      });
      return (
        !!header && (header.sortable === true || header.sortable === "true")
      );
    },
    getServerSortFieldForFetch() {
      const field = this.getPrimarySortField();
      return this.isCampoOrdenacaoBackend(field) ? field : null;
    },
    deveUsarOrdenacaoLocal() {
      if (this.isSearching || !this.sortFields.length) {
        return false;
      }
      return (
        this.sortFields.length > 1 ||
        !this.sortFields.every((field) => this.isCampoOrdenacaoBackend(field))
      );
    },
    atualizarTotaisOrdenacaoLocal() {
      const totalItems = this.recursosOrdenacaoLocal.length;
      this.totalItems = totalItems;
      this.totalPages = totalItems ? Math.ceil(totalItems / this.pageSize) : 0;
      if (this.totalPages && this.page > this.totalPages) {
        this.page = this.totalPages;
      }
    },
    paginarItens(items, page, pageSize) {
      const lista = Array.isArray(items) ? items : [];
      const paginaAtual = page || 1;
      const tamanhoPagina = pageSize || lista.length || 1;
      const inicio = (paginaAtual - 1) * tamanhoPagina;
      return lista.slice(inicio, inicio + tamanhoPagina);
    },
    async carregarOrdenacaoLocal() {
      this.cancelInlineEdit();
      this.loading = true;
      this.inicio = this.vencimentoInicio;
      this.fim = this.vencimentoFim;
      const requestContext = this.startListagemRequest();

      try {
        const itens = await this.buscarTodosRegistrosPaginados();
        if (!this.isCurrentListagemRequest(requestContext)) {
          return;
        }
        this.recursosOrdenacaoLocal = Array.isArray(itens) ? itens : [];
        this.ordenacaoLocalAtiva = true;
        this.atualizarTotaisOrdenacaoLocal();
        this.tablePage = 1;
      } catch (e) {
        if (!this.isCurrentListagemRequest(requestContext)) {
          return;
        }
        console.log(e);
        this.ordenacaoLocalAtiva = false;
        this.recursosOrdenacaoLocal = [];
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Tente_novamente_mais_tarde"),
          "error",
        );
      } finally {
        if (this.isCurrentListagemRequest(requestContext)) {
          this.loading = false;
        }
      }
    },
    extrairConteudoPaginado(response) {
      const data = response && response.data ? response.data : response;
      if (data && Array.isArray(data.content)) {
        return data.content;
      }
      if (Array.isArray(data)) {
        return data;
      }
      return [];
    },
    scheduleSearchChange() {
      this.clearSearchDebounceTimer();

      if (!this.buscaSimplificada) {
        this.handleSearchChange();
        return;
      }

      this.buscaSimplificadaRequestId += 1;

      const termo = String(this.search || "").trim();
      if (!termo) {
        this.handleSearchChange();
        return;
      }

      const delay = Math.max(Number(this.buscaSimplificadaDebounceMs) || 0, 0);
      if (!delay) {
        this.handleSearchChange();
        return;
      }

      this.searchDebounceTimer = window.setTimeout(() => {
        this.searchDebounceTimer = null;
        this.handleSearchChange();
      }, delay);
    },
    clearSearchDebounceTimer() {
      if (this.searchDebounceTimer) {
        window.clearTimeout(this.searchDebounceTimer);
        this.searchDebounceTimer = null;
      }
    },
    resetBuscaSimplificadaStatus() {
      this.buscaSimplificadaStatus = {
        active: false,
        term: "",
        scannedPages: 0,
        totalPages: 0,
        scannedItems: 0,
        totalItems: 0,
        found: 0,
        fallback: false,
      };
    },
    isBuscaSimplificadaRequestAtual(requestId) {
      return requestId === this.buscaSimplificadaRequestId;
    },
    normalizarTermoBusca(value) {
      return String(value || "")
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase("pt-BR");
    },
    getBuscaSimplificadaPageSize() {
      const pageSize = Number(this.buscaSimplificadaPageSize) || 100;
      return Math.max(pageSize, Number(this.pageSize) || 8, 1);
    },
    getBuscaSimplificadaConcorrencia() {
      const concorrencia = Number(this.buscaSimplificadaConcorrencia) || 2;
      return Math.min(Math.max(concorrencia, 1), 5);
    },
    atualizarTotaisBuscaSimplificada() {
      const totalItems = Array.isArray(this.recursos)
        ? this.recursos.length
        : 0;
      this.totalItems = totalItems;
      this.totalPages = totalItems ? Math.ceil(totalItems / this.pageSize) : 0;

      if (!this.totalPages) {
        this.page = 1;
        this.tablePage = 1;
        return;
      }

      if (this.page > this.totalPages) {
        this.page = this.totalPages;
      }
      this.tablePage = this.page;
    },
    aplicarResultadoBuscaSimplificada(requestId, resultados, statusPatch = {}) {
      if (!this.isBuscaSimplificadaRequestAtual(requestId)) {
        return false;
      }

      this.setRecursos(resultados);
      this.atualizarTotaisBuscaSimplificada();
      this.buscaSimplificadaStatus = {
        ...this.buscaSimplificadaStatus,
        ...statusPatch,
        found: this.totalItems,
      };
      return true;
    },
    async requestBuscaSimplificadaLegada(termo, requestId = null) {
      const currentRequestId =
        requestId || (this.buscaSimplificadaRequestId += 1);
      const service = this.$parent?.DataService;

      this.isSearching = true;
      this.loading = true;
      this.page = 1;
      this.tablePage = 1;
      this.buscaSimplificadaStatus = {
        active: true,
        term: termo,
        scannedPages: 0,
        totalPages: 1,
        scannedItems: 0,
        totalItems: 0,
        found: 0,
        fallback: true,
      };

      try {
        if (!service || typeof service.getAll !== "function") {
          this.aplicarResultadoBuscaSimplificada(currentRequestId, [], {
            active: false,
            fallback: true,
          });
          return;
        }

        const response = await service.getAll();
        if (!this.isBuscaSimplificadaRequestAtual(currentRequestId)) {
          return;
        }

        const itens = this.extrairConteudoPaginado(response);
        const resultados = this.filtrarItensPorBusca(itens, termo);
        this.aplicarResultadoBuscaSimplificada(currentRequestId, resultados, {
          active: false,
          scannedPages: 1,
          totalPages: 1,
          scannedItems: itens.length,
          totalItems: itens.length,
          fallback: true,
        });
      } catch (e) {
        console.log("requestBuscaSimplificadaLegada", e);
      } finally {
        if (this.isBuscaSimplificadaRequestAtual(currentRequestId)) {
          this.loading = false;
          this.buscaSimplificadaStatus = {
            ...this.buscaSimplificadaStatus,
            active: false,
          };
        }
      }
    },
    async requestBuscaSimplificadaPaginada(termo) {
      const service = this.$parent?.DataService;
      const requestId = (this.buscaSimplificadaRequestId += 1);
      const pageSize = this.getBuscaSimplificadaPageSize();
      const concorrencia = this.getBuscaSimplificadaConcorrencia();
      const orderBy = this.getServerSortFieldForFetch();
      const direction = orderBy ? this.direction : null;

      this.isSearching = true;
      this.loading = true;
      this.page = 1;
      this.tablePage = 1;
      this.setRecursos([]);
      this.atualizarTotaisBuscaSimplificada();
      this.buscaSimplificadaStatus = {
        active: true,
        term: termo,
        scannedPages: 0,
        totalPages: 0,
        scannedItems: 0,
        totalItems: 0,
        found: 0,
        fallback: false,
      };

      if (!service || typeof service.getPage !== "function") {
        await this.requestBuscaSimplificadaLegada(termo, requestId);
        return;
      }

      try {
        const buildParams = (page) =>
          this.getRequestParams(
            page,
            pageSize,
            orderBy,
            direction,
            this.vencimentoInicio,
            this.vencimentoFim,
            this.data,
          );

        const primeiraPagina = await service.getPage(buildParams(1));
        if (!this.isBuscaSimplificadaRequestAtual(requestId)) {
          return;
        }

        const data =
          primeiraPagina && primeiraPagina.data ? primeiraPagina.data : {};
        const primeiraLista = this.extrairConteudoPaginado(primeiraPagina);
        const totalItems = Number(data.totalElements || primeiraLista.length);
        const totalPages = Number(
          data.totalPages ||
            (totalItems ? Math.ceil(totalItems / pageSize) : 0),
        );

        let resultados = this.filtrarItensPorBusca(primeiraLista, termo);
        let scannedPages = totalPages ? 1 : 0;
        let scannedItems = primeiraLista.length;

        this.aplicarResultadoBuscaSimplificada(requestId, resultados, {
          active: true,
          scannedPages,
          totalPages,
          scannedItems,
          totalItems,
          fallback: false,
        });

        for (let page = 2; page <= totalPages; page += concorrencia) {
          const paginas = [];
          for (
            let offset = 0;
            offset < concorrencia && page + offset <= totalPages;
            offset += 1
          ) {
            paginas.push(service.getPage(buildParams(page + offset)));
          }

          const responses = await Promise.all(paginas);
          if (!this.isBuscaSimplificadaRequestAtual(requestId)) {
            return;
          }

          responses.forEach((response) => {
            const itensPagina = this.extrairConteudoPaginado(response);
            resultados = resultados.concat(
              this.filtrarItensPorBusca(itensPagina, termo),
            );
            scannedItems += itensPagina.length;
            scannedPages += 1;
          });

          this.aplicarResultadoBuscaSimplificada(requestId, resultados, {
            active: true,
            scannedPages,
            totalPages,
            scannedItems,
            totalItems,
            fallback: false,
          });
        }

        this.aplicarResultadoBuscaSimplificada(requestId, resultados, {
          active: false,
          scannedPages,
          totalPages,
          scannedItems,
          totalItems,
          fallback: false,
        });
      } catch (error) {
        console.log("requestBuscaSimplificadaPaginada", error);
        if (this.isBuscaSimplificadaRequestAtual(requestId)) {
          await this.requestBuscaSimplificadaLegada(termo, requestId);
        }
      } finally {
        if (this.isBuscaSimplificadaRequestAtual(requestId)) {
          this.loading = false;
          this.buscaSimplificadaStatus = {
            ...this.buscaSimplificadaStatus,
            active: false,
          };
        }
      }
    },
    async buscarTodosRegistrosPaginados() {
      const service = this.$parent?.DataService;
      if (!service || typeof service.getPage !== "function") {
        return [];
      }

      const pageSize = Math.max(Number(this.pageSize) || 8, 100);
      const orderBy = this.getServerSortFieldForFetch();
      const direction = orderBy ? this.direction : null;
      return coletarItensPaginados(
        (page) =>
          service.getPage(
            this.getRequestParams(
              page,
              pageSize,
              orderBy,
              direction,
              this.vencimentoInicio,
              this.vencimentoFim,
              this.data,
            ),
          ),
        pageSize,
      );
    },
    retrieveData() {
      this.cancelInlineEdit();
      if (this.deveUsarOrdenacaoLocal()) {
        this.carregarOrdenacaoLocal();
        return;
      }
      this.ordenacaoLocalAtiva = false;
      this.recursosOrdenacaoLocal = [];
      this.loading = true;
      this.inicio = this.vencimentoInicio;
      this.fim = this.vencimentoFim;
      const requestContext = this.startListagemRequest();

      const params = this.getRequestParams(
        this.page,
        this.pageSize,
        this.getPrimarySortField(),
        this.direction,
        this.inicio,
        this.fim,
        this.data,
      );
      this.$parent.DataService.getPage(params)
        .then((response) => {
          if (!this.isCurrentListagemRequest(requestContext)) {
            return;
          }
          this.updateListagemFromPageResponse(response);
          this.loading = false;
        })
        .catch((e) => {
          if (!this.isCurrentListagemRequest(requestContext)) {
            return;
          }
          console.log(e);
          this.loading = false;
        });
    },
    requestBuscaParametrizadaPaginada(payload) {
      const service = this.$parent?.DataService;
      if (!service || typeof service.getFilterPage !== "function") {
        console.error(
          "DataService.getFilterPage não implementado para busca paginada",
        );
        this.loading = false;
        return;
      }

      const params = this.getRequestParams(
        this.page,
        this.pageSize,
        this.getPrimarySortField(),
        this.direction,
        this.vencimentoInicio,
        this.vencimentoFim,
        this.data,
      );
      const requestContext = this.startListagemRequest();

      service
        .getFilterPage(payload, params)
        .then((response) => {
          if (!this.isCurrentListagemRequest(requestContext)) {
            return;
          }
          if (
            this.nomeSingular === "TituloPagar" ||
            this.nomeSingular === "TituloReceber"
          ) {
            this.updateListagemFromPageFilterResponse(response);
          } else {
            this.updateListagemFromPageResponse(response);
          }
          this.loading = false;
        })
        .catch((error) => {
          if (!this.isCurrentListagemRequest(requestContext)) {
            return;
          }
          console.log("requestBuscaParametrizadaPaginada", error);
          this.loading = false;
        });
    },

    //Paginação
    getRequestParams(page, pageSize, orderBy, direction, inicio, fim, date) {
      let params = {};

      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["linesPerPage"] = pageSize;
      }

      if (orderBy) {
        params["orderBy"] = orderBy;
      }

      if (direction) {
        params["direction"] = direction;
      }
      if (inicio) {
        params["inicio"] = inicio;
      }
      if (fim) {
        params["fim"] = fim;
      }
      if (date) {
        params["date"] = date;
      }

      return params;
    },

    handleSearchChange() {
      this.cancelInlineEdit();
      console.log("handleSearchChange", this.recursos);
      const customFilterPayload = this.getCustomFilterPayload();
      const possuiCustomFiltersAtivos = this.hasCustomFiltersAtivos();
      if (!this.buscaSimplificada && this.buscaParametrizadaPaginada) {
        if (
          !this.possuiFiltrosParametrizadosAtivos(possuiCustomFiltersAtivos)
        ) {
          console.log("entrou 03");
          this.isSearching = false;
          this.retrieveData();
          return;
        }

        console.log("Busca Detalhada Paginada");
        this.isSearching = true;
        this.loading = true;
        this.requestBuscaParametrizadaPaginada(
          this.buildFilterPayload(customFilterPayload),
        );
        return;
      }
      //Tratamento temporario, remover
      if (this.buscaSimplificada) {
        const termo = String(this.search || "").trim();

        if (termo.length > 0) {
          if (this.buscaSimplificadaPaginada) {
            this.requestBuscaSimplificadaPaginada(termo);
            return;
          }

          this.requestBuscaSimplificadaLegada(termo);
          return;
        }

        if (termo.length < 1 && this.isSearching) {
          console.log("entrou 02");
          this.buscaSimplificadaRequestId += 1;
          this.resetBuscaSimplificadaStatus();
          this.isSearching = false;
          this.page = 1;
          this.tablePage = 1;
          this.retrieveData();
        }
      } else {
        if (
          this.detalhe.length === 0 &&
          this.titulo.length === 0 &&
          this.descricao.length === 0 &&
          this.itemsContaFinanceira.length === 0 &&
          this.itemsFornecedor.length === 0 &&
          this.numeroRegistro.length === 0 &&
          this.itemsCliente.length === 0 &&
          this.valorFinanceiro.length === 0 &&
          this.statusFinanceiro === null &&
          this.statusFuncionario === null &&
          this.dsStatusFuncionario === null &&
          this.statusComumFiltro === null &&
          this.itemsFuncionario.length === 0 &&
          this.itemsBeneficioConvenio.length === 0 &&
          this.itemsMoedas.length === 0 &&
          this.itemsProvedor.length === 0 &&
          this.itemsPostoTrabalho.length === 0 &&
          String(this.postoTrabalhoLike || "").length === 0 &&
          this.itemsCargo.length === 0 &&
          this.matricula.length === 0 &&
          this.nome.length === 0 &&
          this.nomeCpf.length === 0 &&
          this.nomeFuncionario.length === 0 &&
          this.data.length === 0 &&
          !this.pesquisaVencimento &&
          !this.pesquisaPeriodo &&
          this.faturado === null &&
          this.itemsPessoa.length === 0 &&
          this.situacaoMovimentacaoContaVinculada.length === 0 &&
          String(this.clienteLike || "").length === 0 &&
          this.identificador.length === 0 &&
          !this.possuiFiltrosGenericosAtivos() &&
          this.tipoVisualizacaoEmpresa.length === 0 &&
          !possuiCustomFiltersAtivos
        ) {
          console.log("entrou 03");
          this.isSearching = false;
          this.retrieveData();
        } else {
          console.log("Busca Detalhada");
          this.isSearching = true;
          this.loading = true;
          const requestContext = this.startListagemRequest();
          this.$parent.DataService.getFilter(
            this.buildFilterPayload(customFilterPayload),
          )
            .then((response) => {
              if (!this.isCurrentListagemRequest(requestContext)) {
                return;
              }
              this.loading = false;
              if (
                this.nomeSingular === "TituloPagar" ||
                this.nomeSingular === "TituloReceber"
              ) {
                this.setRecursos(response.data.titulos);
                this.valorTitulosQuitados = response.data.valorQuitados;
                this.valorTitulosPendentes = response.data.valorAvencer;
                this.valorTitulosVencidos = response.data.valorVencidos;

                this.quantidadeTitulosPendentes =
                  response.data.quantidadeAvencer;
                this.quantidadeTitulosQuitados =
                  response.data.quantidadeQuitados;
                this.quantidadeTitulosVencidos =
                  response.data.quantidadeVencidos;
              } else if (
                this.nomeSingular === "RoteiroTrajeto" ||
                this.nomeSingular === "TarefaExecucaoItem"
              ) {
                // Antes dos itens: o acompanhamento de trajetos agrupa as paradas
                // com os roteiros que vêm na mesma resposta.
                this.$emit("acompanhamento", response.data);
                this.setRecursos(response.data.itens);
                this.quantidadePedidosPendentes =
                  response.data.quantidadePedidoPendente;
              } else {
                this.setRecursos(response.data);
              }
            })
            .catch((error) => {
              if (!this.isCurrentListagemRequest(requestContext)) {
                return;
              }
              console.log("handleSearchChange, 2Catch", error);
              this.loading = false;
            });
        }
      }
    },

    syncBulkActionSelection() {
      if (!this.enableSelection || !this.bulkActionSelected) {
        return;
      }
      const validAction = this.bulkActionsDisponiveis.some((action) => {
        return action.value === this.bulkActionSelected;
      });
      if (!validAction) {
        this.bulkActionSelected = null;
      }
    },

    refreshList() {
      if (this.isSearching || this.pesquisaDataAtualTv) {
        this.handleSearchChange();
      } else {
        this.retrieveData();
      }
    },

    registrarPrimeiraValidacaoNaListagem() {
      const pessoa = this.$store?.state?.user?.pessoa;
      const id = this.objetoAtual?.id;
      if (!pessoa?.id || !id) return;

      const patch = { responsavelValidacao01: pessoa };
      this.atualizarListaLocalPorId(this.recursos, id, patch, false);
      this.atualizarListaLocalPorId(
        this.recursosOrdenacaoLocal,
        id,
        patch,
        false,
      );
      this.objetoAtual = { ...this.objetoAtual, ...patch };
      if (this.selectedRows.length) {
        this.selectedRows = this.selectedRows.map((item) =>
          String(this.resolveResourceId(item)) === String(id)
            ? { ...item, ...patch }
            : item,
        );
      }
    },

    statusAtualizacaoLocalCompativelComFiltro(item) {
      if (!item || !this.valorFiltroPreenchido(this.statusFinanceiro)) {
        return true;
      }

      const statusField = this.bulkActionStatusField || "statusPedido";
      const statusItem = item[statusField];

      if (Array.isArray(this.statusFinanceiro)) {
        return this.statusFinanceiro.includes(statusItem);
      }

      return String(statusItem || "") === String(this.statusFinanceiro || "");
    },

    atualizarListaLocalPorId(lista, id, patch, removerItem) {
      if (!Array.isArray(lista)) {
        return false;
      }

      const index = lista.findIndex((item) => {
        return String(this.resolveResourceId(item)) === String(id);
      });

      if (index < 0) {
        return false;
      }

      if (removerItem) {
        lista.splice(index, 1);
        return true;
      }

      this.$set(lista, index, {
        ...lista[index],
        ...patch,
      });
      return true;
    },

    ajustarTotaisAposRemocaoLocal() {
      this.totalItems = Math.max(Number(this.totalItems || 0) - 1, 0);
      this.totalPages = this.totalItems
        ? Math.ceil(this.totalItems / this.pageSize)
        : 0;
      if (this.totalPages > 0 && this.page > this.totalPages) {
        this.page = this.totalPages;
      }
      if (!this.totalPages) {
        this.page = 1;
        this.tablePage = 1;
      }
    },

    aplicarAtualizacaoLocalAposAcao(recurso, patch = {}) {
      if (!this.atualizarLocalAposAcao) {
        return false;
      }

      const id = this.resolveResourceId(recurso);
      if (id === null || id === undefined || !Array.isArray(this.recursos)) {
        return false;
      }

      const itemAtual = this.recursos.find((item) => {
        return String(this.resolveResourceId(item)) === String(id);
      });
      const itemAtualizado = {
        ...(itemAtual || recurso || {}),
        ...patch,
      };
      const removerItem =
        !this.statusAtualizacaoLocalCompativelComFiltro(itemAtualizado);

      const atualizouRecursos = this.atualizarListaLocalPorId(
        this.recursos,
        id,
        patch,
        removerItem,
      );

      if (!atualizouRecursos) {
        return false;
      }

      this.atualizarListaLocalPorId(
        this.recursosOrdenacaoLocal,
        id,
        patch,
        removerItem,
      );

      if (Array.isArray(this.selectedRows) && this.selectedRows.length) {
        if (removerItem) {
          this.selectedRows = this.selectedRows.filter((item) => {
            return String(this.resolveResourceId(item)) !== String(id);
          });
        } else {
          this.selectedRows = this.selectedRows.map((item) => {
            if (String(this.resolveResourceId(item)) !== String(id)) {
              return item;
            }
            return {
              ...item,
              ...patch,
            };
          });
        }
      }

      if (
        this.objetoAtual &&
        String(this.resolveResourceId(this.objetoAtual)) === String(id)
      ) {
        this.objetoAtual = {
          ...this.objetoAtual,
          ...patch,
        };
      }

      if (removerItem) {
        this.ajustarTotaisAposRemocaoLocal();
      }

      return true;
    },

    atualizarStatusLocalOuRecarregar(
      recurso,
      statusPedido,
      extraPatch = {},
      fallback = null,
    ) {
      const atualizouLocalmente = this.aplicarAtualizacaoLocalAposAcao(
        recurso,
        {
          ...extraPatch,
          statusPedido,
        },
      );

      if (!atualizouLocalmente) {
        if (typeof fallback === "function") {
          fallback();
        } else {
          this.refreshList();
        }
      }

      return atualizouLocalmente;
    },

    deveRecarregarDadosAoEditar() {
      return (
        this.recarregarDadosAoEditar ||
        this.isSearching ||
        this.pesquisaDataAtualTv
      );
    },

    getEditComponentInstance() {
      const editComponentInstance = this.$refs.editComponentInstance;
      return Array.isArray(editComponentInstance)
        ? editComponentInstance[0]
        : editComponentInstance;
    },

    getRecursoAtualizadoEdicao(recursoAtualizado = null) {
      if (recursoAtualizado && typeof recursoAtualizado === "object") {
        return recursoAtualizado;
      }

      const editComponentInstance = this.getEditComponentInstance();
      if (
        editComponentInstance &&
        editComponentInstance.recurso &&
        typeof editComponentInstance.recurso === "object"
      ) {
        return editComponentInstance.recurso;
      }

      return this.recursoAtual;
    },

    atualizarItemEditadoNaListagem(recursoAtualizado = null) {
      const recursoEditado = this.getRecursoAtualizadoEdicao(recursoAtualizado);
      const id = recursoEditado && recursoEditado.id;

      if (!id || !Array.isArray(this.recursos)) {
        return false;
      }

      const index = this.recursos.findIndex((item) => {
        return item && String(item.id) === String(id);
      });

      if (index < 0) {
        return false;
      }

      const itemAtualizado = {
        ...this.recursos[index],
        ...recursoEditado,
      };
      this.$set(this.recursos, index, itemAtualizado);
      this.recursoAtual = itemAtualizado;
      return true;
    },

    executarAcaoEmMassa() {
      if (this.bulkActionDisabled) {
        return;
      }

      const action = this.bulkActionsDisponiveis.find((item) => {
        return item.value === this.bulkActionSelected;
      });
      const actionRequiresStatus =
        action && action.statuses && action.statuses.length;
      if (!action || (actionRequiresStatus && !this.bulkSelectedStatus)) {
        return;
      }
      if (
        actionRequiresStatus &&
        !action.statuses.includes(this.bulkSelectedStatus)
      ) {
        return;
      }

      if (action.deleteSelection === true) {
        this.confirmaDeleteSelecionados();
        this.bulkActionSelected = null;
        return;
      }

      if (action.confirmTitle || action.confirmMessage) {
        this.$swal
          .fire({
            title: action.confirmTitle || this.$t("Confirma_acao?"),
            text: action.confirmMessage || "",
            icon: action.confirmIcon || "warning",
            showCancelButton: true,
            confirmButtonText: this.$t("Confirmar"),
            cancelButtonText: this.$t("Cancelar"),
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.executarAcaoEmMassaConfirmada(action);
            }
          });
        return;
      }

      this.executarAcaoEmMassaConfirmada(action);
    },

    executarAcaoEmMassaConfirmada(action) {
      const service = this.$parent.DataService;
      const serviceMethod = action.serviceMethod || action.value;

      if (typeof action.handler === "function") {
        const itensSelecionados = [...this.selectedRows];
        this.bulkActionLoading = true;
        Promise.resolve(
          action.handler(itensSelecionados, {
            service,
            listagem: this,
          }),
        )
          .then((resultado) => {
            const quantidade = Number.isInteger(resultado?.successCount)
              ? resultado.successCount
              : itensSelecionados.length;
            if (quantidade > 0) {
              this.notificarDadosAlterados("acao-em-massa", {
                acao: serviceMethod,
                quantidade,
              });
            }
            if (action.successMessage !== false) {
              this.$swal.fire(
                this.$t("Sucesso"),
                action.successMessage || this.$t("Sucesso"),
                "success",
              );
            }
          })
          .catch((error) => {
            this.$swal.fire(
              this.$t("Erro"),
              action.errorMessage || this.getApiErrorMessage(error),
              "error",
            );
          })
          .finally(() => {
            this.bulkActionLoading = false;
            this.selectedRows = [];
            this.bulkActionSelected = null;
            if (action.refreshAfter !== false) {
              this.refreshList();
            }
          });
        return;
      }

      if (!service || typeof service[serviceMethod] !== "function") {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Tente_novamente_mais_tarde"),
          "error",
        );
        return;
      }

      this.bulkActionLoading = true;
      let atualizouLocalmente = false;
      const requests = this.selectedRows.map((item) => {
        return service[serviceMethod](item)
          .then(() => {
            return { ok: true, item };
          })
          .catch((error) => {
            return { ok: false, error, item };
          });
      });

      Promise.all(requests)
        .then((results) => {
          const successes = results.filter((result) => {
            return result.ok;
          });
          const failures = results.filter((result) => {
            return !result.ok;
          });

          if (this.atualizarLocalAposAcao && action.localStatus) {
            atualizouLocalmente = successes.every((result) => {
              return this.aplicarAtualizacaoLocalAposAcao(result.item, {
                [this.bulkActionStatusField || "statusPedido"]:
                  action.localStatus,
              });
            });
          }

          if (successes.length) {
            this.notificarDadosAlterados("acao-em-massa", {
              acao: serviceMethod,
              quantidade: successes.length,
            });
          }

          if (failures.length) {
            this.$swal.fire(
              this.$t("Erro"),
              action.errorMessage || this.$t("Tente_novamente_mais_tarde"),
              "error",
            );
          } else {
            this.$swal.fire(
              this.$t("Sucesso"),
              action.successMessage || this.$t("Sucesso"),
              "success",
            );
          }
        })
        .catch(() => {
          this.$swal.fire(
            this.$t("Erro"),
            action.errorMessage || this.$t("Tente_novamente_mais_tarde"),
            "error",
          );
        })
        .finally(() => {
          this.bulkActionLoading = false;
          this.selectedRows = [];
          this.bulkActionSelected = null;
          if (!atualizouLocalmente) {
            this.refreshList();
          }
        });
    },

    handlePageChange(value) {
      this.page = value;
      this.tablePage = this.isBuscaSimplificadaPaginadaAtiva ? value : 1;
      if (this.isBuscaSimplificadaPaginadaAtiva) {
        return;
      }
      if (this.ordenacaoLocalAtiva && !this.isSearching) {
        return;
      }
      if (this.isSearching && this.buscaParametrizadaPaginada) {
        this.handleSearchChange();
        return;
      }
      this.retrieveData();
    },

    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.tablePage = 1;
      if (this.isBuscaSimplificadaPaginadaAtiva) {
        this.atualizarTotaisBuscaSimplificada();
        return;
      }
      if (this.ordenacaoLocalAtiva && !this.isSearching) {
        this.atualizarTotaisOrdenacaoLocal();
        return;
      }
      if (this.isSearching && this.buscaParametrizadaPaginada) {
        this.handleSearchChange();
        return;
      }
      this.retrieveData();
    },

    handleOrderByChange(value) {
      this.orderBy = value;
      this.sortFields = value ? [value] : [];
      if (this.sortFields.length && !this.direction) {
        this.direction = "ASC";
      }
      this.page = 1;
      this.tablePage = 1;
      if (this.isBuscaSimplificadaPaginadaAtiva) {
        return;
      }
      if (this.isSearching && this.buscaParametrizadaPaginada) {
        this.handleSearchChange();
        return;
      }
      this.retrieveData();
    },

    separacao() {
      this.loading = true;
      this.$parent.DataService.separacao(this.objetoAtual)
        .then(() => {
          this.confirmarSeparacao = false;
          this.loading = false;
          this.atualizarStatusLocalOuRecarregar(this.objetoAtual, "SEPARACAO");
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Pedido_separado_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.confirmarSeparacao = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_separar_o_pedido"),
            "error",
          );
        });
    },

    disponibilizar() {
      this.loading = true;
      this.$parent.DataService.disponibilizado(this.objetoAtual)
        .then(() => {
          this.confirmarDisponibilizacao = false;
          this.loading = false;
          this.atualizarStatusLocalOuRecarregar(
            this.objetoAtual,
            "DISPONIBILIZADO",
          );
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Pedido_disponibilizado_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.confirmarDisponibilizacao = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_disponibilizar_o_pedido"),
            "error",
          );
        });
    },

    trocar() {
      this.loading = true;
      this.$parent.DataService.trocar(this.objetoAtual)
        .then(() => {
          this.confirmarTroca = false;
          this.loading = false;
          this.atualizarStatusLocalOuRecarregar(
            this.objetoAtual,
            "PENDENTE",
            {},
            () => this.retrieveData(),
          );
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Pedido_disponivel_para_troca"),
            "success",
          );
        })
        .catch(() => {
          this.confirmarTroca = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_disponibilizar_o_pedido"),
            "error",
          );
        });
    },

    retiradaTerceiro() {
      this.loading = true;
      this.$parent.DataService.retiradoTerceiro(this.objetoAtual)
        .then(() => {
          this.confirmarRetiradoTerceiro = false;
          this.loading = false;
          this.retrieveData();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Pedido_retirado_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.confirmarRetiradoTerceiro = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_retirar_o_pedido"),
            "error",
          );
        });
    },

    retirar() {
      this.loading = true;
      this.$parent.DataService.retirado(this.objetoAtual)
        .then(() => {
          this.confirmarRetirada = false;
          this.loading = false;
          this.atualizarStatusLocalOuRecarregar(
            this.objetoAtual,
            "RETIRADO",
            {},
            () => this.retrieveData(),
          );
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Pedido_retirado_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.confirmarRetirada = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_retirar_o_pedido"),
            "error",
          );
        });
    },

    receber() {
      this.loading = true;
      this.$parent.DataService.recebido(this.objetoAtual)
        .then(() => {
          this.confirmarRecebimento = false;
          this.loading = false;
          this.atualizarStatusLocalOuRecarregar(this.objetoAtual, "RECEBIDO");
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Pedido_retirado_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.confirmarRecebimento = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_retirar_o_pedido"),
            "error",
          );
        });
    },

    entregaPendente() {
      this.loading = true;
      this.$parent.DataService.entregaPendente(this.objetoAtual)
        .then(() => {
          this.confirmarEntrega = false;
          this.loading = false;
          this.retrieveData();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Entrega_pendente_conferencia_registrada_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.confirmarEntrega = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_registrar_a_entrega_pendente"),
            "error",
          );
        });
    },

    entregaTotal() {
      this.loading = true;
      this.$parent.DataService.entregaTotal(this.objetoAtual)
        .then(() => {
          this.confirmarEntregaTotal = false;
          this.loading = false;
          this.atualizarStatusLocalOuRecarregar(
            this.objetoAtual,
            "DEVOLUCAOTOTAL",
            {},
            () => this.retrieveData(),
          );
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Entrega_total_registrada_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.confirmarEntregaTotal = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_registrar_a_entrega_total"),
            "error",
          );
        });
    },

    validacaoFinanceira01() {
      this.loading = true;
      this.$parent.DataService.validacaoFinanceira01(this.objetoAtual)
        .then(() => {
          this.modalConfirmaValidacaoFinanceira01 = false;
          this.loading = false;
          this.retrieveData();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Validacao_registrada_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.modalConfirmaValidacaoFinanceira01 = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_registrar_a_validacao"),
            "error",
          );
        });
    },

    validacaoFinanceira02() {
      this.loading = true;
      this.$parent.DataService.validacaoFinanceira02(this.objetoAtual)
        .then(() => {
          this.modalConfirmaValidacaoFinanceira02 = false;
          this.loading = false;
          this.retrieveData();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Validacao_registrada_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.modalConfirmaValidacaoFinanceira02 = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_registrar_a_validacao"),
            "error",
          );
        });
    },

    validacaoFuncionarioAfastamento01() {
      this.loading = true;
      this.$parent.DataService.validar01(this.objetoAtual)
        .then(() => {
          this.modalConfirmaValidacaoFuncionarioAfastamento01 = false;
          this.loading = false;
          this.notificarDadosAlterados("validacao-afastamento-01", {
            recurso: this.objetoAtual,
          });
          this.registrarPrimeiraValidacaoNaListagem();
          this.refreshList();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.exigeValidacao02FuncionarioAfastamentoSolicitacao()
              ? this.$t("Primeira_validacao_registrada")
              : this.$t("Solicitacao_validada_e_aprovada"),
            "success",
          );
        })
        .catch((e) => {
          this.modalConfirmaValidacaoFuncionarioAfastamento01 = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_registrar_a_validacao") +
              (e?.response?.data?.message
                ? " - " + e.response.data.message
                : ""),
            "error",
          );
        });
    },

    validacaoFuncionarioAfastamento02() {
      this.loading = true;
      this.$parent.DataService.validar02(this.objetoAtual)
        .then(() => {
          this.modalConfirmaValidacaoFuncionarioAfastamento02 = false;
          this.loading = false;
          this.notificarDadosAlterados("validacao-afastamento-02", {
            recurso: this.objetoAtual,
          });
          this.refreshList();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Solicitacao_validada_e_aprovada"),
            "success",
          );
        })
        .catch((e) => {
          this.modalConfirmaValidacaoFuncionarioAfastamento02 = false;
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_registrar_a_validacao") +
              (e?.response?.data?.message
                ? " - " + e.response.data.message
                : ""),
            "error",
          );
        });
    },

    aprovar() {
      const primeiraValidacaoPonto =
        this.exigeValidacao02FuncionarioPontoSolicitacao() &&
        !this.objetoAtual?.responsavelValidacao01;
      this.loading = true;
      this.$parent.DataService.aprovar({
        id: this.objetoAtual.id,
        data: this.dataAprovacao,
      })
        .then(() => {
          this.dataAprovacao = null;
          this.modalConfirmaAprovacao = false;

          this.loading = false;
          this.notificarDadosAlterados("aprovacao", {
            recurso: this.objetoAtual,
          });
          if (primeiraValidacaoPonto) {
            this.registrarPrimeiraValidacaoNaListagem();
          }
          if (
            this.nomeSingular === "FuncionarioPontoSolicitacao" ||
            this.nomeSingular === "FuncionarioAfastamentoSolicitacao"
          ) {
            this.refreshList();
          } else {
            this.retrieveData();
          }
          this.$swal.fire(
            this.$t("Sucesso"),
            primeiraValidacaoPonto
              ? this.$t("Primeira_validacao_registrada")
              : this.nomeSingular === "FuncionarioAfastamentoSolicitacao"
              ? this.$t("Aprovado_com_sucesso")
              : this.nomeSingular === "FuncionarioPontoSolicitacao"
              ? this.$t("Solicitacao_validada_e_aprovada")
              : this.$t("Validacao_registrada_com_sucesso"),
            "success",
          );
        })
        .catch((e) => {
          this.dataAprovacao = null;
          this.modalConfirmaAprovacao = false;

          this.loading = false;
          if (this.nomeSingular === "FuncionarioAfastamentoSolicitacao") {
            this.$swal.fire(
              this.$t("naoFoiPossivelAprovarSolicitacaoAfastamento"),
              this.getApiErrorMessage(e),
              "warning",
            );
            return;
          }
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_registrar_a_validacao") +
              (e?.response?.data?.message
                ? " - " + e.response.data.message
                : ""),
            "error",
          );
        });
    },

    gerarDocumento() {
      this.loading = true;
      this.$parent.DataService.gerarDocumento({
        id: this.objetoAtual.id,
        data: this.dataAprovacao,
      })
        .then(() => {
          this.modalConfirmaGeracaoDocumento = false;

          this.loading = false;
          this.handleSearchChange();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.modalConfirmaGeracaoDocumento = false;

          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Falha_ao_gerar_documento"),
            "error",
          );
        });
    },

    registroExecucaoServico() {
      this.loading = true;
      this.$parent.DataService.registrarExecucao(this.objetoAtual.id)
        .then(() => {
          this.modalConfirmaExecucaoServico = false;

          this.loading = false;

          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Registrado_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.modalConfirmaExecucaoServico = false;

          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Falha_ao_gerar_documento"),
            "error",
          );
        });
    },

    entregaParcial(item) {
      console.log("item", item);
      this.recebimentoDetalhado = false;
      this.loading = true;
      this.$parent.DataService.entregaParcial(item)
        .then(() => {
          this.loading = false;
          this.retrieveData();
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Entrega_parcial_registrada_com_sucesso"),
            "success",
          );
        })
        .catch(() => {
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_registrar_a_entrega_parcial"),
            "error",
          );
        });
    },

    printSingle(id, type) {
      this.loading = true;
      if (type === "pedidoMaterial") {
        this.$parent.DataService.get("pedidoMaterial/romaneio/" + id, {
          responseType: "blob",
        })
          .then((res) => {
            console.log("printSingle", res.data);
            this.loading = false;
            this.download(res.data, "document.pdf", "application/pdf");
            this.$swal.fire(
              this.$t("Sucesso"),
              this.$t("Documento_gerado_com_sucesso"),
              "success",
            );
          })
          .catch(() => {
            this.loading = false;
            this.$swal.fire(
              this.$t("Erro"),
              this.$t("Falha_ao_exportar"),
              "error",
            );
          });
      } else if (type === "movimentacaoImobilizado") {
        this.$parent.DataService.get(
          "imobilizadoMovimentacoes/romaneio/" + id,
          {
            responseType: "blob",
          },
        )
          .then((res) => {
            console.log("printSingle", res.data);
            this.loading = false;
            this.download(res.data, "document.pdf", "application/pdf");
            this.$swal.fire(
              this.$t("Sucesso"),
              this.$t("Documento_gerado_com_sucesso"),
              "success",
            );
          })
          .catch(() => {
            this.loading = false;
            this.$swal.fire(
              this.$t("Erro"),
              this.$t("Falha_ao_exportar"),
              "error",
            );
          });
      } else if (type === "pedidoUniforme") {
        this.$parent.DataService.get("pedidoUniforme/romaneio/" + id, {
          responseType: "blob",
        })
          .then((res) => {
            console.log("printSingle", res.data);
            this.loading = false;
            this.download(res.data, "document.pdf", "application/pdf");
            this.$swal.fire(
              this.$t("Sucesso"),
              this.$t("Documento_gerado_com_sucesso"),
              "success",
            );
          })
          .catch(() => {
            this.loading = false;
            this.$swal.fire(
              this.$t("Erro"),
              this.$t("Falha_ao_exportar"),
              "error",
            );
          });
      } else if (type === "pedidoConsumivel") {
        this.$parent.DataService.get("pedidoConsumivel/romaneio/" + id, {
          responseType: "blob",
        })
          .then((res) => {
            console.log("printSingle", res.data);
            this.loading = false;
            this.download(res.data, "document.pdf", "application/pdf");
            this.$swal.fire(
              this.$t("Sucesso"),
              this.$t("Documento_gerado_com_sucesso"),
              "success",
            );
          })
          .catch(() => {
            this.loading = false;
            this.$swal.fire(
              this.$t("Erro"),
              this.$t("Falha_ao_exportar"),
              "error",
            );
          });
      } else if (type === "pedidoConsumivelCompleto") {
        this.$parent.DataService.get("pedidoConsumivel/romaneio/value/" + id, {
          responseType: "blob",
        })
          .then((res) => {
            console.log("printSingle", res.data);
            this.loading = false;
            this.download(res.data, "document.pdf", "application/pdf");
            this.$swal.fire(
              this.$t("Sucesso"),
              this.$t("Documento_gerado_com_sucesso"),
              "success",
            );
          })
          .catch(() => {
            this.loading = false;
            this.$swal.fire(
              this.$t("Erro"),
              this.$t("Falha_ao_exportar"),
              "error",
            );
          });
      } else {
        console.log("Entrou no else");
        this.$parent.DataService.print(id, {
          responseType: "blob",
        })
          .then((res) => {
            this.loading = false;
            this.download(res.data, "document.pdf", "application/pdf");
            this.$swal.fire(
              this.$t("Sucesso"),
              this.$t("Documento_gerado_com_sucesso"),
              "success",
            );
          })
          .catch(() => {
            this.loading = false;
            this.$swal.fire(
              this.$t("Erro"),
              this.$t("Falha_ao_exportar"),
              "error",
            );
          });
      }
    },

    downloadDocumento(documentoArquivo) {
      // Cenário A: Se `documentoArquivo` for uma URL apontando para o servidor
      // (Ex.: https://meus-arquivos/documento.pdf).
      // Basta abrir em nova aba ou forçar o download:
      if (this.isUrl(documentoArquivo)) {
        window.open(documentoArquivo, "_blank");
        return;
      }

      // Cenário B: Se `documentoArquivo` for uma string base64
      // Precisamos criar um Blob e forçar o download.
      // Ex.: "data:application/pdf;base64,JVBERi0xLjQKJ..."
      if (documentoArquivo.startsWith("data:")) {
        const link = document.createElement("a");
        link.href = documentoArquivo;
        // Tente extrair a extensão se tiver "data:application/pdf" ou "data:image/jpeg" etc.
        const extension = this.getExtensionFromBase64(documentoArquivo);
        link.download = `documento${extension}`;
        link.click();
        return;
      }

      // Caso contrário, trate como erro ou algo indefinido
      this.$swal.fire(
        this.$t("Erro"),
        this.$t("Arquivo_invalido_ou_não_suportado"),
        "error",
      );
    },
    getPreContratacaoPublicUrl(item) {
      const key = item && item.key;
      if (!key) {
        return null;
      }
      try {
        const resolved = this.$router.resolve({
          name: "PreContratacaoPublica",
          params: { key },
        });
        return `${window.location.origin}${resolved.href}`;
      } catch (err) {
        return `${window.location.origin}/#/pre-contratacao/${key}`;
      }
    },
    async copiarLinkPreContratacao(item) {
      const url = this.getPreContratacaoPublicUrl(item);
      if (!url) {
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Link_publico_indisponivel"),
          "error",
        );
        return;
      }
      const copied = await this.copyToClipboard(url);
      if (copied) {
        this.$swal.fire(
          this.$t("Sucesso"),
          this.$t("Link_publico_copiado"),
          "success",
        );
        return;
      }
      this.$swal.fire({
        title: this.$t("Link_publico"),
        input: "text",
        inputValue: url,
        confirmButtonText: "OK",
      });
    },
    getRevogacaoAssinaturaDocumentacaoAcessoriaPublicUrl(hash) {
      if (!hash) {
        return null;
      }
      try {
        const resolved = this.$router.resolve({
          name: "FuncionarioDocumentacaoAcessoriaRevogacaoAssinaturaPublica",
          params: { hash },
        });
        return `${window.location.origin}${resolved.href}`;
      } catch (err) {
        return `${window.location.origin}/#/documentacao-acessoria/revogar-assinatura/${hash}`;
      }
    },
    async gerarLinkRevogacaoAssinaturaDocumentacaoAcessoria(item) {
      if (!item || !item.id) {
        return;
      }

      const confirmacao = await this.$swal.fire({
        title: this.$t("Gerar_link_revogacao_assinatura"),
        text: this.$t("Gerar_link_revogacao_assinatura_confirmacao"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Gerar_link"),
        cancelButtonText: this.$t("Cancelar"),
      });

      if (!confirmacao.isConfirmed) {
        return;
      }

      this.loading = true;
      try {
        const response =
          await this.$parent.DataService.gerarLinkRevogacaoAssinatura(item.id);
        const hash = response?.data?.hash;
        const url =
          this.getRevogacaoAssinaturaDocumentacaoAcessoriaPublicUrl(hash);
        if (!url) {
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Link_publico_indisponivel"),
            "error",
          );
          return;
        }
        const copied = await this.copyToClipboard(url);
        if (copied) {
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Link_revogacao_assinatura_copiado"),
            "success",
          );
          return;
        }
        this.$swal.fire({
          title: this.$t("Link_revogacao_assinatura"),
          input: "text",
          inputValue: url,
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$swal.fire(
          this.$t("Erro"),
          this.getApiErrorMessage(error),
          "error",
        );
      } finally {
        this.loading = false;
      }
    },
    getApiErrorMessage(error) {
      const errors = error?.response?.data?.errors;
      if (Array.isArray(errors) && errors.length && errors[0]?.message) {
        return errors[0].message;
      }
      return (
        error?.response?.data?.message || this.$t("Tente_novamente_mais_tarde")
      );
    },
    async copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(text);
          return true;
        } catch (err) {
          return this.legacyCopy(text);
        }
      }
      return this.legacyCopy(text);
    },
    legacyCopy(text) {
      try {
        const el = document.createElement("textarea");
        el.value = text;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(el);
        return ok;
      } catch (err) {
        return false;
      }
    },

    isUrl(value) {
      // Bem simples: checa se inicia com http(s) ou termina com .pdf, .png, etc.
      // Se preferir, use uma regex mais robusta.
      return value.startsWith("http://") || value.startsWith("https://");
    },

    download(content, fileName, mimeType) {
      var a = document.createElement("a");
      mimeType = mimeType || "application/octet-stream";

      if (navigator.msSaveBlob) {
        // IE10
        navigator.msSaveBlob(
          new Blob([content], {
            type: mimeType,
          }),
          fileName,
        );
      } else if (URL && "download" in a) {
        //html5 A[download]
        a.href = URL.createObjectURL(
          new Blob([content], {
            type: mimeType,
          }),
        );
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        location.href =
          "data:application/octet-stream," + encodeURIComponent(content); // only this mime type is supported
      }
    },

    handleSortFieldsChange(value) {
      this.sortFields = value ? [value] : [];
      this.orderBy = this.sortFields.length ? this.sortFields[0] : null;
      if (this.sortFields.length && !this.direction) {
        this.direction = "ASC";
      }
    },
    handleDirectionChange(value) {
      this.direction = value;
    },
    confirmarOrdenacao() {
      this.ordenacaoMenu = false;
      this.appliedSortFields = [...this.sortFields];
      this.appliedDirection = this.direction;
      this.page = 1;
      this.tablePage = 1;
      if (this.isSearching && this.buscaParametrizadaPaginada) {
        this.handleSearchChange();
        return;
      }
      if (!this.isSearching) {
        this.retrieveData();
      }
    },
    limparOrdenacao() {
      this.sortFields = [];
      this.orderBy = null;
      this.direction = null;
      this.appliedSortFields = [];
      this.appliedDirection = null;
      this.page = 1;
      this.tablePage = 1;
      this.ordenacaoLocalAtiva = false;
      this.recursosOrdenacaoLocal = [];
      if (!this.isSearching) {
        this.retrieveData();
      }
    },
    handleClickPedido(event) {
      this.produto = event.produto;
      console.log("handleClickPedido", event);
      this.quantidadePendente =
        (event.quantidadeEntregue === null ? 0 : event.quantidadeEntregue) -
        (event.quantidadeDevolvida === null ? 0 : event.quantidadeDevolvida);
      console.log(
        "handleClickPedido quantidadePendente",
        this.quantidadePendente,
      );
      this.formChangeProdutoPedido = true;
    },

    changeProdutoPedido() {
      var produtoExistente = this.objetoAtual.items.find(
        (produto) => produto.produto.id == this.produto.id,
      );

      if (produtoExistente) {
        this.quantidade = parseInt(this.quantidade);
        // + parseInt(produtoExistente.quantidadeDevolvida);
        this.objetoAtual.items = this.objetoAtual.items.filter((produto) => {
          return produto.produto.id !== produtoExistente.produto.id;
        });
      }
      this.objetoAtual.items.push({
        produto: this.produto,
        quantidade: this.quantidade,
      });
      this.produto = {};
      this.quantidade = 0;
      this.formChangeProdutoPedido = false;
    },
    limpaFormProduto() {
      this.formChangeProdutoPedido = false;
      // this.quantidadeSolicitada = 0;
    },

    sugestaoVencimento() {
      var now = new Date();
      this.vencimentoInicio = this.utils_dateObj_to_ymd(
        new Date(now.getFullYear(), now.getMonth(), 1),
      );
      this.vencimentoFim = this.utils_dateObj_to_ymd(
        new Date(now.getFullYear(), now.getMonth() + 1, 0),
      );
    },

    getDateFilterStorage() {
      if (!this.persistDateFilterKey || typeof window === "undefined") {
        return null;
      }
      try {
        return window.sessionStorage || null;
      } catch (error) {
        return null;
      }
    },

    normalizePersistedDateFilter(value) {
      const normalized = typeof value === "string" ? value.trim() : "";
      if (!normalized) {
        return "";
      }
      if (
        /^\d{4}-\d{2}-\d{2}$/.test(normalized) ||
        /^\d{2}\/\d{2}\/\d{4}$/.test(normalized)
      ) {
        return normalized;
      }
      return "";
    },

    savePersistedDateFilter(value = this.data) {
      const storage = this.getDateFilterStorage();
      if (!storage) {
        return;
      }
      const normalized = this.normalizePersistedDateFilter(value);
      if (!normalized) {
        storage.removeItem(this.persistDateFilterKey);
        return;
      }
      storage.setItem(this.persistDateFilterKey, normalized);
    },

    loadPersistedDateFilter() {
      const storage = this.getDateFilterStorage();
      if (!storage) {
        return "";
      }
      return this.normalizePersistedDateFilter(
        storage.getItem(this.persistDateFilterKey),
      );
    },

    inicializarFiltroDataAutomatica() {
      const dataPersistida = this.loadPersistedDateFilter();
      if (dataPersistida) {
        this.data = dataPersistida;
        if (this.pesquisaDataAtualTv) {
          this.inicioPeriodo = dataPersistida;
        }
        return;
      }

      if (this.pesquisaDataAtualTv) {
        this.dataAtualTv();
        return;
      }

      if (this.pesquisaDataSeguinteTv) {
        this.dataSeguinteTv();
      }
    },

    dataAtualTv() {
      var nowTv = new Date();
      const currentHour = nowTv.getHours();

      // Se a hora atual for igual ou maior que 20, adiciona um dia
      if (currentHour > 19) {
        nowTv.setDate(nowTv.getDate() + 1);
      }

      this.data = this.utils_dateObj_to_ymd(nowTv);
      this.inicioPeriodo = this.utils_dateObj_to_ymd(nowTv);
      this.savePersistedDateFilter(this.data);
    },

    dataSeguinteTv() {
      var nowTv = new Date();
      const currentHour = nowTv.getHours();

      // Se a hora atual for igual ou maior que 20, adiciona um dia
      if (currentHour < 17) {
        nowTv.setDate(nowTv.getDate());
      } else if (currentHour >= 20) {
        nowTv.setDate(nowTv.getDate() + 2);
      } else {
        nowTv.setDate(nowTv.getDate() + 1);
      }

      this.data = this.utils_dateObj_to_ymd(nowTv);
      this.savePersistedDateFilter(this.data);
    },

    sugestaoPeriodo(periodoAnterior) {
      var now = new Date();
      if (periodoAnterior === null) {
        periodoAnterior = false;
      }

      if (periodoAnterior) {
        this.inicioPeriodo = this.utils_dateObj_to_ymd(
          new Date(now.getFullYear(), now.getMonth() - 1, 1),
        );
        this.encerramentoPeriodo = this.utils_dateObj_to_ymd(
          new Date(now.getFullYear(), now.getMonth(), 0),
        );
      } else {
        this.inicioPeriodo = this.utils_dateObj_to_ymd(
          new Date(now.getFullYear(), now.getMonth(), 1),
        );
        this.encerramentoPeriodo = this.utils_dateObj_to_ymd(
          new Date(now.getFullYear(), now.getMonth() + 1, 0),
        );
      }
      this.emitirPeriodo();
    },

    utils_dateObj_to_ymd(payload = null) {
      let today;
      if (payload) {
        today = new Date(payload);
      } else {
        today = new Date();
      }
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        today.getDate().toString().padStart(2, "0");

      console.log(date);
      return date;
    },
    handleDataInicioVencimentoChange(value) {
      this.vencimentoInicio = value;
      //this.handleSearchChange();
    },
    handleDataFinalVencimentoChange(value) {
      this.vencimentoFim = value;
      // this.handleSearchChange();
    },

    handleCompetenciaChange(value) {
      this.competencia = value;
      //this.handleSearchChange();
    },

    handleDataInicioPeriodoChange(value) {
      this.inicioPeriodo = value;
      this.emitirPeriodo();
      // this.handleSearchChange();
    },
    handleDataEncerramentoPeriodoChange(value) {
      this.encerramentoPeriodo = value;
      this.emitirPeriodo();
      //this.handleSearchChange();
    },
    emitirPeriodo() {
      this.$emit("periodo-selecionado", {
        inicio: this.inicioPeriodo,
        encerramento: this.encerramentoPeriodo,
      });
    },

    handleDataChange(value) {
      this.data = value;
      this.savePersistedDateFilter(value);
      // this.handleSearchChange();
    },

    getContasFinanceiras() {
      const requestTenantId = this.getCurrentTenantId();
      ComumDataService.get("/contaFinanceiras/conta").then((res) => {
        if (!this.isCurrentTenantRequest(requestTenantId)) return;
        this.contasFinanceiras = res.data;
      });
    },

    getContasVinculada() {
      const requestTenantId = this.getCurrentTenantId();
      ComumDataService.get("/contaBancarias/coorporate/kind/1").then((res) => {
        if (!this.isCurrentTenantRequest(requestTenantId)) return;
        this.contasVinculada = res.data;
      });
    },

    getFornecedores() {
      const requestTenantId = this.getCurrentTenantId();
      ComumDataService.get("/fornecedores").then((res) => {
        if (!this.isCurrentTenantRequest(requestTenantId)) return;
        this.fornecedores = res.data;
      });
    },

    getClientes() {
      const requestTenantId = this.getCurrentTenantId();
      ComumDataService.get("/clientes").then((res) => {
        if (!this.isCurrentTenantRequest(requestTenantId)) return;
        this.clientes = res.data;
      });
    },

    getFuncionarios() {
      const requestTenantId = this.getCurrentTenantId();
      ComumDataService.get("/funcionarios").then((res) => {
        if (!this.isCurrentTenantRequest(requestTenantId)) return;
        this.funcionarios = res.data;
      });
    },

    getPessoas() {
      const requestTenantId = this.getCurrentTenantId();
      ComumDataService.get("/pessoas").then((res) => {
        if (!this.isCurrentTenantRequest(requestTenantId)) return;
        this.pessoas = res.data;
      });
    },

    getBeneficioConvenios() {
      const requestTenantId = this.getCurrentTenantId();
      ComumDataService.get("/beneficioConvenio").then((res) => {
        if (!this.isCurrentTenantRequest(requestTenantId)) return;
        this.beneficioConvenios = res.data;
      });
    },

    getMoedas() {
      const requestTenantId = this.getCurrentTenantId();
      ComumDataService.get("operacaoMoeda/active").then((res) => {
        if (!this.isCurrentTenantRequest(requestTenantId)) return;
        this.moedas = res.data;
      });
    },

    getPostoTrabalhos() {
      const requestTenantId = this.getCurrentTenantId();
      ComumDataService.get("/postosTrabalho").then((res) => {
        if (!this.isCurrentTenantRequest(requestTenantId)) return;
        this.postoTrabalhos = res.data;
      });
    },

    getCargos() {
      const requestTenantId = this.getCurrentTenantId();
      ComumDataService.get("/funcionarioCargos").then((res) => {
        if (!this.isCurrentTenantRequest(requestTenantId)) return;
        this.cargos = res.data;
      });
    },

    readFile() {
      return new Promise((resolve, reject) => {
        this.file = this.$refs.doc.files[0];
        const reader = new FileReader();
        if (
          this.file.name.includes(".csv") ||
          this.file.name.includes(".txt")
        ) {
          reader.onload = (res) => {
            this.modalSelecionaArquivo = false;
            resolve(res.target.result);
          };
          reader.onerror = (err) => console.log(err);
          reader.readAsText(this.file);
        } else {
          reader.onerror = reject;
          reader.onload = (res) => {
            this.modalSelecionaArquivo = false;
            resolve(res.target.result);
          };
          reader.onerror = (err) => console.log(err);
          reader.readAsText(this.file);
        }
      });
    },

    openModalImportDexion() {
      this.contentFile = null;
      this.modalImportArquivo = true;
      this.tipoImportacaoExterna = "Dexion";
    },

    openModalImportContaContabil() {
      this.contentFile = null;
      this.modalImportArquivo = true;
      this.tipoImportacaoExterna = "ContaContabil";
    },

    async importExternal() {
      if (!this.$refs.doc?.files?.length) {
        this.$swal.fire(this.$t("Erro"), this.$t("Selecione_arquivo"), "error");
        return;
      }
      this.loading = true;
      this.contentFile = await this.readFile();
      console.log("this.file", this.file);

      //Importação de contas contábeis (CSV)
      if (
        this.tipoImportacaoExterna === "ContaContabil" &&
        this.file.name.includes(".csv")
      ) {
        //Lendo arquivo
        console.log("this.contentFile", this.contentFile);
        //Split
        const lines = this.contentFile
          .replace(/^\uFEFF/, "")
          .split(/\r\n|\n|\r/)
          .filter((line) => line.trim().length > 0);

        //Convertendo para objeto Json
        var jsonObj = [];
        var headers = lines[0].split(";").map((header) => header.trim());
        for (var i = 1; i < lines.length; i++) {
          var data = lines[i].split(";");
          var obj = {};
          for (var j = 0; j < headers.length; j++) {
            var valor = data[j] || "";
            //Tratamentos especificos para formatações

            //Inclui no objeto apenas quando existir valor
            if (headers[j] && valor.trim().length > 0) {
              //Data
              if (
                valor.trim().indexOf("/") === 2 &&
                valor.trim().length === 10
              ) {
                obj[headers[j]] = this.formatedDate(valor.trim());
              } else if (headers[j].indexOf("valor") !== -1) {
                obj[headers[j]] = valor
                  .trim()
                  .replace(".", "")
                  .replace(",", ".");
              } else {
                obj[headers[j]] = valor.trim();
              }
            }
          }
          if (Object.keys(obj).length > 0) {
            jsonObj.push(obj);
          }
        }

        // const output = lines.slice(1).map((line) => {
        //   const fields = line.split(";");
        //   return Object.fromEntries(header.map((h, i) => [h, fields[i]]));
        // });
        console.log("jsonObj", jsonObj);

        this.$parent.DataService.importContaContabil(jsonObj)
          .then(() => {
            this.retrieveData();
            jsonObj = [];
            this.loading = false;
            this.modalImportArquivo = false;
            this.$swal.fire(
              this.$t("Sucesso"),
              this.$t("Importacao_realizada_sucesso"),
              "success",
            );
          })
          .catch((error) => {
            //Tratando objeto de retorno
            jsonObj = [];
            this.loading = false;
            console.log("error", error.response.data.errors);
            var linesErr = error.response.data.errors[0].message.split(",");
            var objTratErr = {};
            var listTratErr = [];
            var lineNumber = 0;
            for (var x = 0; x < linesErr.length; x++) {
              objTratErr = {};
              objTratErr.message = linesErr[x]
                .substring(linesErr[x].indexOf(":") + 2)
                .trim();
              lineNumber =
                parseInt(
                  linesErr[x].substring(
                    linesErr[x].indexOf("[") + 1,
                    linesErr[x].indexOf("]"),
                  ),
                ) + 2;
              objTratErr.fieldName =
                "Linha: " +
                lineNumber.toString() +
                " - " +
                linesErr[x].substring(
                  linesErr[x].indexOf("]") + 2,
                  linesErr[x].indexOf(":"),
                );
              objTratErr.line = lineNumber;
              listTratErr.push(objTratErr);
              //console.log("objTratErr", objTratErr);
            }
            listTratErr = listTratErr.sort(this.compareArrayError);

            this.modalImportArquivo = false;
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            //console.log("error.response", error.response);
            this.errors = listTratErr;
          });
      } else if (
        this.tipoImportacaoExterna === "Dexion" &&
        this.file.name.includes(".txt")
      ) {
        const objetos = [];
        let objetoAtual = {};
        console.log("Import Dexion - init");

        // Divide o documento em linhas e remove as linhas em branco
        const linhas = this.contentFile
          .split("\n")
          .filter((linha) => linha.trim() !== "");

        // Itera pelas linhas do documento
        for (const linha of linhas) {
          const campos = linha.split("|");

          // Preenche o objeto com os campos
          objetoAtual = {
            tipo: campos[1],
            matricula: campos[2],
            nome: campos[3],
            cpf: campos[4],
            nis: campos[5],
            sexo: campos[6],
            nascimento: campos[7],
            nomeMae: campos[8],
            nomePai: campos[9],
            email: campos[10],
            enderecoLogradouro: campos[11],
            enderecoComplemento: campos[12],
            enderecoNumero: campos[13],
            enderecoCep: campos[14],
            enderecoBairro: campos[15],
            enderecoCidade: campos[16],
            enderecoUf: campos[17],
            admissao: campos[18],
            experienciaTermino: campos[19],
            experienciaProrrogacao: campos[20],
            demissao: campos[21],
            afastamentoSequencial: campos[22],
            afastamentoInicio: campos[23],
            afastamentoFim: campos[24],
            afastamentoMotivo: campos[25],
            afastamentoCid: campos[26],
          };

          objetos.push(objetoAtual);
        }

        console.log("objetos", objetos);

        this.$parent.DataService.importDexion(objetos)
          .then(() => {
            this.retrieveData();
            this.loading = false;
            this.modalImportArquivo = false;
            this.$swal.fire(
              this.$t("Sucesso"),
              this.$t("Importacao_realizada_sucesso"),
              "success",
            );
          })
          .catch((error) => {
            this.loading = false;
            this.modalImportArquivo = false;
            console.log("error", error);
            this.$swal.fire(
              this.$t("Erro"),
              this.$t("Arquivo_invalido"),
              "error",
            );
          });
        console.log("Import Dexion - end");
      } else {
        this.loading = false;
        this.modalImportArquivo = false;
        this.$swal.fire(this.$t("Erro"), this.$t("Arquivo_invalido"), "error");
      }
    },

    formatedDate: function (dataValue) {
      var data = dataValue?.toString() || "";
      if (data.toString().length == 10) {
        var dia = data.split("/")[0];
        var mes = data.split("/")[1];
        var ano = data.split("/")[2];

        let string = ano + "-" + mes + "-" + dia;
        return string;
      } else {
        return data;
      }
    },

    compareArrayError: function (a, b) {
      if (a.line < b.line) return -1;
      if (a.line > b.line) return 1;
      return 0;
    },

    printXml(item) {
      window.open(item.xml);
    },

    async integrar(objeto) {
      this.loading = true;
      this.confirmarEnvio = false;
      try {
        await ComumDataService.put(
          "/faturamentoDocumentoFiscais/integration/" + objeto.id,
        );

        let documentoAtualizado = null;
        try {
          const response = await ComumDataService.get(
            "/faturamentoDocumentoFiscais/" + objeto.id,
          );
          documentoAtualizado = response?.data;
        } catch {
          // A consulta complementar não deve transformar um envio aceito em falha.
        }

        this.retrieveData();

        if (integracaoFiscalRejeitada(documentoAtualizado)) {
          this.$swal.fire(
            this.$t("Erro"),
            mensagemErroIntegracaoFiscal(
              documentoAtualizado,
              this.$t("Falha_ao_enviar_documento"),
            ),
            "error",
          );
          return;
        }

        this.$swal.fire(
          this.$t("Sucesso"),
          this.$t("Documento_enviado_realize_consulte_a_seguir"),
          "success",
        );
      } catch (error) {
        this.$swal.fire(
          this.$t("Erro"),
          mensagemErroIntegracaoFiscal(
            error,
            this.$t("Falha_ao_enviar_documento"),
          ),
          "error",
        );
      } finally {
        this.loading = false;
      }
    },

    consultar(item) {
      const acompanhandoCancelamento =
        item?.statusDocumento === "AUTORIZADO" &&
        item?.integradorEmissao === "PROPRIO" &&
        item?.faturamentoPracaFiscal?.tipoDocumentoFiscal === "NFSE";
      this.loading = true;
      ComumDataService.put("/faturamentoDocumentoFiscais/consult/" + item.id)
        .then((res) => {
          this.retrieveData();
          this.loading = false;
          console.log("Consulta documento", res.data);
          if (res.data.statusDocumento === "NAOAUTORIZADO") {
            const movimentacoes = res.data.movimentacoes;
            const ultimoDetalhe =
              movimentacoes[movimentacoes.length - 1].detalhes;
            console.log("Consulta documento", ultimoDetalhe);
            this.$swal.fire(
              this.$t(res.data.statusDocumento),
              this.$t(ultimoDetalhe),
              "error",
            );
          } else if (res.data.statusDocumento === "CANCELADO") {
            this.$swal.fire(
              this.$t("CANCELADO"),
              this.$t("Cancelamento_confirmado_na_consulta"),
              "success",
            );
          } else if (
            acompanhandoCancelamento &&
            res.data.statusDocumento === "AUTORIZADO"
          ) {
            this.$swal.fire(
              this.$t("Atencao"),
              this.$t("Cancelamento_ainda_nao_confirmado"),
              "warning",
            );
          } else {
            this.$swal.fire(
              this.$t(res.data.statusDocumento),
              this.$t("Documento_consultado_com_sucesso"),
              "success",
            );
          }
        })
        .catch(() => {
          this.loading = false;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Falha_ao_consultar_documento_tente_novamente"),
            "error",
          );
        });
    },

    async printDoc(item) {
      this.loading = true;
      try {
        const tipoDocumento = item.faturamentoPracaFiscal.tipoDocumentoFiscal;
        if (tipoDocumento === "RECIBO") {
          const res = await ComumDataService.get(
            "faturamentoDocumentoFiscais/recibo/" + item.id,
            { responseType: "blob" },
          );
          this.retrieveData();
          this.download(res.data, "document.pdf", "application/pdf");
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success",
          );
        } else if (
          tipoDocumento === "NFSE" &&
          item.integradorEmissao === "PROPRIO"
        ) {
          const res = await ComumDataService.get(
            "faturamentoDocumentoFiscais/print/" +
              item.numeroDocumento +
              "/" +
              item.faturamentoPracaFiscal.serie,
            { responseType: "blob" },
          );
          this.retrieveData();
          this.download(res.data, "document.pdf", "application/pdf");
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Documento_gerado_com_sucesso"),
            "success",
          );
        } else {
          let url = item.danfe;
          if (!url && tipoDocumento === "NFSE" && item.id) {
            const res = await ComumDataService.put(
              "/faturamentoDocumentoFiscais/consult/" + item.id,
            );
            url = res.data && res.data.danfe;
            item.danfe = url;
            this.retrieveData();
          }
          if (!url) {
            throw new Error("Documento sem link de impressão.");
          }
          window.open(url, "_blank");
        }
      } catch (error) {
        const data = error && error.response ? error.response.data : null;
        this.$swal.fire(
          this.$t("Erro"),
          (data && (data.message || data.error)) ||
            error.message ||
            this.$t("Falha_ao_exportar"),
          "error",
        );
      } finally {
        this.loading = false;
      }
    },

    showPedidosPendentes() {
      this.loading = true;
      this.keyModal += 1;
      ComumDataService.get("/pedidosTransporte/pending/" + this.data)
        .then((res) => {
          this.pedidosPendentes = (res.data || []).map((item) =>
            this.prepararPedidoPendente(item),
          );

          this.modalPedidosPendentes = true;
          this.loading = false;
        })
        .catch(() => {
          this.pedidosPendentes = [];
          this.loading = false;
        });
    },

    showTarefaSolicitacaoPendentes() {
      this.loading = true;
      this.keyModal += 1;
      ComumDataService.get("/tarefaSolicitacoes/pending/" + this.data)
        .then((res) => {
          this.pedidosPendentes = (res.data || []).map((item) =>
            this.prepararTarefaSolicitacaoPendente(item),
          );

          this.modalSolicitacoesTarefaPendente = true;
          this.loading = false;
        })
        .catch(() => {
          this.pedidosPendentes = [];
          this.loading = false;
        });
    },

    prepararPedidoPendente(item) {
      return {
        ...item,
        origemCidadeUf: this.formatCidadeUf(item?.origem?.cidade),
        destinoCidadeUf: this.formatCidadeUf(item?.destino?.cidade),
      };
    },

    prepararTarefaSolicitacaoPendente(item) {
      return {
        ...item,
        localCidadeUf: this.formatCidadeUf(item?.local?.cidade),
      };
    },

    formatCidadeUf(cidade) {
      const estado = (cidade && cidade.estado) || {};
      return [cidade && cidade.nome, estado.sigla].filter(Boolean).join("/");
    },

    showModalRoteirizarPedido(item) {
      this.loading = true;
      this.keyModal += 1;
      this.pedidoAtual = item;
      console.log("this.pedidoAtual", this.pedidoAtual);
      ComumDataService.get("/roteiros/date/" + this.data)
        .then((res) => {
          this.roteirosDisponiveis = res.data;
          console.log("this.roteirosDisponiveis", this.roteirosDisponiveis);
          this.modalRoteirizarPedido = true;
          this.loading = false;
        })
        .catch(() => {
          this.roteirosDisponiveis = [];
          this.loading = false;
        });
    },
    roteirizarPedido() {
      this.loading = true;
      ComumDataService.post("/roteiroTrajetos", {
        roteiroId: this.novoTrajeto.roteiro.id,
        pedidoId: this.pedidoAtual.id,
        previsaoAtendimentoOrigem: this.novoTrajeto.previsaoAtendimentoOrigem,
        previsaoAtendimentoDestino: this.novoTrajeto.previsaoAtendimentoDestino,
      })
        .then(() => {
          this.loading = false;
          this.modalPedidosPendentes = false;
          this.modalRoteirizarPedido = false;
          this.handleSearchChange();
        })
        .catch(() => {
          this.loading = false;
          this.modalPedidosPendentes = false;
        });
    },

    showModalRoteirizarTarefaSolicitacao(item) {
      this.loading = true;
      this.keyModal += 1;
      this.pedidoAtual = item;
      console.log("this.pedidoAtual", this.pedidoAtual);
      ComumDataService.get("/tarefasExecucao/date/" + this.data)
        .then((res) => {
          this.roteirosDisponiveis = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.roteirosDisponiveis = [];
          this.loading = false;
        });

      // if (this.imobilizadosDisponiveis.length === 0) {
      //   this.loading = true;
      //   ComumDataService.get("/imobilizados")
      //     .then((res) => {
      //       this.imobilizadosDisponiveis = res.data;
      //       this.loading = false;
      //     })
      //     .catch((err) => {
      //       this.roteirosDisponiveis = [];
      //       this.loading = false;
      //     });

      //   console.log("this.imobilizadosDisponiveis", this.imobilizadosDisponiveis);
      // }

      this.modalRoteirizarTarefaSolicitacao = true;
      this.loading = false;
    },

    roteirizarTarefaSolicitacao() {
      this.loading = true;
      // Monta o payload incluindo os imobilizados selecionados
      const payload = {
        roteiroId: this.novoTrajeto.roteiro.id,
        pedidoId: this.pedidoAtual.id,
        previsaoAtendimento: this.novoTrajeto.previsaoAtendimento,
        imobilizados: this.selectedImobilizados, // ou utilize um map para enviar apenas os IDs, ex: this.selectedImobilizados.map(imob => imob.id)
      };

      ComumDataService.post("/tarefasExecucaoItem", payload)
        .then(() => {
          this.loading = false;
          this.modalSolicitacoesTarefaPendente = false;
          this.modalRoteirizarTarefaSolicitacao = false;
          this.handleSearchChange();
        })
        .catch(() => {
          this.loading = false;
          this.modalSolicitacoesTarefaPendente = false;
        });
    },

    addImobilizado() {
      // Verifica se há um imobilizado selecionado e se ele não está duplicado
      if (
        this.selectedImobilizado &&
        !this.selectedImobilizados.some(
          (imob) => imob.id === this.selectedImobilizado.id,
        )
      ) {
        this.selectedImobilizados.push(this.selectedImobilizado);
        this.selectedImobilizado = null; // Limpa o campo após adicionar
      }
    },
    removeImobilizado(index) {
      this.selectedImobilizados.splice(index, 1);
    },

    confirmaGerarRoteirosModelo() {
      this.loading = true;
      this.roteiroModelo = { id: 0 };
      ComumDataService.get("/roteiroModelos", {})
        .then((res) => {
          this.loading = false;
          this.roteiroModelo = { id: 0 };
          this.roteiroModelos = res.data;
          this.modalGerarRoteiroModelo = true;
        })
        .catch(() => {
          this.roteiroModelo = { id: 0 };
          this.loading = false;
          this.modalGerarRoteiroModelo = false;
        });
    },

    gerarRoteirosModelo() {
      console.log("this.roteiroModelo.id", this.roteiroModelo.id);
      console.log("this.data", this.data);

      this.loading = true;

      // Guarde os valores atuais antes de definir this.roteiroModelo como null
      const roteiroModeloId = this.roteiroModelo ? this.roteiroModelo.id : null;
      const dataRoteiro = this.data;

      // Verifique se roteiroModeloId não é nulo antes de continuar
      if (roteiroModeloId === null) {
        console.error("Erro: roteiroModeloId é nulo");
        this.loading = false;
        return;
      }

      // Defina this.roteiroModelo como null após guardar seus valores
      this.roteiroModelo = null;

      ComumDataService.put("/roteiroModelos/route", {
        roteiroModeloId: roteiroModeloId,
        dataRoteiro: dataRoteiro,
      })
        .then(() => {
          this.loading = false;
          this.modalGerarRoteiroModelo = false;
          this.handleSearchChange();
        })
        .catch((error) => {
          this.errors = error.response.data.errors;

          this.loading = false;
          this.modalGerarRoteiroModelo = false;
        });
    },

    parametrizacaoInquilinoAtiva(tipo) {
      const parametrizacoes =
        this.$store?.state?.inquilino?.parametrizacoes || [];
      const parametrizacaoExistente = parametrizacoes.find(
        (item) => item && item.tipo === tipo,
      );

      return (
        !!parametrizacaoExistente && parametrizacaoExistente.ativo !== false
      );
    },

    exigeValidacao02FuncionarioAfastamentoSolicitacao() {
      return (
        this.nomeSingular === "FuncionarioAfastamentoSolicitacao" &&
        this.parametrizacaoInquilinoAtiva("AFASTAMENTOSOLICITACAO02VALIDACOES")
      );
    },

    exigeValidacao01FuncionarioAfastamentoSolicitacao() {
      return (
        this.nomeSingular === "FuncionarioAfastamentoSolicitacao" &&
        (this.parametrizacaoInquilinoAtiva(
          "AFASTAMENTOSOLICITACAO01VALIDACAO",
        ) ||
          this.exigeValidacao02FuncionarioAfastamentoSolicitacao())
      );
    },

    podeValidarFuncionarioAfastamentoSolicitacao01(item) {
      return (
        this.exigeValidacao01FuncionarioAfastamentoSolicitacao() &&
        this.possuiPermissaoValidacaoFuncionarioAfastamento("Validar01") &&
        item.status === "PENDENTE" &&
        !item.responsavelValidacao01
      );
    },

    podeValidarFuncionarioAfastamentoSolicitacao02(item) {
      return (
        this.exigeValidacao02FuncionarioAfastamentoSolicitacao() &&
        this.possuiPermissaoValidacaoFuncionarioAfastamento("Validar02") &&
        item.status === "PENDENTE" &&
        !!item.responsavelValidacao01 &&
        !item.responsavelValidacao02
      );
    },

    etapaValidacaoAfastamento(item) {
      if (this.podeValidarFuncionarioAfastamentoSolicitacao01(item)) return 1;
      if (this.podeValidarFuncionarioAfastamentoSolicitacao02(item)) return 2;
      return 0;
    },

    possuiPermissaoValidacaoFuncionarioAfastamento(etapa) {
      const permissoes = this.$store?.state?.permissoes;
      return (
        Array.isArray(permissoes) &&
        permissoes.includes(`ROLE_FuncionarioAfastamentoSolicitacao_${etapa}`)
      );
    },

    exigeValidacao02FuncionarioPontoSolicitacao() {
      return (
        this.nomeSingular === "FuncionarioPontoSolicitacao" &&
        this.parametrizacaoInquilinoAtiva("PONTOSOLICITACAO02VALIDACOES")
      );
    },

    etapaPendenteSolicitacao(item) {
      if (this.nomeSingular === "FuncionarioPontoSolicitacao") {
        if (!this.exigeValidacao02FuncionarioPontoSolicitacao())
          return "Aguardando_aprovacao";
        if (!item.responsavelValidacao01)
          return "Aguardando_primeira_validacao";
        return "Aguardando_segunda_validacao";
      }
      if (!this.exigeValidacao01FuncionarioAfastamentoSolicitacao())
        return "Aguardando_aprovacao";
      if (!item.responsavelValidacao01) return "Aguardando_primeira_validacao";
      if (!this.exigeValidacao02FuncionarioAfastamentoSolicitacao())
        return "Aguardando_aprovacao";
      if (item.responsavelValidacao02) return "Aguardando_aprovacao";
      return "Aguardando_segunda_validacao";
    },

    podeAprovarFuncionarioAfastamentoSolicitacao(item) {
      if (
        this.nomeSingular !== "FuncionarioAfastamentoSolicitacao" ||
        item.status !== "PENDENTE"
      ) {
        return false;
      }

      if (this.exigeValidacao02FuncionarioAfastamentoSolicitacao()) {
        return !!item.responsavelValidacao01 && !!item.responsavelValidacao02;
      }

      if (this.exigeValidacao01FuncionarioAfastamentoSolicitacao()) {
        return !!item.responsavelValidacao01;
      }

      return true;
    },

    aprovacaoFuncionarioAfastamentoSolicitacaoBloqueada(item) {
      return (
        this.nomeSingular === "FuncionarioAfastamentoSolicitacao" &&
        item.status === "PENDENTE" &&
        this.exigeValidacao01FuncionarioAfastamentoSolicitacao() &&
        !this.podeAprovarFuncionarioAfastamentoSolicitacao(item)
      );
    },

    removerFluxoEntregaSolicitacaoUniforme() {
      try {
        const parametrizacoes =
          this.$store?.state?.inquilino?.parametrizacoes || [];
        const parametrizacaoExistente = parametrizacoes.find(
          (item) =>
            item && item.tipo === "SOLICITACAOUNIFORMEREMOVERFLUXOENTREGA",
        );

        if (!parametrizacaoExistente) return false;

        // Se o campo 'ativo' vier como false, não exibe. Caso contrário, exibe.
        return parametrizacaoExistente.ativo !== false;
      } catch (err) {
        console.warn(
          "Falha ao verificar parametrização APROVACAOHORASCALCULOPONTO",
          err,
        );
        return false;
      }
    },
  },
};
</script>

<style>
.crud-consulta-paginada__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 16px;
  color: #64748b;
  font-size: 13px;
}

.listagem-base {
  position: relative;
}

.listagem-base--incorporada .crud-listagem-container {
  min-height: auto;
  padding: 12px !important;
}

.listagem-base--incorporada .crud-listagem-layout {
  margin-top: 0 !important;
}

.listagem-base--incorporada .crud-listagem-card {
  box-shadow: none !important;
  margin: 0;
}

.listagem-base .loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(243, 244, 246, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  backdrop-filter: blur(1px);
}

.listagem-base.crud-dialog-active > .loading-overlay {
  display: none;
  pointer-events: none;
}

.crud-listagem-table:focus {
  outline: 2px solid rgba(94, 114, 228, 0.3);
  outline-offset: -2px;
}

#app .crud-listagem-table tbody tr.crud-listagem-table__row--keyboard-active {
  background: #f0f3ff !important;
  box-shadow: inset 3px 0 0 #5e72e4;
  outline: none;
}

#app
  .crud-listagem-table
  tbody
  tr.crud-listagem-table__row--keyboard-active:hover {
  background: #e9edff !important;
}

.crud-modal-loading-card {
  align-items: center;
  background: transparent;
  box-shadow: none;
  display: flex;
  justify-content: center;
  min-height: min(70vh, 640px);
  padding: 24px;
}

.crud-modal-loading-panel {
  align-items: center;
  background: #ffffff;
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 8px;
  box-shadow: 0 22px 55px rgba(15, 23, 42, 0.22);
  display: flex;
  gap: 18px;
  min-width: min(440px, calc(100vw - 32px));
  overflow: hidden;
  padding: 20px 22px;
  position: relative;
}

.crud-modal-loading-accent {
  background: #525863 !important;
  background-image: none !important;
  height: 3px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.crud-modal-loading-visual {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  display: flex;
  flex: 0 0 62px;
  height: 62px;
  justify-content: center;
  position: relative;
  width: 62px;
}

.crud-modal-loading-ring {
  animation: crud-modal-ring-spin 0.9s linear infinite;
  background: transparent !important;
  background-image: none !important;
  border: 4px solid rgba(82, 88, 99, 0.18);
  border-radius: 50%;
  border-top-color: #525863;
  height: 38px;
  position: absolute;
  width: 38px;
}

.crud-modal-loading-ring::after {
  content: none;
}

.crud-modal-loading-core {
  animation: crud-modal-core-pulse 1.2s ease-in-out infinite;
  background: #525863 !important;
  background-image: none !important;
  border-radius: 50%;
  box-shadow: 0 0 0 6px rgba(82, 88, 99, 0.14);
  height: 8px;
  position: relative;
  width: 8px;
  z-index: 1;
}

.crud-modal-loading-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.crud-modal-loading-title {
  color: #111827;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.2;
}

.crud-modal-loading-track {
  background: #e5e7eb;
  border-radius: 999px;
  height: 4px;
  overflow: hidden;
  position: relative;
}

.crud-modal-loading-track span {
  animation: crud-modal-track-slide 1.15s ease-in-out infinite;
  background: #525863 !important;
  background-image: none !important;
  border-radius: inherit;
  display: block;
  height: 100%;
  position: absolute;
  width: 42%;
}

.crud-modal-loading-lines {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.crud-modal-loading-lines span {
  animation: crud-modal-line-breathe 1.4s ease-in-out infinite;
  background: #525863 !important;
  background-image: none !important;
  border-radius: 999px;
  display: block;
  height: 7px;
  opacity: 0.16;
}

.crud-modal-loading-lines span:first-child {
  width: 78%;
}

.crud-modal-loading-lines span:last-child {
  animation-delay: 0.14s;
  width: 54%;
}

@keyframes crud-modal-ring-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes crud-modal-core-pulse {
  0%,
  100% {
    opacity: 0.72;
    transform: scale(0.82);
  }

  50% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes crud-modal-track-slide {
  0% {
    left: -42%;
  }

  100% {
    left: 100%;
  }
}

@keyframes crud-modal-line-breathe {
  0%,
  100% {
    opacity: 0.1;
  }

  50% {
    opacity: 0.22;
  }
}

.inline-edit-cell {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 32px;
}

.inline-edit-cell .v-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.inline-edit-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.billing-error-cell {
  align-items: center;
  color: #b42318;
  display: inline-flex;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
}

.inline-edit-input {
  max-width: 260px;
}

.inline-edit-input-description {
  min-width: 420px;
  max-width: 720px;
}

.inline-edit-input-date {
  max-width: 170px;
}

.inline-edit-input-competencia {
  max-width: 130px;
}

.pagination-footer-row {
  row-gap: 8px;
}

.pagination-toolbar {
  gap: 8px;
}

.pagination-page-size {
  max-width: 96px;
}

.pagination-wrapper {
  min-width: 280px;
}

.simple-search-status {
  color: #64748b;
  display: flex;
  flex-direction: column;
  font-size: 0.75rem;
  gap: 4px;
  margin-top: 6px;
}

.simple-search-status span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ordenacao-menu {
  width: min(420px, calc(100vw - 32px));
}

.inline-edit-trigger {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.inline-edit-cell:hover .inline-edit-trigger {
  opacity: 1;
}

@media (hover: none) {
  .inline-edit-trigger {
    opacity: 1;
  }
}

@media (max-width: 960px) {
  .inline-edit-input-description {
    min-width: 240px;
    max-width: 100%;
  }
}

@media (max-width: 599px) {
  .inline-edit-cell,
  .inline-edit-input,
  .inline-edit-input-description,
  .inline-edit-input-date,
  .inline-edit-input-competencia {
    max-width: 100%;
    min-width: 0;
    width: 100%;
  }

  .billing-error-cell {
    max-width: 100%;
    overflow-wrap: anywhere;
    white-space: normal;
  }

  .card-saldo {
    flex: 1 1 100%;
    min-width: 0;
    padding: 8px 12px;
  }
}

.doubt-btn {
  position: fixed;
  right: 10px;
  bottom: 10px;
}

#app .CANCELADO {
  color: red;
}

.PENDENTE {
  color: #67748e;
}

#app .VENCIDO {
  color: red;
}

#app .INATIVO {
  color: red;
}

#app .ATIVO {
  color: #67748e !important;
}

#app .QUITADO {
  color: #67748e;
}

#app .SEPARACAO {
  color: #000080;
}

#app .ENTREGATOTAL {
  color: green;
}

#app .RETIRADO {
  color: green;
}

#app .DISPONIBILIZADO {
  color: #a0522d;
}

#app .ENTREGAPARCIAL {
  color: green;
}

#app .RECEBIDO {
  color: green;
}

#app .CONCLUIDO {
  color: rgb(9, 146, 9);
}

#app .ROTEIRIZADO {
  color: rgb(9, 146, 9);
}

#app .TRAJETOIMPARCONCLUIDO {
  color: rgb(9, 146, 9);
  /* Cor verde para status concluído */
  background-color: #f2f1f1a3;
  /* Cinza claro para roteiro ímpar */
}

#app .TRAJETOIMPAR {
  background-color: #f2f1f1a3;
  /* Cinza claro para roteiro ímpar */
}

#app .TRAJETOPARCONCLUIDO {
  color: rgb(9, 146, 9);
  /* Cor verde para status concluído */
  background-color: #8c9eba45;
}

#app .TRAJETOPAR {
  background-color: #8c9eba45;
}

.ENTREGAPENDENTE {
  color: #daa520;
}

#app .ANDAMENTO {
  color: #dd5e23;
}

#app .TRAJETOIMPARANDAMENTO {
  color: #dd5e23;
  background-color: #f2f1f1a3;
  /* Cinza claro para roteiro ímpar */
}

#app .TRAJETOPARANDAMENTO {
  color: #dd5e23;
  background-color: #8c9eba45;
}

#app .TRAJETOATRASADO {
  background-color: #f7981d33;
  border-left: 4px solid #f7981d;
}

#app .TRAJETOPAR {
  background-color: #8c9eba45;
}

.rounded-div {
  background-color: red;
  border-radius: 999px;
}

.card-saldo p {
  margin: 0 !important;
}

.card-saldo {
  display: grid;
  grid-template-columns: 1fr;
  background: #67748e;
  color: white;
  padding: 0.2em 2em;
  text-align: left;
  border-radius: 2px;
}
</style>
